export const agenciasBB = [
  { label: '1 - RIO', value: '1' },
  { label: '2 - MANAUS', value: '2' },
  { label: '3 - PRESIDENTE VARGAS', value: '3' },
  { label: '4 - SANTOS', value: '4' },
  { label: '5 - CAMPOS GOYTACAZES', value: '5' },
  { label: '6 - SALVADOR', value: '6' },
  { label: '7 - RECIFE', value: '7' },
  { label: '8 - SETOR PUBLICO CE', value: '8' },
  { label: '9 - PRACA TIRADENTES-PR', value: '9' },
  { label: '10 - EMPRESA PORTO ALEGRE', value: '10' },
  { label: '11 - EMPRESA JOAO PESSOA', value: '11' },
  { label: '12 - TRES CORACOES', value: '12' },
  { label: '13 - MACEIO', value: '13' },
  { label: '14 - CORUMBA', value: '14' },
  { label: '15 - UBERABA', value: '15' },
  { label: '16 - FLORIANOPOLIS', value: '16' },
  { label: '18 - SAO PAULO', value: '18' },
  { label: '19 - ILHEUS', value: '19' },
  { label: '20 - SAO LUIS', value: '20' },
  { label: '21 - EMPRESA VITORIA', value: '21' },
  { label: '22 - EMPRESA NATAL', value: '22' },
  { label: '23 - PARNAIBA', value: '23' },
  { label: '24 - EMPRESA JUIZ DE FORA', value: '24' },
  { label: '25 - CATAGUASES', value: '25' },
  { label: '26 - CARANGOLA', value: '26' },
  { label: '27 - JAU', value: '27' },
  { label: '28 - RIBEIRAO PRETO', value: '28' },
  { label: '29 - EMPRESA PELOTAS', value: '29' },
  { label: '30 - PONTA GROSSA', value: '30' },
  { label: '31 - BARRETOS', value: '31' },
  { label: '32 - VARGINHA', value: '32' },
  { label: '33 - BELO HORIZONTE', value: '33' },
  { label: '34 - BAGE', value: '34' },
  { label: '35 - SANTANA LIVRAMENTO', value: '35' },
  { label: '36 - MOSSORO', value: '36' },
  { label: '37 - EMPRESA BAURU', value: '37' },
  { label: '38 - JOINVILLE', value: '38' },
  { label: '39 - CAMOCIM', value: '39' },
  { label: '40 - SAO FELIX', value: '40' },
  { label: '41 - FEIRA DE SANTANA', value: '41' },
  { label: '42 - CACHOEIRA DO SUL', value: '42' },
  { label: '43 - IPAMERI', value: '43' },
  { label: '44 - TERESINA', value: '44' },
  { label: '45 - URUGUAIANA', value: '45' },
  { label: '46 - EMPRESA CUIABA', value: '46' },
  { label: '47 - ABATIA', value: '47' },
  { label: '48 - AFONSO PENA', value: '48' },
  { label: '49 - PENEDO', value: '49' },
  { label: '50 - CATANDUVA', value: '50' },
  { label: '51 - MACAE', value: '51' },
  { label: '52 - EMPRESA CAMPINAS', value: '52' },
  { label: '53 - FRANCA', value: '53' },
  { label: '54 - BEBEDOURO', value: '54' },
  { label: '56 - PIRACICABA', value: '56' },
  { label: '57 - SAO JOSE RIO PRETO', value: '57' },
  { label: '58 - LINS', value: '58' },
  { label: '59 - SANTO AMARO', value: '59' },
  { label: '60 - JEQUIE', value: '60' },
  { label: '61 - TEOFILO OTONI', value: '61' },
  { label: '62 - BARBACENA', value: '62' },
  { label: '63 - EMPRESA CAMP.GRANDE', value: '63' },
  { label: '64 - GUAXUPE', value: '64' },
  { label: '65 - SAO JOAO BOA VISTA', value: '65' },
  { label: '66 - SAO JOSE RIO PARDO', value: '66' },
  { label: '67 - GARANHUNS', value: '67' },
  { label: '68 - ARCOVERDE', value: '68' },
  { label: '69 - JUAZEIRO', value: '69' },
  { label: '70 - ITABUNA', value: '70' },
  { label: '71 - EMPRESA RIO BRANCO', value: '71' },
  { label: '72 - NITEROI', value: '72' },
  { label: '73 - BARRA DO PIRAI', value: '73' },
  { label: '74 - ITAPERUNA', value: '74' },
  { label: '76 - TAUBATE', value: '76' },
  { label: '77 - PIRAJU', value: '77' },
  { label: '78 - PONTA PORA', value: '78' },
  { label: '79 - BOTUCATU', value: '79' },
  { label: '80 - PETROPOLIS', value: '80' },
  { label: '81 - NOVA IGUACU', value: '81' },
  { label: '82 - ARARAQUARA', value: '82' },
  { label: '83 - CACHOEIRO ITAPEMIRIM', value: '83' },
  { label: '85 - SOBRAL', value: '85' },
  { label: '86 - SETOR PUBLICO GO', value: '86' },
  { label: '87 - CATETE', value: '87' },
  { label: '88 - PONTE NOVA', value: '88' },
  { label: '89 - CAXIAS DO SUL', value: '89' },
  { label: '90 - ARAGUARI', value: '90' },
  { label: '91 - MADUREIRA', value: '91' },
  { label: '92 - EMPRESA PASSO FUNDO', value: '92' },
  { label: '93 - BANDEIRA', value: '93' },
  { label: '94 - CRATO', value: '94' },
  { label: '95 - EMPRESA BLUMENAU', value: '95' },
  { label: '96 - FLORIANO', value: '96' },
  { label: '97 - PRESIDENTE PRUDENTE', value: '97' },
  { label: '98 - UBERLANDIA', value: '98' },
  { label: '99 - CAJAZEIRAS', value: '99' },
  { label: '100 - JACAREZINHO', value: '100' },
  { label: '101 - MEIER', value: '101' },
  { label: '102 - PORTO VELHO', value: '102' },
  { label: '103 - CURVELO', value: '103' },
  { label: '104 - MONTES CLAROS', value: '104' },
  { label: '105 - PARAGUACU PAULISTA', value: '105' },
  { label: '106 - CAMPO MAIOR', value: '106' },
  { label: '107 - CANTAGALO-RJ', value: '107' },
  { label: '108 - CALCADAO', value: '108' },
  { label: '109 - MUNDO NOVO-BA', value: '109' },
  { label: '110 - VICOSA', value: '110' },
  { label: '111 - MIRASSOL', value: '111' },
  { label: '112 - COLATINA', value: '112' },
  { label: '113 - SANTO ANASTACIO', value: '113' },
  { label: '114 - CAFELANDIA', value: '114' },
  { label: '115 - PALMARES', value: '115' },
  { label: '117 - PROPRIA', value: '117' },
  { label: '118 - ORLANDIA', value: '118' },
  { label: '119 - NOVO HORIZONTE', value: '119' },
  { label: '120 - UNIAO DOS PALMARES', value: '120' },
  { label: '121 - ARACATI', value: '121' },
  { label: '122 - IGUATU', value: '122' },
  { label: '123 - AQUIDAUANA', value: '123' },
  { label: '124 - CAXIAS', value: '124' },
  { label: '125 - PIRAPORA', value: '125' },
  { label: '126 - SANTA MARIA', value: '126' },
  { label: '127 - CAMPO GRANDE-RJ', value: '127' },
  { label: '128 - CAICO', value: '128' },
  { label: '129 - PIRIPIRI', value: '129' },
  { label: '130 - SANTAREM', value: '130' },
  { label: '131 - RESENDE', value: '131' },
  { label: '132 - ERECHIM', value: '132' },
  { label: '133 - TUPA', value: '133' },
  { label: '134 - MATAO', value: '134' },
  { label: '135 - JACOBINA', value: '135' },
  { label: '136 - PALMEIRA DOS INDIOS', value: '136' },
  { label: '137 - JOACABA', value: '137' },
  { label: '138 - SANTO ANGELO', value: '138' },
  { label: '139 - LAJEADO', value: '139' },
  { label: '140 - FOZ DO IGUACU', value: '140' },
  { label: '141 - MARILIA', value: '141' },
  { label: '143 - CANAVIEIRAS', value: '143' },
  { label: '144 - ALEGRETE', value: '144' },
  { label: '145 - MONTE APRAZIVEL', value: '145' },
  { label: '146 - NOVA GRANADA', value: '146' },
  { label: '147 - JAGUARAO', value: '147' },
  { label: '148 - PROMISSAO', value: '148' },
  { label: '149 - ESTANCIA', value: '149' },
  { label: '150 - CABO FRIO', value: '150' },
  { label: '151 - PATOS', value: '151' },
  { label: '152 - ARACUAI', value: '152' },
  { label: '153 - SAO GABRIEL', value: '153' },
  { label: '154 - RIBEIRAO BONITO', value: '154' },
  { label: '155 - BOM JESUS ITABAPOANA', value: '155' },
  { label: '156 - ITUVERAVA', value: '156' },
  { label: '158 - ALAGOINHAS', value: '158' },
  { label: '159 - CARUARU', value: '159' },
  { label: '160 - PIRAJUI', value: '160' },
  { label: '162 - SAO JOAO DEL REI', value: '162' },
  { label: '163 - PIRASSUNUNGA', value: '163' },
  { label: '164 - ITABAIANA-PB', value: '164' },
  { label: '165 - OLIMPIA', value: '165' },
  { label: '166 - GOVERNADOR VALADARES', value: '166' },
  { label: '167 - BRAGANCA PAULISTA', value: '167' },
  { label: '168 - ALFENAS', value: '168' },
  { label: '169 - QUARAI', value: '169' },
  { label: '170 - VACARIA', value: '170' },
  { label: '171 - ITAPIRA', value: '171' },
  { label: '172 - RIO CLARO', value: '172' },
  { label: '173 - BOA ESPERANCA', value: '173' },
  { label: '174 - BICAS', value: '174' },
  { label: '175 - SAO JOSE DOS CAMPOS', value: '175' },
  { label: '176 - CAMPO BELO-MG', value: '176' },
  { label: '177 - CARATINGA', value: '177' },
  { label: '178 - VALPARAISO', value: '178' },
  { label: '179 - ARACATUBA', value: '179' },
  { label: '180 - SANTA CRUZ DO SUL', value: '180' },
  { label: '181 - BENTO GONCALVES', value: '181' },
  { label: '182 - IRATI', value: '182' },
  { label: '183 - EMPRESA RIO CENTRO', value: '183' },
  { label: '184 - CACERES', value: '184' },
  { label: '185 - SAO LEOPOLDO', value: '185' },
  { label: '186 - MIMOSO DO SUL', value: '186' },
  { label: '187 - SAO BORJA', value: '187' },
  { label: '188 - VITORIA DA CONQUISTA', value: '188' },
  { label: '189 - PEDERNEIRAS', value: '189' },
  { label: '190 - PATOS DE MINAS', value: '190' },
  { label: '191 - EMPRESA SOROCABA', value: '191' },
  { label: '192 - CAMAQUA', value: '192' },
  { label: '193 - CRUZ ALTA', value: '193' },
  { label: '194 - PASSOS', value: '194' },
  { label: '195 - DOM PEDRITO', value: '195' },
  { label: '196 - AGRESTINA', value: '196' },
  { label: '197 - AGUA BRANCA-AL', value: '197' },
  { label: '198 - BARIRI', value: '198' },
  { label: '199 - ITAPETININGA', value: '199' },
  { label: '200 - GUARABIRA', value: '200' },
  { label: '201 - TUBARAO', value: '201' },
  { label: '202 - CARLOS CHAGAS', value: '202' },
  { label: '203 - AVARE', value: '203' },
  { label: '204 - ITUIUTABA', value: '204' },
  { label: '205 - OURO FINO', value: '205' },
  { label: '206 - MAFRA', value: '206' },
  { label: '207 - AGUA DOCE', value: '207' },
  { label: '208 - TRES LAGOAS', value: '208' },
  { label: '209 - SANTA TERESA', value: '209' },
  { label: '210 - ARAXA', value: '210' },
  { label: '211 - MARACAJU', value: '211' },
  { label: '212 - FORMIGA', value: '212' },
  { label: '213 - PEDRA AZUL', value: '213' },
  { label: '214 - ASSU', value: '214' },
  { label: '215 - AIMORES', value: '215' },
  { label: '216 - LIMEIRA', value: '216' },
  { label: '217 - UNIAO DA VITORIA', value: '217' },
  { label: '218 - SANTA CRUZ RIO PARDO', value: '218' },
  { label: '219 - BURITI ALEGRE', value: '219' },
  { label: '220 - GOIANA', value: '220' },
  { label: '221 - RIO VERDE', value: '221' },
  { label: '222 - SAO MATEUS', value: '222' },
  { label: '223 - ASSIS', value: '223' },
  { label: '224 - CORNELIO PROCOPIO', value: '224' },
  { label: '225 - SERRINHA', value: '225' },
  { label: '227 - BARRA', value: '227' },
  { label: '228 - SENHOR DO BONFIM', value: '228' },
  { label: '229 - MONTEIRO', value: '229' },
  { label: '230 - CAETITE', value: '230' },
  { label: '231 - BARREIRAS', value: '231' },
  { label: '232 - LIMOEIRO', value: '232' },
  { label: '233 - VITORIA SANTO ANTAO', value: '233' },
  { label: '234 - CRUZEIRO DO SUL-AC', value: '234' },
  { label: '235 - SANTA VITORIA PALMAR', value: '235' },
  { label: '237 - CRATEUS', value: '237' },
  { label: '238 - NAZARE', value: '238' },
  { label: '239 - SENADOR POMPEU', value: '239' },
  { label: '240 - AMARGOSA', value: '240' },
  { label: '241 - QUIXADA', value: '241' },
  { label: '242 - PEDREIRAS', value: '242' },
  { label: '243 - UNIAO', value: '243' },
  { label: '244 - AGUA PRETA', value: '244' },
  { label: '246 - SERRA TALHADA', value: '246' },
  { label: '247 - GUIRATINGA', value: '247' },
  { label: '248 - CODO', value: '248' },
  { label: '249 - RAMOS', value: '249' },
  { label: '250 - MONTE RORAIMA', value: '250' },
  { label: '251 - LENCOIS', value: '251' },
  { label: '252 - PIRACURUCA', value: '252' },
  { label: '253 - BRAGANCA', value: '253' },
  { label: '254 - PICOS', value: '254' },
  { label: '255 - LUZILANDIA', value: '255' },
  { label: '256 - OBIDOS', value: '256' },
  { label: '257 - TAQUARITINGA', value: '257' },
  { label: '258 - SAARA-RJ', value: '258' },
  { label: '259 - PARANAGUA', value: '259' },
  { label: '261 - MACAPA', value: '261' },
  { label: '262 - VOLTA REDONDA', value: '262' },
  { label: '263 - TAPES', value: '263' },
  { label: '264 - SANTO ANDRE', value: '264' },
  { label: '265 - SAO CRISTOVAO', value: '265' },
  { label: '266 - DORES DO INDAIA', value: '266' },
  { label: '267 - BELA VISTA-MS', value: '267' },
  { label: '268 - VOTUPORANGA', value: '268' },
  { label: '269 - JABOTICABAL', value: '269' },
  { label: '270 - UBA', value: '270' },
  { label: '271 - ITAQUI', value: '271' },
  { label: '272 - RANCHARIA', value: '272' },
  { label: '273 - ANDRADINA', value: '273' },
  { label: '274 - PATROCINIO', value: '274' },
  { label: '275 - AGUAI', value: '275' },
  { label: '276 - RIO DO SUL', value: '276' },
  { label: '277 - GOIAS', value: '277' },
  { label: '278 - ITABAIANA-SE', value: '278' },
  { label: '279 - LUCELIA', value: '279' },
  { label: '280 - CAPELA', value: '280' },
  { label: '281 - ALEGRE', value: '281' },
  { label: '282 - ITAMBE-BA', value: '282' },
  { label: '283 - JANUARIA', value: '283' },
  { label: '284 - ALMENARA', value: '284' },
  { label: '285 - ITABERABA', value: '285' },
  { label: '286 - MURIAE', value: '286' },
  { label: '287 - BOTAFOGO', value: '287' },
  { label: '288 - TIJUCA', value: '288' },
  { label: '289 - COPACABANA', value: '289' },
  { label: '290 - GARCA', value: '290' },
  { label: '291 - CAROLINA', value: '291' },
  { label: '292 - PARA DE MINAS', value: '292' },
  { label: '293 - AREIA', value: '293' },
  { label: '294 - MOGI DAS CRUZES', value: '294' },
  { label: '295 - SAO CARLOS', value: '295' },
  { label: '296 - BANGU', value: '296' },
  { label: '297 - NOSSA SENHORA LAPA', value: '297' },
  { label: '298 - PENHA FRANCA', value: '298' },
  { label: '299 - GUARAPUAVA', value: '299' },
  { label: '300 - EMPRESA PCA ARVORE', value: '300' },
  { label: '301 - IPIRANGA-SP', value: '301' },
  { label: '302 - SAO MANUEL', value: '302' },
  { label: '303 - EMPRESA BRAS', value: '303' },
  { label: '304 - RIO PARDO', value: '304' },
  { label: '305 - ITAJAI', value: '305' },
  { label: '306 - GUARATINGUETA', value: '306' },
  { label: '307 - LAGES', value: '307' },
  { label: '308 - ITAJUBA', value: '308' },
  { label: '309 - POCOS DE CALDAS', value: '309' },
  { label: '310 - MARTINOPOLIS', value: '310' },
  { label: '311 - CATALAO', value: '311' },
  { label: '312 - SANTO ANTONIO PADUA', value: '312' },
  { label: '313 - JATAI', value: '313' },
  { label: '314 - EMPRESA NOV.HAMBURGO', value: '314' },
  { label: '315 - TRES RIOS', value: '315' },
  { label: '316 - MANHUACU', value: '316' },
  { label: '317 - CAMBARA', value: '317' },
  { label: '318 - MONTENEGRO', value: '318' },
  { label: '319 - AMERICANA', value: '319' },
  { label: '320 - PRESIDENTE VENCESLAU', value: '320' },
  { label: '321 - CHAPECO', value: '321' },
  { label: '322 - SAO CAETANO DO SUL', value: '322' },
  { label: '323 - RUSSAS', value: '323' },
  { label: '324 - ANAPOLIS', value: '324' },
  { label: '325 - DANTAS BARRETO', value: '325' },
  { label: '326 - ITACOATIARA', value: '326' },
  { label: '327 - SAO LOURENCO DO SUL', value: '327' },
  { label: '328 - POMPEIA', value: '328' },
  { label: '329 - DUQUE DE CAXIAS', value: '329' },
  { label: '330 - ROSARIO DO SUL', value: '330' },
  { label: '331 - SANTANA DO IPANEMA', value: '331' },
  { label: '332 - IPU', value: '332' },
  { label: '333 - PARINTINS', value: '333' },
  { label: '334 - BATURITE', value: '334' },
  { label: '335 - NOVA FRIBURGO', value: '335' },
  { label: '336 - LAGARTO', value: '336' },
  { label: '337 - TUPANCIRETA', value: '337' },
  { label: '338 - ARROIO GRANDE', value: '338' },
  { label: '339 - SANTA ROSA', value: '339' },
  { label: '340 - JUNDIAI', value: '340' },
  { label: '341 - ARARAS', value: '341' },
  { label: '342 - GUAIBA', value: '342' },
  { label: '343 - CANOINHAS', value: '343' },
  { label: '344 - DIAMANTINA', value: '344' },
  { label: '345 - LAGUNA', value: '345' },
  { label: '346 - CIDADE ALTA', value: '346' },
  { label: '347 - PENAPOLIS', value: '347' },
  { label: '348 - BIRIGUI', value: '348' },
  { label: '349 - ROLANDIA', value: '349' },
  { label: '350 - MORRINHOS', value: '350' },
  { label: '351 - BATATAIS', value: '351' },
  { label: '352 - MARINGA', value: '352' },
  { label: '353 - SANTIAGO', value: '353' },
  { label: '354 - ITU', value: '354' },
  { label: '355 - APUCARANA', value: '355' },
  { label: '356 - ALEM PARAIBA', value: '356' },
  { label: '357 - IPIAU', value: '357' },
  { label: '358 - CARAZINHO', value: '358' },
  { label: '359 - ARAPONGAS', value: '359' },
  { label: '360 - MANDAGUARI', value: '360' },
  { label: '361 - CURRAIS NOVOS', value: '361' },
  { label: '362 - PALMEIRA DAS MISSOES', value: '362' },
  { label: '363 - LAGOA VERMELHA', value: '363' },
  { label: '364 - LAVRAS', value: '364' },
  { label: '365 - CORONEL FABRICIANO', value: '365' },
  { label: '366 - MONTE CARMELO', value: '366' },
  { label: '367 - FARRAPOS', value: '367' },
  { label: '368 - POUSO ALEGRE', value: '368' },
  { label: '369 - STO.ANTONIO PATRULHA', value: '369' },
  { label: '370 - GUACUI', value: '370' },
  { label: '371 - IJUI', value: '371' },
  { label: '372 - DIVINOPOLIS', value: '372' },
  { label: '373 - DRACENA', value: '373' },
  { label: '374 - ITAPIPOCA', value: '374' },
  { label: '375 - CACADOR', value: '375' },
  { label: '376 - ITUMBIARA', value: '376' },
  { label: '377 - FORMOSA', value: '377' },
  { label: '378 - RAUL SOARES', value: '378' },
  { label: '379 - OURINHOS', value: '379' },
  { label: '380 - PARACATU', value: '380' },
  { label: '381 - PARANAVAI', value: '381' },
  { label: '382 - AGUAS DE LINDOIA', value: '382' },
  { label: '383 - CAMPOS ELISEOS', value: '383' },
  { label: '384 - MOOCA', value: '384' },
  { label: '385 - PINHEIROS', value: '385' },
  { label: '386 - EMPRESA SANTANA', value: '386' },
  { label: '387 - SANTO AMARO PAULISTA', value: '387' },
  { label: '388 - ASSAI', value: '388' },
  { label: '389 - JEQUITINHONHA', value: '389' },
  { label: '390 - GUAJARA-MIRIM', value: '390' },
  { label: '391 - DOURADOS', value: '391' },
  { label: '392 - CINELANDIA', value: '392' },
  { label: '393 - BOCAIUVA', value: '393' },
  { label: '394 - SAO GONCALO', value: '394' },
  { label: '395 - SETE LAGOAS', value: '395' },
  { label: '396 - CAPELINHA', value: '396' },
  { label: '397 - GUANHAES', value: '397' },
  { label: '398 - TUPACIGUARA', value: '398' },
  { label: '399 - MACHADO', value: '399' },
  { label: '400 - URAI', value: '400' },
  { label: '401 - BRUSQUE', value: '401' },
  { label: '402 - FERNANDOPOLIS', value: '402' },
  { label: '403 - VIDEIRA', value: '403' },
  { label: '404 - VALENCA', value: '404' },
  { label: '405 - JARAGUA DO SUL', value: '405' },
  { label: '406 - CAMPO MOURAO', value: '406' },
  { label: '407 - CRICIUMA', value: '407' },
  { label: '408 - S.SEBASTIAO PARAISO', value: '408' },
  { label: '409 - NOVA PRATA', value: '409' },
  { label: '410 - CONCORDIA', value: '410' },
  { label: '411 - JALES', value: '411' },
  { label: '412 - MANHUMIRIM', value: '412' },
  { label: '413 - MOCOCA', value: '413' },
  { label: '414 - CRUZ DAS ALMAS', value: '414' },
  { label: '415 - ATIBAIA', value: '415' },
  { label: '416 - TAQUARA', value: '416' },
  { label: '417 - ITAPETINGA', value: '417' },
  { label: '418 - CASA BRANCA', value: '418' },
  { label: '419 - IGARAPAVA', value: '419' },
  { label: '420 - ITARARE', value: '420' },
  { label: '421 - TRES PONTAS', value: '421' },
  { label: '422 - FRUTAL', value: '422' },
  { label: '423 - ENCANTADO', value: '423' },
  { label: '424 - ENCRUZILHADA DO SUL', value: '424' },
  { label: '425 - ITAUNA', value: '425' },
  { label: '426 - STO.ANTONIO PLATINA', value: '426' },
  { label: '427 - SAO BERNARDO CAMPO', value: '427' },
  { label: '428 - VICOSA', value: '428' },
  { label: '429 - BANDEIRANTES', value: '429' },
  { label: '430 - ESTRELA', value: '430' },
  { label: '431 - GUAPORE', value: '431' },
  { label: '432 - GUARARAPES', value: '432' },
  { label: '433 - JUAZEIRO DO NORTE', value: '433' },
  { label: '434 - MANTENA', value: '434' },
  { label: '435 - PRACA MAUA', value: '435' },
  { label: '436 - TUPI PAULISTA', value: '436' },
  { label: '437 - SAO LUIZ GONZAGA', value: '437' },
  { label: '438 - FRANCISCO SA', value: '438' },
  { label: '439 - OSVALDO CRUZ', value: '439' },
  { label: '440 - PEREIRA BARRETO', value: '440' },
  { label: '441 - PORECATU', value: '441' },
  { label: '442 - LUZ', value: '442' },
  { label: '443 - OLIVEIRA', value: '443' },
  { label: '444 - GETULIO VARGAS', value: '444' },
  { label: '445 - ITAJUIPE', value: '445' },
  { label: '446 - TIMBAUBA', value: '446' },
  { label: '447 - ESTRELA DO SUL', value: '447' },
  { label: '448 - MIRANDOPOLIS', value: '448' },
  { label: '449 - CRUZEIRO-SP', value: '449' },
  { label: '451 - NHANDEARA', value: '451' },
  { label: '452 - EMPRESA CENTRAL', value: '452' },
  { label: '454 - SAO FIDELIS', value: '454' },
  { label: '455 - SACRAMENTO', value: '455' },
  { label: '456 - AMPARO', value: '456' },
  { label: '457 - TRES PASSOS', value: '457' },
  { label: '458 - CERES', value: '458' },
  { label: '459 - STA.BARBARA D OESTE', value: '459' },
  { label: '460 - ANGRA DOS REIS', value: '460' },
  { label: '462 - SANTOS DUMONT-MG', value: '462' },
  { label: '463 - PIRES DO RIO', value: '463' },
  { label: '464 - BOM SUCESSO', value: '464' },
  { label: '465 - GARIBALDI', value: '465' },
  { label: '466 - SAO FRANCISCO DO SUL', value: '466' },
  { label: '467 - ITAPOLIS', value: '467' },
  { label: '468 - RESPLENDOR', value: '468' },
  { label: '469 - BARRA MANSA', value: '469' },
  { label: '470 - ADAMANTINA', value: '470' },
  { label: '471 - LEOPOLDINA', value: '471' },
  { label: '472 - EMPRESA ABOLICAO', value: '472' },
  { label: '473 - OURO PRETO', value: '473' },
  { label: '474 - ESPIRITO STO.PINHAL', value: '474' },
  { label: '475 - GUAIRA', value: '475' },
  { label: '476 - ASTORGA', value: '476' },
  { label: '477 - MACAU', value: '477' },
  { label: '478 - LINHARES', value: '478' },
  { label: '479 - CANOAS', value: '479' },
  { label: '480 - NANUQUE', value: '480' },
  { label: '481 - MARANGUAPE', value: '481' },
  { label: '482 - CORINTO', value: '482' },
  { label: '483 - SAO GOTARDO', value: '483' },
  { label: '484 - PARANAIBA', value: '484' },
  { label: '485 - CASTRO', value: '485' },
  { label: '486 - FARROUPILHA', value: '486' },
  { label: '487 - RIO POMBA', value: '487' },
  { label: '488 - SAO SEPE', value: '488' },
  { label: '489 - STA.MARIA DO SUACUI', value: '489' },
  { label: '490 - SOLEDADE', value: '490' },
  { label: '491 - GOIATUBA', value: '491' },
  { label: '492 - REGISTRO', value: '492' },
  { label: '493 - JACAREPAGUA', value: '493' },
  { label: '494 - SAO FRANCISCO', value: '494' },
  { label: '495 - PATO BRANCO', value: '495' },
  { label: '496 - INHUMAS', value: '496' },
  { label: '497 - VICENTE DE CARVALHO', value: '497' },
  { label: '498 - PACAEMBU', value: '498' },
  { label: '500 - SAO JERONIMO', value: '500' },
  { label: '501 - SARANDI', value: '501' },
  { label: '502 - CARMO DO PARANAIBA', value: '502' },
  { label: '503 - EMPRESA CONTAGEM', value: '503' },
  { label: '504 - CONSELHEIRO LAFAIETE', value: '504' },
  { label: '505 - IBITINGA', value: '505' },
  { label: '506 - INHAPIM', value: '506' },
  { label: '507 - PAULO DE FARIA', value: '507' },
  { label: '508 - UNAI', value: '508' },
  { label: '509 - NOVA ESPERANCA', value: '509' },
  { label: '510 - ITAPEVA', value: '510' },
  { label: '511 - TATUI', value: '511' },
  { label: '512 - ALTO ARAGUAIA', value: '512' },
  { label: '513 - PORANGATU', value: '513' },
  { label: '514 - PORTO FERREIRA', value: '514' },
  { label: '515 - PALMEIRAS DE GOIAS', value: '515' },
  { label: '516 - CRUZEIRO DO OESTE', value: '516' },
  { label: '517 - CURITIBANOS', value: '517' },
  { label: '518 - ITAPEMIRIM', value: '518' },
  { label: '519 - SAO JOAO DO PIAUI', value: '519' },
  { label: '520 - LOANDA', value: '520' },
  { label: '521 - POMBAL', value: '521' },
  { label: '522 - BAMBUI', value: '522' },
  { label: '523 - SAO ROQUE', value: '523' },
  { label: '524 - ESPINOSA', value: '524' },
  { label: '525 - IPANEMA', value: '525' },
  { label: '526 - QUIRINOPOLIS', value: '526' },
  { label: '527 - BANANEIRAS', value: '527' },
  { label: '528 - BACABAL', value: '528' },
  { label: '529 - URUACU', value: '529' },
  { label: '530 - S.LUIS MONTES BELOS', value: '530' },
  { label: '531 - CASCAVEL', value: '531' },
  { label: '532 - UBAJARA', value: '532' },
  { label: '533 - CORACAO DE JESUS', value: '533' },
  { label: '536 - QUIXERAMOBIM', value: '536' },
  { label: '537 - SAO BENTO DO UNA', value: '537' },
  { label: '539 - COROMANDEL', value: '539' },
  { label: '540 - ARARANGUA', value: '540' },
  { label: '541 - ARRAIAS', value: '541' },
  { label: '542 - ARAPIRACA', value: '542' },
  { label: '543 - GUIA LOPES DA LAGUNA', value: '543' },
  { label: '544 - PIRACANJUBA', value: '544' },
  { label: '545 - VALENCA', value: '545' },
  { label: '546 - CAIAPONIA', value: '546' },
  { label: '547 - ICO', value: '547' },
  { label: '548 - IRECE', value: '548' },
  { label: '549 - ILHA DO GOVERNADOR', value: '549' },
  { label: '551 - RONDONOPOLIS', value: '551' },
  { label: '552 - COXIM', value: '552' },
  { label: '553 - POXOREU', value: '553' },
  { label: '554 - EMPRESA IMPERATRIZ', value: '554' },
  { label: '555 - ALENQUER', value: '555' },
  { label: '556 - POCOES', value: '556' },
  { label: '557 - ANICUNS', value: '557' },
  { label: '558 - BREVES', value: '558' },
  { label: '559 - ITAPURANGA', value: '559' },
  { label: '560 - SAO JOAO NEPOMUCENO', value: '560' },
  { label: '561 - SAO FRANCISCO ASSIS', value: '561' },
  { label: '562 - ITAPECURU-MIRIM', value: '562' },
  { label: '563 - SANTO ANTONIO JESUS', value: '563' },
  { label: '565 - MARABA', value: '565' },
  { label: '566 - PINHEIRO', value: '566' },
  { label: '567 - ALTAMIRA', value: '567' },
  { label: '568 - GRAJAU', value: '568' },
  { label: '569 - SANTA MARIA VITORIA', value: '569' },
  { label: '570 - AFOGADOS INGAZEIRA', value: '570' },
  { label: '571 - BARRA DO GARCAS', value: '571' },
  { label: '572 - GOIANDIRA', value: '572' },
  { label: '573 - LENCOIS PAULISTA', value: '573' },
  { label: '574 - PINDAMONHANGABA', value: '574' },
  { label: '575 - GRAMADO', value: '575' },
  { label: '576 - EMPRESA PENHA', value: '576' },
  { label: '577 - TEFE', value: '577' },
  { label: '578 - MOGI-MIRIM', value: '578' },
  { label: '580 - MOREIRA SALES', value: '580' },
  { label: '581 - ORIZONA', value: '581' },
  { label: '582 - SURUBIM', value: '582' },
  { label: '583 - TATUAPE', value: '583' },
  { label: '584 - VILA MARIA', value: '584' },
  { label: '585 - CATOLE DO ROCHA', value: '585' },
  { label: '586 - XANXERE', value: '586' },
  { label: '587 - TOLEDO', value: '587' },
  { label: '588 - BOM DESPACHO', value: '588' },
  { label: '589 - BOM JESUS', value: '589' },
  { label: '590 - BREJO', value: '590' },
  { label: '591 - CONCEICAO M.DENTRO', value: '591' },
  { label: '592 - VILA MILITAR', value: '592' },
  { label: '593 - IRARA', value: '593' },
  { label: '594 - REMANSO', value: '594' },
  { label: '595 - RUY BARBOSA', value: '595' },
  { label: '596 - URUCUI', value: '596' },
  { label: '597 - ZONA SUL-RJ', value: '597' },
  { label: '598 - LEBLON', value: '598' },
  { label: '599 - SAO MIGUEL DO OESTE', value: '599' },
  { label: '600 - ARARIPINA', value: '600' },
  { label: '601 - COARACI', value: '601' },
  { label: '602 - IBAITI', value: '602' },
  { label: '603 - SAO JOAO DOS PATOS', value: '603' },
  { label: '604 - VERANOPOLIS', value: '604' },
  { label: '605 - CABROBO', value: '605' },
  { label: '606 - POSSE', value: '606' },
  { label: '607 - CONSELHEIRO PENA', value: '607' },
  { label: '609 - CORRENTE', value: '609' },
  { label: '610 - ESPLANADA', value: '610' },
  { label: '611 - ESTANCIA VELHA', value: '611' },
  { label: '612 - NOSSA SENHORA GLORIA', value: '612' },
  { label: '613 - SANTA INES', value: '613' },
  { label: '614 - NOVA CRUZ', value: '614' },
  { label: '615 - PALMAS', value: '615' },
  { label: '616 - FRANCISCO BELTRAO', value: '616' },
  { label: '617 - CANGUCU', value: '617' },
  { label: '618 - CIANORTE', value: '618' },
  { label: '619 - JULIO DE CASTILHOS', value: '619' },
  { label: '620 - NOVA LONDRINA', value: '620' },
  { label: '621 - PAULO AFONSO', value: '621' },
  { label: '622 - TANABI', value: '622' },
  { label: '623 - MIRANDA', value: '623' },
  { label: '624 - CASSIA', value: '624' },
  { label: '625 - SAPE', value: '625' },
  { label: '626 - CANDELARIA-RS', value: '626' },
  { label: '627 - RIO BONITO', value: '627' },
  { label: '628 - VIAMAO', value: '628' },
  { label: '629 - TIMBO', value: '629' },
  { label: '630 - LAPA', value: '630' },
  { label: '631 - AGUDOS', value: '631' },
  { label: '632 - IPORA', value: '632' },
  { label: '633 - IVAIPORA', value: '633' },
  { label: '634 - PIANCO', value: '634' },
  { label: '635 - CAMBUCI', value: '635' },
  { label: '636 - GUARULHOS', value: '636' },
  { label: '637 - OSASCO', value: '637' },
  { label: '638 - ARAGUAINA', value: '638' },
  { label: '639 - JUSSARA', value: '639' },
  { label: '640 - BREJO SANTO', value: '640' },
  { label: '641 - GUAIRA', value: '641' },
  { label: '642 - JARAGUA', value: '642' },
  { label: '643 - TAMOIOS', value: '643' },
  { label: '644 - CAPINZAL', value: '644' },
  { label: '645 - UMUARAMA', value: '645' },
  { label: '646 - ANA ROSA', value: '646' },
  { label: '647 - VILA PRUDENTE', value: '647' },
  { label: '649 - ITANHANDU', value: '649' },
  { label: '650 - PRATA', value: '650' },
  { label: '651 - IPANEMA', value: '651' },
  { label: '652 - RIBEIRAO DO PINHAL', value: '652' },
  { label: '653 - SAPIRANGA', value: '653' },
  { label: '654 - MUZAMBINHO', value: '654' },
  { label: '655 - SAO MATEUS DO SUL', value: '655' },
  { label: '656 - SAO JOAQUIM', value: '656' },
  { label: '657 - CUITE', value: '657' },
  { label: '659 - MINEIROS', value: '659' },
  { label: '661 - PASSO DA AREIA', value: '661' },
  { label: '662 - POCONE', value: '662' },
  { label: '663 - CEAGESP', value: '663' },
  { label: '664 - BELA VISTA PARAISO', value: '664' },
  { label: '665 - TELEMACO BORBA', value: '665' },
  { label: '666 - SANTA FE DO SUL', value: '666' },
  { label: '667 - ROSARIO OESTE', value: '667' },
  { label: '668 - GOIANESIA', value: '668' },
  { label: '669 - ANTONIO PRADO', value: '669' },
  { label: '670 - CACAPAVA DO SUL', value: '670' },
  { label: '671 - TAQUARI', value: '671' },
  { label: '672 - VENANCIO AIRES', value: '672' },
  { label: '673 - CARPINA', value: '673' },
  { label: '674 - SAO BENTO DO SUL', value: '674' },
  { label: '675 - PRACA DOS CORREIOS', value: '675' },
  { label: '676 - PARANACITY', value: '676' },
  { label: '677 - IBIRUBA', value: '677' },
  { label: '678 - TAPERA', value: '678' },
  { label: '679 - CERRO LARGO', value: '679' },
  { label: '680 - FREDERICO WESTPHALEN', value: '680' },
  { label: '681 - MAUA', value: '681' },
  { label: '682 - TRES DE MAIO', value: '682' },
  { label: '683 - JACAREI', value: '683' },
  { label: '684 - RIACHAO DO JACUIPE', value: '684' },
  { label: '685 - CAMPOS NOVOS', value: '685' },
  { label: '687 - FREGUESIA DO O', value: '687' },
  { label: '688 - ABAETE', value: '688' },
  { label: '689 - MACARANI', value: '689' },
  { label: '690 - SANTA HELENA GOIAS', value: '690' },
  { label: '691 - CAMPINA VERDE', value: '691' },
  { label: '692 - PORTEIRINHA', value: '692' },
  { label: '693 - CASTRO ALVES', value: '693' },
  { label: '694 - OSORIO', value: '694' },
  { label: '695 - CAMPO LARGO', value: '695' },
  { label: '696 - IBIRAMA', value: '696' },
  { label: '697 - SETE DE SETEMBRO', value: '697' },
  { label: '698 - CANELA', value: '698' },
  { label: '699 - CAPIVARI', value: '699' },
  { label: '700 - ACOPIARA', value: '700' },
  { label: '701 - SANTA CRUZ', value: '701' },
  { label: '702 - NOVA VENECIA', value: '702' },
  { label: '703 - WENCESLAU BRAZ', value: '703' },
  { label: '704 - PONTALINA', value: '704' },
  { label: '705 - GIRUA', value: '705' },
  { label: '706 - APARECIDA DO TABOADO', value: '706' },
  { label: '707 - FAXINAL DO SOTURNO', value: '707' },
  { label: '708 - CASTANHAL', value: '708' },
  { label: '709 - PANAMBI', value: '709' },
  { label: '710 - BARREIROS', value: '710' },
  { label: '711 - STA.CRUZ CAPIBARIBE', value: '711' },
  { label: '712 - AVENIDA PAULISTA', value: '712' },
  { label: '713 - TIETE', value: '713' },
  { label: '714 - CABO', value: '714' },
  { label: '715 - SAO SEBASTIAO-SP', value: '715' },
  { label: '716 - ALECRIM', value: '716' },
  { label: '717 - DIADEMA', value: '717' },
  { label: '718 - SUZANO', value: '718' },
  { label: '719 - BELENZINHO', value: '719' },
  { label: '721 - BELO JARDIM', value: '721' },
  { label: '722 - MOEMA', value: '722' },
  { label: '723 - PINHEIRO MACHADO', value: '723' },
  { label: '724 - SAO FRANCISCO PAULA', value: '724' },
  { label: '725 - FLORES DA CUNHA', value: '725' },
  { label: '726 - MARAU', value: '726' },
  { label: '727 - JOAO CAMARA', value: '727' },
  { label: '728 - NOVA ANDRADINA', value: '728' },
  { label: '729 - ITAGUAI', value: '729' },
  { label: '730 - BRUMADO', value: '730' },
  { label: '731 - SANANDUVA', value: '731' },
  { label: '732 - SANTO AUGUSTO', value: '732' },
  { label: '733 - CAMPOS SALES', value: '733' },
  { label: '734 - LARANJEIRAS DO SUL', value: '734' },
  { label: '735 - MEDIANEIRA', value: '735' },
  { label: '736 - PALMITOS', value: '736' },
  { label: '737 - TANGARA', value: '737' },
  { label: '738 - BRACO DO NORTE', value: '738' },
  { label: '740 - RIO BRILHANTE', value: '740' },
  { label: '741 - TERESOPOLIS', value: '741' },
  { label: '742 - PORTO MURTINHO', value: '742' },
  { label: '743 - AMAMBAI', value: '743' },
  { label: '744 - BOM JESUS DA LAPA', value: '744' },
  { label: '745 - CACEQUI', value: '745' },
  { label: '746 - BORRAZOPOLIS', value: '746' },
  { label: '747 - UBIRATA', value: '747' },
  { label: '748 - BOM JESUS', value: '748' },
  { label: '749 - PARAUNA', value: '749' },
  { label: '750 - BETIM', value: '750' },
  { label: '751 - SAO JOAO DE MERITI', value: '751' },
  { label: '752 - SETOR CAMPINAS', value: '752' },
  { label: '753 - RIO VERDE M.GROSSO', value: '753' },
  { label: '754 - ITAITUBA', value: '754' },
  { label: '755 - CAMPO BOM', value: '755' },
  { label: '756 - PORTAO-CURITIBA', value: '756' },
  { label: '757 - SAO MIGUEL ARAGUAIA', value: '757' },
  { label: '758 - MOMBACA', value: '758' },
  { label: '759 - SOUSA', value: '759' },
  { label: '761 - AFONSO CLAUDIO', value: '761' },
  { label: '764 - ESTEIO', value: '764' },
  { label: '765 - CANUDOS-PA', value: '765' },
  { label: '766 - LEME', value: '766' },
  { label: '767 - ITABIRA', value: '767' },
  { label: '768 - CAMBE', value: '768' },
  { label: '769 - NATIVIDADE', value: '769' },
  { label: '772 - MARCELINO RAMOS', value: '772' },
  { label: '773 - MANDAGUACU', value: '773' },
  { label: '774 - TABATINGA', value: '774' },
  { label: '775 - TOBIAS BARRETO', value: '775' },
  { label: '776 - SAO JOSE DO CEDRO', value: '776' },
  { label: '777 - SAO LOURENCO OESTE', value: '777' },
  { label: '778 - TORRES', value: '778' },
  { label: '779 - AJURICABA', value: '779' },
  { label: '780 - RUBIATABA', value: '780' },
  { label: '781 - ANDRADAS', value: '781' },
  { label: '782 - BARRA DO CORDA', value: '782' },
  { label: '783 - CAMETA', value: '783' },
  { label: '784 - CAPINOPOLIS', value: '784' },
  { label: '785 - CASTELO-ES', value: '785' },
  { label: '786 - CIDADE GAUCHA', value: '786' },
  { label: '787 - DIAMANTINO', value: '787' },
  { label: '788 - ELESBAO VELOSO', value: '788' },
  { label: '789 - ENGENHEIRO BELTRAO', value: '789' },
  { label: '790 - ESPUMOSO', value: '790' },
  { label: '791 - EUCLIDES DA CUNHA', value: '791' },
  { label: '792 - EUNAPOLIS', value: '792' },
  { label: '793 - GLORIA DE DOURADOS', value: '793' },
  { label: '794 - GURUPI', value: '794' },
  { label: '795 - HORIZONTINA', value: '795' },
  { label: '796 - IPORA', value: '796' },
  { label: '797 - ITAIOPOLIS', value: '797' },
  { label: '798 - ITAPIRANGA', value: '798' },
  { label: '799 - ITATIBA', value: '799' },
  { label: '800 - JOAO PINHEIRO', value: '800' },
  { label: '801 - LAVRAS DO SUL', value: '801' },
  { label: '802 - MONTANHA-ES', value: '802' },
  { label: '803 - NILOPOLIS', value: '803' },
  { label: '804 - PARAISO DO TOCANTINS', value: '804' },
  { label: '805 - STO.ANTONIO SUDOESTE', value: '805' },
  { label: '806 - SAO GABRIEL DA PALHA', value: '806' },
  { label: '807 - SAO SEBASTIAO DO CAI', value: '807' },
  { label: '808 - SOBRADINHO-RS', value: '808' },
  { label: '809 - TAIO', value: '809' },
  { label: '810 - TOCANTINOPOLIS', value: '810' },
  { label: '811 - VALINHOS', value: '811' },
  { label: '812 - VASSOURAS', value: '812' },
  { label: '813 - BROOKLIN PAULISTA', value: '813' },
  { label: '814 - BOCA DO ACRE', value: '814' },
  { label: '815 - CAPITAO POCO', value: '815' },
  { label: '816 - CARINHANHA', value: '816' },
  { label: '817 - IBOTIRAMA', value: '817' },
  { label: '818 - MANACAPURU', value: '818' },
  { label: '819 - MANICORE', value: '819' },
  { label: '820 - PARAGOMINAS', value: '820' },
  { label: '821 - PAULISTA', value: '821' },
  { label: '823 - SANTA QUITERIA', value: '823' },
  { label: '824 - SAO MIGUEL CAMPOS', value: '824' },
  { label: '825 - IBIUNA', value: '825' },
  { label: '826 - TAGUATINGA CENTRO', value: '826' },
  { label: '828 - JOAO COLIN', value: '828' },
  { label: '829 - ARACRUZ', value: '829' },
  { label: '830 - ASSIS CHATEAUBRIAND', value: '830' },
  { label: '831 - ATALAIA', value: '831' },
  { label: '832 - BARRA DO BUGRES', value: '832' },
  { label: '833 - BARRA SAO FRANCISCO', value: '833' },
  { label: '834 - BONITO-PE', value: '834' },
  { label: '836 - CACU', value: '836' },
  { label: '837 - CAMACAN', value: '837' },
  { label: '838 - CAMAPUA', value: '838' },
  { label: '839 - NAO-ME-TOQUE', value: '839' },
  { label: '840 - CAPAO BONITO', value: '840' },
  { label: '841 - CARDOSO', value: '841' },
  { label: '842 - CHOPINZINHO', value: '842' },
  { label: '843 - CLEVELANDIA', value: '843' },
  { label: '844 - ECOPORANGA', value: '844' },
  { label: '845 - FATIMA DO SUL', value: '845' },
  { label: '846 - GANDU', value: '846' },
  { label: '847 - GOIOERE', value: '847' },
  { label: '849 - ITABIRITO', value: '849' },
  { label: '850 - ITABORAI', value: '850' },
  { label: '851 - ITANHEM', value: '851' },
  { label: '852 - ITAPAJE', value: '852' },
  { label: '853 - ITURAMA', value: '853' },
  { label: '854 - JACIARA', value: '854' },
  { label: '855 - JAGUARI', value: '855' },
  { label: '856 - JANDAIA DO SUL', value: '856' },
  { label: '857 - LORENA', value: '857' },
  { label: '858 - MARAVILHA', value: '858' },
  { label: '859 - MAL.CANDIDO RONDON', value: '859' },
  { label: '860 - MIGUELOPOLIS', value: '860' },
  { label: '861 - MIRACEMA', value: '861' },
  { label: '862 - MIRACEMA TOCANTINS', value: '862' },
  { label: '863 - MORADA NOVA', value: '863' },
  { label: '864 - NONOAI', value: '864' },
  { label: '865 - PIRANHAS', value: '865' },
  { label: '866 - PITANGA', value: '866' },
  { label: '867 - PRINCESA ISABEL', value: '867' },
  { label: '868 - RESTINGA SECA', value: '868' },
  { label: '869 - RIBEIRAO PIRES', value: '869' },
  { label: '870 - SALGUEIRO', value: '870' },
  { label: '871 - SANTA BARBARA DO SUL', value: '871' },
  { label: '872 - STA.RITA DO SAPUCAI', value: '872' },
  { label: '873 - SAO JOAQUIM DA BARRA', value: '873' },
  { label: '874 - SAO PEDRO DO SUL', value: '874' },
  { label: '875 - SEARA', value: '875' },
  { label: '876 - TAPEJARA', value: '876' },
  { label: '877 - TENENTE PORTELA', value: '877' },
  { label: '878 - TOME-ACU', value: '878' },
  { label: '879 - UMARIZAL', value: '879' },
  { label: '880 - URUSSANGA', value: '880' },
  { label: '881 - VISCONDE RIO BRANCO', value: '881' },
  { label: '882 - CAMPO NOVO', value: '882' },
  { label: '883 - GRAVATAI', value: '883' },
  { label: '885 - SAO MARCOS', value: '885' },
  { label: '888 - AGUA BRANCA-PI', value: '888' },
  { label: '889 - AGUAS FORMOSAS', value: '889' },
  { label: '890 - ALVARES MACHADO', value: '890' },
  { label: '891 - ANDIRA', value: '891' },
  { label: '892 - APODI', value: '892' },
  { label: '893 - ARARUAMA', value: '893' },
  { label: '894 - ARCOS', value: '894' },
  { label: '895 - BALSAS', value: '895' },
  { label: '896 - BARRA BONITA-SP', value: '896' },
  { label: '897 - BATAGUASSU', value: '897' },
  { label: '898 - BOA VIAGEM', value: '898' },
  { label: '899 - BODOCO', value: '899' },
  { label: '900 - BOM JESUS DE GOIAS', value: '900' },
  { label: '901 - BOM RETIRO', value: '901' },
  { label: '902 - BRASILIA DE MINAS', value: '902' },
  { label: '903 - CAARAPO', value: '903' },
  { label: '904 - AV.FERNANDES CUNHA', value: '904' },
  { label: '905 - CAMPOS DO JORDAO', value: '905' },
  { label: '906 - CANTO DO BURITI', value: '906' },
  { label: '907 - CAPANEMA-PR', value: '907' },
  { label: '909 - CASSILANDIA', value: '909' },
  { label: '910 - CATUIPE', value: '910' },
  { label: '911 - COLINAS DO TOCANTINS', value: '911' },
  { label: '912 - COLORADO', value: '912' },
  { label: '913 - CONCEICAO', value: '913' },
  { label: '914 - CONCEICAO ARAGUAIA', value: '914' },
  { label: '915 - CORDEIRO', value: '915' },
  { label: '916 - COTIA', value: '916' },
  { label: '917 - CUSTODIA', value: '917' },
  { label: '918 - DESCALVADO', value: '918' },
  { label: '919 - DOIS VIZINHOS', value: '919' },
  { label: '920 - FLORIDA PAULISTA', value: '920' },
  { label: '921 - GASPAR', value: '921' },
  { label: '922 - GRAVATA', value: '922' },
  { label: '923 - GUANAMBI', value: '923' },
  { label: '924 - GUARAPARI', value: '924' },
  { label: '925 - GUARUJA', value: '925' },
  { label: '926 - HUMAITA', value: '926' },
  { label: '927 - IBIA', value: '927' },
  { label: '928 - INDAIAL', value: '928' },
  { label: '929 - INDAIATUBA', value: '929' },
  { label: '930 - IPIRA', value: '930' },
  { label: '932 - ITANHAEM', value: '932' },
  { label: '933 - IUNA', value: '933' },
  { label: '934 - JABOATAO GUARARAPES', value: '934' },
  { label: '935 - JANAUBA', value: '935' },
  { label: '936 - JEREMOABO', value: '936' },
  { label: '937 - JOSE BONIFACIO', value: '937' },
  { label: '938 - JUNQUEIROPOLIS', value: '938' },
  { label: '939 - LAJINHA', value: '939' },
  { label: '940 - LAVRAS DA MANGABEIRA', value: '940' },
  { label: '941 - LUZIANIA', value: '941' },
  { label: '942 - MAGE', value: '942' },
  { label: '943 - MAIRINQUE', value: '943' },
  { label: '944 - MAMANGUAPE', value: '944' },
  { label: '945 - MANGA', value: '945' },
  { label: '946 - MARACAS', value: '946' },
  { label: '947 - MAUES', value: '947' },
  { label: '948 - MONDAI', value: '948' },
  { label: '949 - MONTE ALEGRE', value: '949' },
  { label: '950 - MONTE ALTO', value: '950' },
  { label: '951 - JI-PARANA', value: '951' },
  { label: '952 - MONTE SANTO DE MINAS', value: '952' },
  { label: '953 - MUTUM', value: '953' },
  { label: '954 - NAVIRAI', value: '954' },
  { label: '955 - ORLEANS', value: '955' },
  { label: '957 - PALMEIRA', value: '957' },
  { label: '958 - PALMITAL', value: '958' },
  { label: '959 - PALOTINA', value: '959' },
  { label: '961 - PEDRO LEOPOLDO', value: '961' },
  { label: '962 - PENTECOSTE', value: '962' },
  { label: '963 - PETROLINA', value: '963' },
  { label: '964 - PIEDADE', value: '964' },
  { label: '966 - PIRATINI', value: '966' },
  { label: '967 - PITANGUI', value: '967' },
  { label: '968 - PIUMHI', value: '968' },
  { label: '970 - PORTO FELIZ', value: '970' },
  { label: '971 - PRESIDENTE EPITACIO', value: '971' },
  { label: '972 - PRUDENTOPOLIS', value: '972' },
  { label: '973 - RIBEIRA DO POMBAL', value: '973' },
  { label: '974 - RIO DAS PEDRAS', value: '974' },
  { label: '975 - RONDON', value: '975' },
  { label: '976 - SALINAS', value: '976' },
  { label: '978 - SANTA ISABEL DO IVAI', value: '978' },
  { label: '979 - SAO DOMINGOS-GO', value: '979' },
  { label: '980 - S.GONCALO DO SAPUCAI', value: '980' },
  { label: '981 - SAO JOSE DO BELMONTE', value: '981' },
  { label: '982 - SAO JOSE DOS PINHAIS', value: '982' },
  { label: '983 - SAO LOURENCO', value: '983' },
  { label: '984 - SAO PAULO DO POTENGI', value: '984' },
  { label: '985 - SEABRA', value: '985' },
  { label: '986 - SERTANOPOLIS', value: '986' },
  { label: '987 - SERTAOZINHO', value: '987' },
  { label: '988 - SILVANIA', value: '988' },
  { label: '990 - SUMARE', value: '990' },
  { label: '992 - TERRA RICA', value: '992' },
  { label: '993 - TURVO', value: '993' },
  { label: '994 - VINHEDO', value: '994' },
  { label: '996 - XAXIM-SC', value: '996' },
  { label: '999 - UNA', value: '999' },
  { label: '1000 - ABAETETUBA', value: '1000' },
  { label: '1001 - BAIRRO MARTINS', value: '1001' },
  { label: '1002 - MUNDO NOVO-MS', value: '1002' },
  { label: '1003 - ASA NORTE 504', value: '1003' },
  { label: '1004 - ASA SUL 507', value: '1004' },
  { label: '1006 - CUBATAO', value: '1006' },
  { label: '1008 - CARAPICUIBA', value: '1008' },
  { label: '1009 - IPATINGA', value: '1009' },
  { label: '1010 - ACARAU', value: '1010' },
  { label: '1011 - AFRANIO', value: '1011' },
  { label: '1013 - ALEXANDRIA', value: '1013' },
  { label: '1014 - ALMEIRIM', value: '1014' },
  { label: '1017 - AMELIA RODRIGUES', value: '1017' },
  { label: '1020 - ASSARE', value: '1020' },
  { label: '1021 - CAMPO GRANDE-RN', value: '1021' },
  { label: '1022 - PRACA DO RELOGIO', value: '1022' },
  { label: '1023 - BAIXO GUANDU', value: '1023' },
  { label: '1024 - BARBALHA', value: '1024' },
  { label: '1025 - BARRA DO MENDES', value: '1025' },
  { label: '1027 - BARREIRINHAS', value: '1027' },
  { label: '1028 - BELEM SAO FRANCISCO', value: '1028' },
  { label: '1029 - BELMONTE', value: '1029' },
  { label: '1031 - BONITO-MS', value: '1031' },
  { label: '1035 - CANINDE', value: '1035' },
  { label: '1036 - CARACARAI', value: '1036' },
  { label: '1037 - CARAUARI', value: '1037' },
  { label: '1038 - CARAUBAS', value: '1038' },
  { label: '1039 - CASCAVEL', value: '1039' },
  { label: '1041 - CAUCAIA', value: '1041' },
  { label: '1042 - CEARA-MIRIM', value: '1042' },
  { label: '1043 - CENTRALINA', value: '1043' },
  { label: '1045 - COELHO NETO', value: '1045' },
  { label: '1046 - CONCEICAO ALAGOAS', value: '1046' },
  { label: '1047 - CONCEICAO DO COITE', value: '1047' },
  { label: '1048 - CONDEUBA', value: '1048' },
  { label: '1050 - CORURIPE', value: '1050' },
  { label: '1051 - CRISTALINA', value: '1051' },
  { label: '1052 - CUPIRA', value: '1052' },
  { label: '1053 - CURURUPU', value: '1053' },
  { label: '1054 - DELMIRO GOUVEIA', value: '1054' },
  { label: '1055 - DIONISIO CERQUEIRA', value: '1055' },
  { label: '1056 - DOMINGOS MARTINS', value: '1056' },
  { label: '1057 - EIRUNEPE', value: '1057' },
  { label: '1058 - ESCADA', value: '1058' },
  { label: '1059 - EXU', value: '1059' },
  { label: '1061 - FLORESTA-PE', value: '1061' },
  { label: '1062 - FORMOSA RIO PRETO', value: '1062' },
  { label: '1063 - FREI PAULO', value: '1063' },
  { label: '1065 - GILBUES', value: '1065' },
  { label: '1066 - GOIANINHA', value: '1066' },
  { label: '1067 - GUIMARANIA', value: '1067' },
  { label: '1069 - IBIMIRIM', value: '1069' },
  { label: '1070 - IBIRATAIA', value: '1070' },
  { label: '1072 - INHAMBUPE', value: '1072' },
  { label: '1076 - ITABAIANINHA', value: '1076' },
  { label: '1077 - ITANHOMI', value: '1077' },
  { label: '1080 - ITIUBA', value: '1080' },
  { label: '1081 - ITUBERA', value: '1081' },
  { label: '1083 - JACINTO', value: '1083' },
  { label: '1084 - JAGUAQUARA', value: '1084' },
  { label: '1085 - JUCURUTU', value: '1085' },
  { label: '1087 - LAGO DA PEDRA', value: '1087' },
  { label: '1088 - LAJES', value: '1088' },
  { label: '1089 - LIVRAMENTO N.SENHORA', value: '1089' },
  { label: '1090 - LUZ', value: '1090' },
  { label: '1091 - MACAUBAS', value: '1091' },
  { label: '1092 - MARA ROSA', value: '1092' },
  { label: '1094 - MATA DE SAO JOAO', value: '1094' },
  { label: '1095 - VILA BELA S.TRINDADE', value: '1095' },
  { label: '1096 - MIGUEL CALMON', value: '1096' },
  { label: '1097 - MINAS NOVAS', value: '1097' },
  { label: '1098 - MIRAI', value: '1098' },
  { label: '1099 - MORRO DO CHAPEU', value: '1099' },
  { label: '1100 - MUCUGE', value: '1100' },
  { label: '1101 - MUTUIPE', value: '1101' },
  { label: '1102 - NOVA PETROPOLIS', value: '1102' },
  { label: '1104 - ORIXIMINA', value: '1104' },
  { label: '1105 - PACAJUS', value: '1105' },
  { label: '1106 - PARELHAS', value: '1106' },
  { label: '1107 - PARIPIRANGA', value: '1107' },
  { label: '1108 - PARNAMIRIM', value: '1108' },
  { label: '1109 - PAU DOS FERROS', value: '1109' },
  { label: '1110 - PAULISTANA', value: '1110' },
  { label: '1111 - PECANHA', value: '1111' },
  { label: '1112 - PETROLANDIA', value: '1112' },
  { label: '1113 - PINDOBACU', value: '1113' },
  { label: '1114 - PIRENOPOLIS', value: '1114' },
  { label: '1115 - POCO VERDE', value: '1115' },
  { label: '1116 - PORTO DOS GAUCHOS', value: '1116' },
  { label: '1117 - PORTO NACIONAL', value: '1117' },
  { label: '1118 - PRADO', value: '1118' },
  { label: '1119 - PRESIDENTE DUTRA', value: '1119' },
  { label: '1121 - REDENCAO', value: '1121' },
  { label: '1122 - REGENERACAO', value: '1122' },
  { label: '1123 - RIACHO DE SANTANA', value: '1123' },
  { label: '1125 - RUBIM', value: '1125' },
  { label: '1126 - ESTILO GOIANIA', value: '1126' },
  { label: '1128 - STA.MARIA BOA VISTA', value: '1128' },
  { label: '1129 - SANTA RITA DE CASSIA', value: '1129' },
  { label: '1130 - SANTA LUZ', value: '1130' },
  { label: '1133 - SANTO ESTEVAO', value: '1133' },
  { label: '1134 - SAO BENTO', value: '1134' },
  { label: '1135 - SAO FELIX ARAGUAIA', value: '1135' },
  { label: '1136 - S.GABRIEL CACHOEIRA', value: '1136' },
  { label: '1137 - SAO JOSE DA LAJE', value: '1137' },
  { label: '1138 - SAO LOURENCO DA MATA', value: '1138' },
  { label: '1139 - SAO LUIS DO QUITUNDE', value: '1139' },
  { label: '1140 - SAO MIGUEL', value: '1140' },
  { label: '1143 - SAO SEBASTIAO PASSE', value: '1143' },
  { label: '1144 - SERRA BRANCA', value: '1144' },
  { label: '1145 - SERRO', value: '1145' },
  { label: '1146 - SERTANIA', value: '1146' },
  { label: '1147 - SIDROLANDIA', value: '1147' },
  { label: '1148 - SIMPLICIO MENDES', value: '1148' },
  { label: '1149 - SOLEDADE', value: '1149' },
  { label: '1150 - SOLONOPOLE', value: '1150' },
  { label: '1151 - SOURE', value: '1151' },
  { label: '1152 - TANHACU', value: '1152' },
  { label: '1153 - TAQUARITINGA NORTE', value: '1153' },
  { label: '1154 - TARUMIRIM', value: '1154' },
  { label: '1155 - TAUA', value: '1155' },
  { label: '1156 - TEIXEIRA', value: '1156' },
  { label: '1157 - TIANGUA', value: '1157' },
  { label: '1158 - TORIXOREU', value: '1158' },
  { label: '1160 - TRES MARIAS', value: '1160' },
  { label: '1161 - TUCURUI', value: '1161' },
  { label: '1164 - UBATA', value: '1164' },
  { label: '1165 - UIRAUNA', value: '1165' },
  { label: '1166 - URUBURETAMA', value: '1166' },
  { label: '1168 - WANDERLEY', value: '1168' },
  { label: '1169 - VARZEA ALEGRE', value: '1169' },
  { label: '1171 - XIQUE-XIQUE', value: '1171' },
  { label: '1172 - MOGI-GUACU', value: '1172' },
  { label: '1173 - CASA VERDE', value: '1173' },
  { label: '1177 - ALTA FLORESTA', value: '1177' },
  { label: '1178 - ARIQUEMES', value: '1178' },
  { label: '1179 - CACOAL', value: '1179' },
  { label: '1180 - SINOP', value: '1180' },
  { label: '1181 - PIMENTA BUENO', value: '1181' },
  { label: '1182 - VILHENA', value: '1182' },
  { label: '1183 - ICOARACI', value: '1183' },
  { label: '1184 - BAIRRO IPIRANGA', value: '1184' },
  { label: '1185 - CASA NOVA', value: '1185' },
  { label: '1187 - EMPRESA MARINGA', value: '1187' },
  { label: '1188 - IGREJINHA', value: '1188' },
  { label: '1189 - PARAISO', value: '1189' },
  { label: '1191 - AVENIDA ANGELICA', value: '1191' },
  { label: '1192 - EMPRESA VILA CARRAO', value: '1192' },
  { label: '1193 - BAIRRO DO LIMAO', value: '1193' },
  { label: '1194 - BARAO DE DUPRAT', value: '1194' },
  { label: '1195 - EMPRESA BOM RETIRO', value: '1195' },
  { label: '1196 - LIBERDADE', value: '1196' },
  { label: '1197 - CAMPOS ELISEOS', value: '1197' },
  { label: '1198 - PARI', value: '1198' },
  { label: '1199 - PERDIZES-SP', value: '1199' },
  { label: '1201 - JAGUARE-SP', value: '1201' },
  { label: '1202 - SETE DE ABRIL', value: '1202' },
  { label: '1203 - SACOMAN', value: '1203' },
  { label: '1204 - PRACA SILVIO ROMERO', value: '1204' },
  { label: '1205 - AVENIDA CURSINO SP', value: '1205' },
  { label: '1206 - VILA ALPINA', value: '1206' },
  { label: '1207 - VILA DIVA', value: '1207' },
  { label: '1208 - COSTA E SILVA', value: '1208' },
  { label: '1209 - CURIMATA', value: '1209' },
  { label: '1210 - CRAVINHOS', value: '1210' },
  { label: '1211 - MARECHAL FLORIANO', value: '1211' },
  { label: '1212 - AV.TIRADENTES', value: '1212' },
  { label: '1213 - JARDIM SATELITE', value: '1213' },
  { label: '1216 - COXIPO', value: '1216' },
  { label: '1217 - CABULA', value: '1217' },
  { label: '1218 - BEZERRA DE MENEZES', value: '1218' },
  { label: '1219 - EDUCANDOS', value: '1219' },
  { label: '1220 - TUCURUVI', value: '1220' },
  { label: '1221 - CARIJOS', value: '1221' },
  { label: '1222 - EMPRESA PAMPULHA', value: '1222' },
  { label: '1223 - LIBERDADE', value: '1223' },
  { label: '1224 - EMPRESA S.CAMPOS-SE', value: '1224' },
  { label: '1226 - SOBRADINHO-DF', value: '1226' },
  { label: '1227 - BONFIM', value: '1227' },
  { label: '1228 - CARLOS PRATES', value: '1228' },
  { label: '1229 - EMPRESA SAVASSI', value: '1229' },
  { label: '1230 - SETOR COMERCIAL SUL', value: '1230' },
  { label: '1231 - EMPRESA SIA', value: '1231' },
  { label: '1232 - BAIRRO DA PEDREIRA', value: '1232' },
  { label: '1233 - EMPRESA FAROL', value: '1233' },
  { label: '1234 - VARADOURO', value: '1234' },
  { label: '1235 - EMPRESA TAGUATINGA', value: '1235' },
  { label: '1238 - CAMACARI', value: '1238' },
  { label: '1239 - GAMA CENTRO', value: '1239' },
  { label: '1240 - VILA VELHA', value: '1240' },
  { label: '1241 - CARIACICA', value: '1241' },
  { label: '1242 - EMPRESA GOYAZES', value: '1242' },
  { label: '1243 - BACACHERI', value: '1243' },
  { label: '1244 - VISCONDE', value: '1244' },
  { label: '1245 - BARAO DE SOUZA LEAO', value: '1245' },
  { label: '1246 - RIBEIRA', value: '1246' },
  { label: '1247 - SERRA DO RAMALHO', value: '1247' },
  { label: '1248 - AZENHA', value: '1248' },
  { label: '1250 - VILA ISABEL', value: '1250' },
  { label: '1251 - EMPRESA R.ASSEMBLEIA', value: '1251' },
  { label: '1252 - CANDELARIA-RJ', value: '1252' },
  { label: '1253 - EMPRESA BARRA TIJUCA', value: '1253' },
  { label: '1254 - BONSUCESSO', value: '1254' },
  { label: '1255 - CAJU', value: '1255' },
  { label: '1257 - SANTA CRUZ', value: '1257' },
  { label: '1261 - ALFREDO CHAVES', value: '1261' },
  { label: '1262 - ALHANDRA', value: '1262' },
  { label: '1263 - SAO VICENTE', value: '1263' },
  { label: '1264 - ALIANCA', value: '1264' },
  { label: '1265 - ALMIRANTE TAMANDARE', value: '1265' },
  { label: '1266 - CAPELA DO SOCORRO', value: '1266' },
  { label: '1267 - SAO MIGUEL PAULISTA', value: '1267' },
  { label: '1268 - SANTA RITA', value: '1268' },
  { label: '1269 - AVENIDA 85', value: '1269' },
  { label: '1272 - COMODORO', value: '1272' },
  { label: '1273 - ESTILO INV. BRASILIA', value: '1273' },
  { label: '1279 - SENA MADUREIRA', value: '1279' },
  { label: '1283 - GIRAU DO PONCIANO', value: '1283' },
  { label: '1288 - RIO REAL', value: '1288' },
  { label: '1289 - TEIXEIRA DE FREITAS', value: '1289' },
  { label: '1291 - UAUA', value: '1291' },
  { label: '1292 - AQUIRAZ', value: '1292' },
  { label: '1293 - CEDRO', value: '1293' },
  { label: '1295 - MESSEJANA', value: '1295' },
  { label: '1298 - BOA ESPERANCA', value: '1298' },
  { label: '1299 - MUNIZ FREIRE', value: '1299' },
  { label: '1300 - SANTA LEOPOLDINA', value: '1300' },
  { label: '1301 - SERRA', value: '1301' },
  { label: '1302 - ALEXANIA', value: '1302' },
  { label: '1303 - ALVORADA-TO', value: '1303' },
  { label: '1304 - ARAGUACU', value: '1304' },
  { label: '1305 - ARAGUATINS', value: '1305' },
  { label: '1306 - COLMEIA', value: '1306' },
  { label: '1307 - DIANOPOLIS', value: '1307' },
  { label: '1308 - EDEIA', value: '1308' },
  { label: '1309 - MINACU', value: '1309' },
  { label: '1311 - ACAILANDIA', value: '1311' },
  { label: '1312 - COLINAS', value: '1312' },
  { label: '1313 - ESPERANTINOPOLIS', value: '1313' },
  { label: '1317 - AGUA BOA', value: '1317' },
  { label: '1318 - ARENAPOLIS', value: '1318' },
  { label: '1319 - CANARANA-MT', value: '1319' },
  { label: '1320 - MIRASSOL D OESTE', value: '1320' },
  { label: '1321 - TANGARA DA SERRA', value: '1321' },
  { label: '1322 - NOVA XAVANTINA', value: '1322' },
  { label: '1324 - ARAL MOREIRA', value: '1324' },
  { label: '1326 - ABRE CAMPO', value: '1326' },
  { label: '1327 - ANDRELANDIA', value: '1327' },
  { label: '1329 - BONFINOPOLIS MINAS', value: '1329' },
  { label: '1330 - BURITIS', value: '1330' },
  { label: '1331 - MATO VERDE', value: '1331' },
  { label: '1332 - PERDIZES-MG', value: '1332' },
  { label: '1333 - PRESIDENTE OLEGARIO', value: '1333' },
  { label: '1334 - RIO PARDO DE MINAS', value: '1334' },
  { label: '1335 - RIO PARANAIBA', value: '1335' },
  { label: '1336 - STO.ANTONIO DO MONTE', value: '1336' },
  { label: '1338 - VAZANTE', value: '1338' },
  { label: '1342 - RONDON DO PARA', value: '1342' },
  { label: '1347 - ARAPOTI', value: '1347' },
  { label: '1348 - BITURUNA', value: '1348' },
  { label: '1349 - 1349', value: '1349' },
  { label: '1350 - GUARANIACU', value: '1350' },
  { label: '1351 - MARILANDIA DO SUL', value: '1351' },
  { label: '1353 - PALMITAL', value: '1353' },
  { label: '1354 - PEROLA-PR', value: '1354' },
  { label: '1355 - PIRAI DO SUL', value: '1355' },
  { label: '1356 - SAO JOAO', value: '1356' },
  { label: '1357 - SAO MIGUEL DO IGUACU', value: '1357' },
  { label: '1361 - IGARASSU', value: '1361' },
  { label: '1363 - VICENCIA', value: '1363' },
  { label: '1364 - FRONTEIRAS', value: '1364' },
  { label: '1365 - PATU', value: '1365' },
  { label: '1366 - SANTO ANTONIO', value: '1366' },
  { label: '1367 - BOA VISTA DO BURICA', value: '1367' },
  { label: '1369 - EMPRESA FORTALEZA', value: '1369' },
  { label: '1370 - CHAPADA', value: '1370' },
  { label: '1371 - CONSTANTINA', value: '1371' },
  { label: '1373 - MACHADINHO', value: '1373' },
  { label: '1374 - MOSTARDAS', value: '1374' },
  { label: '1376 - RONDA ALTA', value: '1376' },
  { label: '1377 - SANTO CRISTO', value: '1377' },
  { label: '1378 - SAO JOSE DO NORTE', value: '1378' },
  { label: '1379 - SEBERI', value: '1379' },
  { label: '1380 - TRES COROAS', value: '1380' },
  { label: '1381 - COLORADO DO OESTE', value: '1381' },
  { label: '1382 - ABELARDO LUZ', value: '1382' },
  { label: '1383 - ALFREDO WAGNER', value: '1383' },
  { label: '1384 - CUNHA PORA', value: '1384' },
  { label: '1385 - DESCANSO', value: '1385' },
  { label: '1386 - ESTREITO', value: '1386' },
  { label: '1387 - FRAIBURGO', value: '1387' },
  { label: '1388 - GUARACIABA', value: '1388' },
  { label: '1389 - ITUPORANGA', value: '1389' },
  { label: '1390 - MASSARANDUBA', value: '1390' },
  { label: '1391 - PALMA SOLA', value: '1391' },
  { label: '1392 - PINHALZINHO', value: '1392' },
  { label: '1393 - QUILOMBO', value: '1393' },
  { label: '1394 - RIO NEGRINHO', value: '1394' },
  { label: '1395 - SAO CARLOS', value: '1395' },
  { label: '1396 - DOIS CORREGOS', value: '1396' },
  { label: '1397 - MARACAI', value: '1397' },
  { label: '1398 - SAO SIMAO-SP', value: '1398' },
  { label: '1400 - JARDIM DA PENHA', value: '1400' },
  { label: '1401 - JARU', value: '1401' },
  { label: '1402 - GENERAL VALADAO', value: '1402' },
  { label: '1403 - ESTILO INV ESPLANADA DF', value: '1403' },
  { label: '1404 - OURO PRETO DO OESTE', value: '1404' },
  { label: '1405 - PRESIDENTE MEDICI', value: '1405' },
  { label: '1406 - ROLIM DE MOURA', value: '1406' },
  { label: '1407 - MUQUI', value: '1407' },
  { label: '1408 - IMBITUBA', value: '1408' },
  { label: '1409 - NOVA RUSSAS', value: '1409' },
  { label: '1410 - SOMBRIO', value: '1410' },
  { label: '1412 - PRAIA GRANDE', value: '1412' },
  { label: '1413 - SAO JOSE DO OURO', value: '1413' },
  { label: '1414 - JOAO PAULO', value: '1414' },
  { label: '1418 - ALPINOPOLIS', value: '1418' },
  { label: '1419 - LAGO NORTE', value: '1419' },
  { label: '1420 - ALTEROSA', value: '1420' },
  { label: '1421 - ALTINHO', value: '1421' },
  { label: '1422 - ALTINOPOLIS', value: '1422' },
  { label: '1423 - PARANOA', value: '1423' },
  { label: '1424 - ALTO PARANA', value: '1424' },
  { label: '1425 - ALTO PIQUIRI', value: '1425' },
  { label: '1426 - AHU', value: '1426' },
  { label: '1427 - ALTONIA', value: '1427' },
  { label: '1428 - ALTOS', value: '1428' },
  { label: '1429 - ALVINOPOLIS-MG', value: '1429' },
  { label: '1430 - ALVORADA-RS', value: '1430' },
  { label: '1431 - ALVORADA DO SUL', value: '1431' },
  { label: '1432 - AV.BRASILIA-CURITIBA', value: '1432' },
  { label: '1434 - AMPERE', value: '1434' },
  { label: '1435 - ANAGE', value: '1435' },
  { label: '1436 - ANANINDEUA', value: '1436' },
  { label: '1438 - ANCHIETA-ES', value: '1438' },
  { label: '1439 - ANCHIETA-SC', value: '1439' },
  { label: '1441 - ANGATUBA', value: '1441' },
  { label: '1443 - CAJURU', value: '1443' },
  { label: '1444 - ANGICAL', value: '1444' },
  { label: '1445 - ANGICOS', value: '1445' },
  { label: '1446 - ANITA GARIBALDI', value: '1446' },
  { label: '1451 - APARECIDA', value: '1451' },
  { label: '1452 - APARECIDA DE GOIANIA', value: '1452' },
  { label: '1453 - TRINDADE', value: '1453' },
  { label: '1456 - ARACI', value: '1456' },
  { label: '1459 - ARAIOSES', value: '1459' },
  { label: '1460 - PARQUE SAO PAULO', value: '1460' },
  { label: '1461 - IRAI DE MINAS', value: '1461' },
  { label: '1462 - ARAQUARI', value: '1462' },
  { label: '1465 - ARARUNA-PR', value: '1465' },
  { label: '1467 - ARAUCARIA', value: '1467' },
  { label: '1468 - AREADO', value: '1468' },
  { label: '1469 - AREIA BRANCA-RN', value: '1469' },
  { label: '1470 - ARINOS', value: '1470' },
  { label: '1471 - ARIPUANA', value: '1471' },
  { label: '1472 - RUA ARAGUAIA', value: '1472' },
  { label: '1473 - ARROIO DO MEIO', value: '1473' },
  { label: '1474 - ARROIO DO TIGRE', value: '1474' },
  { label: '1475 - ARTUR NOGUEIRA', value: '1475' },
  { label: '1476 - ARUJA', value: '1476' },
  { label: '1477 - ARVOREZINHA', value: '1477' },
  { label: '1478 - ASCURRA', value: '1478' },
  { label: '1479 - AV ESTEVES RODRIGUES', value: '1479' },
  { label: '1480 - AUGUSTO CORREA', value: '1480' },
  { label: '1481 - AURIFLAMA', value: '1481' },
  { label: '1482 - AURORA', value: '1482' },
  { label: '1483 - SARANDI', value: '1483' },
  { label: '1484 - DR.MARIANO DA ROCHA', value: '1484' },
  { label: '1486 - BAIANOPOLIS', value: '1486' },
  { label: '1487 - EMPRESA CAXIAS SUL', value: '1487' },
  { label: '1488 - BAIXA GRANDE', value: '1488' },
  { label: '1489 - BALNEARIO CAMBORIU', value: '1489' },
  { label: '1490 - BANANAL', value: '1490' },
  { label: '1492 - SORRISO', value: '1492' },
  { label: '1493 - BARBOSA FERRAZ', value: '1493' },
  { label: '1495 - AUTO SHOP.ARICANDUVA', value: '1495' },
  { label: '1496 - BARRA DA ESTIVA', value: '1496' },
  { label: '1497 - BARRA DO RIBEIRO', value: '1497' },
  { label: '1498 - BARRA VELHA', value: '1498' },
  { label: '1501 - BAIRRO BRASIL', value: '1501' },
  { label: '1502 - CANAPOLIS-MG', value: '1502' },
  { label: '1503 - ITAMARATY', value: '1503' },
  { label: '1504 - CARDOSO DE ALMEIDA', value: '1504' },
  { label: '1505 - EMPRESA PC.GIRASSOIS', value: '1505' },
  { label: '1506 - BORBA GATO', value: '1506' },
  { label: '1507 - SIA TRECHO 2', value: '1507' },
  { label: '1508 - BAIRRO MALLET', value: '1508' },
  { label: '1509 - CASA FORTE', value: '1509' },
  { label: '1510 - EMPRESA S.J.RIO PRET', value: '1510' },
  { label: '1511 - EMPRESA MOOCA', value: '1511' },
  { label: '1512 - SOROCABA NORTE', value: '1512' },
  { label: '1513 - NOVA ODESSA', value: '1513' },
  { label: '1515 - BARAO GERALDO', value: '1515' },
  { label: '1516 - PONTE DO MORUMBI', value: '1516' },
  { label: '1517 - QUITANDA', value: '1517' },
  { label: '1519 - CHAMPAGNAT', value: '1519' },
  { label: '1521 - IMIRIM', value: '1521' },
  { label: '1522 - BATEL', value: '1522' },
  { label: '1523 - EMPRESA JARAGUA', value: '1523' },
  { label: '1524 - CASCADURA', value: '1524' },
  { label: '1527 - TAILANDIA', value: '1527' },
  { label: '1528 - JARDIM BELA VISTA', value: '1528' },
  { label: '1529 - BARUERI', value: '1529' },
  { label: '1530 - ITAQUERA', value: '1530' },
  { label: '1532 - ITAPUA', value: '1532' },
  { label: '1533 - CANDELARIA-RN', value: '1533' },
  { label: '1534 - SEMINARIO', value: '1534' },
  { label: '1541 - JARDIM TREMEMBE', value: '1541' },
  { label: '1542 - VILA ESPERANCA', value: '1542' },
  { label: '1543 - GECEX SAO PAULO III', value: '1543' },
  { label: '1545 - VILA MASCOTE', value: '1545' },
  { label: '1548 - VILA MATILDE', value: '1548' },
  { label: '1549 - SAPOPEMBA', value: '1549' },
  { label: '1556 - JARDIM TRANQUILIDADE', value: '1556' },
  { label: '1557 - EMPRESA SANTO ANDRE', value: '1557' },
  { label: '1560 - GECEX CAMPINAS', value: '1560' },
  { label: '1561 - BAIRRO ASSUNCAO', value: '1561' },
  { label: '1563 - AVENIDA GOIAS', value: '1563' },
  { label: '1565 - BENFICA-RJ', value: '1565' },
  { label: '1566 - JARDIM LUZ', value: '1566' },
  { label: '1568 - GRAJAU', value: '1568' },
  { label: '1569 - VOLUNTARIOS', value: '1569' },
  { label: '1570 - IRAJA', value: '1570' },
  { label: '1571 - ITATIAIA', value: '1571' },
  { label: '1572 - JARDIM BOTANICO-RJ', value: '1572' },
  { label: '1575 - REALENGO', value: '1575' },
  { label: '1576 - AMARAL PEIXOTO', value: '1576' },
  { label: '1577 - TELEPORTO', value: '1577' },
  { label: '1578 - PIRATININGA', value: '1578' },
  { label: '1579 - TAQUARA', value: '1579' },
  { label: '1581 - QUEIMADOS', value: '1581' },
  { label: '1582 - AV.SAUL ELKIND', value: '1582' },
  { label: '1583 - RETIRO', value: '1583' },
  { label: '1584 - BERNARDO MONTEIRO', value: '1584' },
  { label: '1585 - BAIRRO DE LOURDES', value: '1585' },
  { label: '1587 - CANAA', value: '1587' },
  { label: '1588 - CTO.ADM.NATAL', value: '1588' },
  { label: '1589 - GUARANTA DO NORTE', value: '1589' },
  { label: '1590 - SAPEZAL', value: '1590' },
  { label: '1591 - UNIV.FED.CAMPINA GDE', value: '1591' },
  { label: '1592 - ARMACAO DOS BUZIOS', value: '1592' },
  { label: '1594 - ESTORIL', value: '1594' },
  { label: '1595 - PEDRO AFONSO', value: '1595' },
  { label: '1596 - SANTANA DE PARNAIBA', value: '1596' },
  { label: '1597 - ESPIGAO D OESTE', value: '1597' },
  { label: '1598 - CARIRI SHOPPING', value: '1598' },
  { label: '1599 - PITUACU', value: '1599' },
  { label: '1600 - RUA DO LIVRAMENTO', value: '1600' },
  { label: '1601 - PRACA CENTENARIO', value: '1601' },
  { label: '1602 - COMERCIO', value: '1602' },
  { label: '1603 - JARDINS-SE', value: '1603' },
  { label: '1604 - CORP BANK CEARA', value: '1604' },
  { label: '1605 - PRACA DO CARMO', value: '1605' },
  { label: '1606 - SETOR BANCARIO SUL', value: '1606' },
  { label: '1607 - S.PUBLICO GOVFEDERAL', value: '1607' },
  { label: '1608 - GECEX BRASILIA', value: '1608' },
  { label: '1609 - PRACA PIO XII', value: '1609' },
  { label: '1610 - AVENIDA GOIAS', value: '1610' },
  { label: '1611 - JARACATI', value: '1611' },
  { label: '1614 - EMPRESA PRACA SETE', value: '1614' },
  { label: '1615 - SETOR PUBLICO MG', value: '1615' },
  { label: '1616 - GECEX OPERACOES BHZ', value: '1616' },
  { label: '1617 - PRACA 1817', value: '1617' },
  { label: '1618 - SETOR PUBLICO PB', value: '1618' },
  { label: '1619 - CID.UNIVERSITARIA-PB', value: '1619' },
  { label: '1620 - TAMARINEIRA', value: '1620' },
  { label: '1622 - EMPRESA CURITIBA', value: '1622' },
  { label: '1626 - FLORESTA-MG', value: '1626' },
  { label: '1628 - GECEX OPERACOES CWB', value: '1628' },
  { label: '1629 - SANTO AGOSTINHO', value: '1629' },
  { label: '1630 - VENDA NOVA', value: '1630' },
  { label: '1631 - ALIPIO DE MELO', value: '1631' },
  { label: '1632 - BARREIRO', value: '1632' },
  { label: '1633 - ELDORADO', value: '1633' },
  { label: '1634 - PARQUE DA CRIANCA', value: '1634' },
  { label: '1635 - CRUZ DAS ARMAS', value: '1635' },
  { label: '1636 - EPITACIO PESSOA', value: '1636' },
  { label: '1637 - PICARRA', value: '1637' },
  { label: '1638 - TIRIRICAL', value: '1638' },
  { label: '1639 - SAO FRANCISCO', value: '1639' },
  { label: '1640 - BARAO DE GURGUEIA', value: '1640' },
  { label: '1641 - BENEVIDES', value: '1641' },
  { label: '1643 - BEZERROS', value: '1643' },
  { label: '1644 - BIGUACU', value: '1644' },
  { label: '1645 - BIRITIBA-MIRIM', value: '1645' },
  { label: '1648 - BOCA DA MATA', value: '1648' },
  { label: '1649 - BOITUVA', value: '1649' },
  { label: '1650 - BOM JARDIM-PE', value: '1650' },
  { label: '1651 - BOM JARDIM-MA', value: '1651' },
  { label: '1652 - BOM JARDIM-RJ', value: '1652' },
  { label: '1656 - BORBOREMA', value: '1656' },
  { label: '1657 - BORDA DA MATA', value: '1657' },
  { label: '1658 - BOSSOROCA', value: '1658' },
  { label: '1659 - BOTELHOS', value: '1659' },
  { label: '1660 - BOTUPORA', value: '1660' },
  { label: '1661 - BRASILANDIA', value: '1661' },
  { label: '1662 - BRASILEIA', value: '1662' },
  { label: '1663 - BRAZOPOLIS', value: '1663' },
  { label: '1666 - BREJO MADRE DE DEUS', value: '1666' },
  { label: '1667 - BROTAS', value: '1667' },
  { label: '1668 - UFRN', value: '1668' },
  { label: '1669 - BRUMADINHO', value: '1669' },
  { label: '1670 - BUENO BRANDAO', value: '1670' },
  { label: '1671 - BUENOPOLIS', value: '1671' },
  { label: '1674 - SETOR PUBLICO PA', value: '1674' },
  { label: '1675 - BURI', value: '1675' },
  { label: '1676 - BURITAMA', value: '1676' },
  { label: '1677 - BURITI', value: '1677' },
  { label: '1679 - BURITI DOS LOPES', value: '1679' },
  { label: '1680 - BURITIZEIRO', value: '1680' },
  { label: '1681 - CABEDELO', value: '1681' },
  { label: '1682 - CABO VERDE', value: '1682' },
  { label: '1683 - CACAPAVA', value: '1683' },
  { label: '1685 - CACHOEIRA ALTA', value: '1685' },
  { label: '1686 - EMPRESA MARAJOARA', value: '1686' },
  { label: '1687 - CACHOEIRA DE MINAS', value: '1687' },
  { label: '1688 - CACHOEIRAS DE MACACU', value: '1688' },
  { label: '1689 - CACHOEIRINHA-PE', value: '1689' },
  { label: '1690 - GECEX PORTO ALEGRE', value: '1690' },
  { label: '1691 - CACONDE', value: '1691' },
  { label: '1694 - CAETE', value: '1694' },
  { label: '1696 - CAFARNAUM', value: '1696' },
  { label: '1697 - CAIBATE', value: '1697' },
  { label: '1700 - CAIEIRAS', value: '1700' },
  { label: '1701 - JARDIM DO LAGO', value: '1701' },
  { label: '1703 - CAJURU', value: '1703' },
  { label: '1704 - CALDAS', value: '1704' },
  { label: '1705 - CALDAS NOVAS', value: '1705' },
  { label: '1706 - CAMANDUCAIA', value: '1706' },
  { label: '1707 - CAMBORIU', value: '1707' },
  { label: '1708 - CAMBUCI', value: '1708' },
  { label: '1709 - CAMBUI', value: '1709' },
  { label: '1711 - CAMPANHA', value: '1711' },
  { label: '1712 - CAMPESTRE', value: '1712' },
  { label: '1713 - CAMPINA DA LAGOA', value: '1713' },
  { label: '1714 - CAMPINAS DO SUL', value: '1714' },
  { label: '1716 - CAMPO BELO DO SUL', value: '1716' },
  { label: '1718 - CAMPO ERE', value: '1718' },
  { label: '1719 - CAMPO FORMOSO', value: '1719' },
  { label: '1723 - CAMPOS GERAIS', value: '1723' },
  { label: '1726 - CANDEIAS-BA', value: '1726' },
  { label: '1727 - CANDEIAS-MG', value: '1727' },
  { label: '1728 - CANDIBA', value: '1728' },
  { label: '1729 - CANDIDO MOTA', value: '1729' },
  { label: '1730 - CANDIDO SALES', value: '1730' },
  { label: '1731 - CANGUARETAMA', value: '1731' },
  { label: '1732 - CANHOTINHO', value: '1732' },
  { label: '1734 - CANTANHEDE', value: '1734' },
  { label: '1735 - CAPANEMA-PA', value: '1735' },
  { label: '1741 - CARAGUATATUBA', value: '1741' },
  { label: '1743 - CARANDAI', value: '1743' },
  { label: '1744 - EMPRESA IBIRAPUERA', value: '1744' },
  { label: '1747 - CARIRIACU', value: '1747' },
  { label: '1750 - CARMO DA MATA', value: '1750' },
  { label: '1751 - CARMO DO RIO CLARO', value: '1751' },
  { label: '1753 - CARMOPOLIS DE MINAS', value: '1753' },
  { label: '1756 - CASCA', value: '1756' },
  { label: '1757 - CASIMIRO DE ABREU', value: '1757' },
  { label: '1759 - CATANDUVAS-PR', value: '1759' },
  { label: '1760 - CATANDUVAS-SC', value: '1760' },
  { label: '1761 - CATENDE', value: '1761' },
  { label: '1762 - CATU', value: '1762' },
  { label: '1763 - CAXAMBU', value: '1763' },
  { label: '1765 - CENTENARIO DO SUL', value: '1765' },
  { label: '1767 - CERQUEIRA CESAR', value: '1767' },
  { label: '1768 - CERQUILHO', value: '1768' },
  { label: '1769 - CORP BANK SEDAN', value: '1769' },
  { label: '1770 - CEU AZUL', value: '1770' },
  { label: '1771 - CHA GRANDE', value: '1771' },
  { label: '1772 - CHAPADA GUIMARAES', value: '1772' },
  { label: '1773 - CHAPADINHA', value: '1773' },
  { label: '1774 - CICERO DANTAS', value: '1774' },
  { label: '1776 - COARI', value: '1776' },
  { label: '1778 - GECEX RIO DE JANEIRO', value: '1778' },
  { label: '1779 - COLIDER', value: '1779' },
  { label: '1780 - COLOMBO', value: '1780' },
  { label: '1781 - COLORADO', value: '1781' },
  { label: '1784 - CONCEICAO APARECIDA', value: '1784' },
  { label: '1786 - CONCEICAO DO CASTELO', value: '1786' },
  { label: '1789 - CONCEICAO RIO VERDE', value: '1789' },
  { label: '1790 - CONCHAL', value: '1790' },
  { label: '1791 - CONCHAS', value: '1791' },
  { label: '1793 - CONGONHAS', value: '1793' },
  { label: '1795 - COQUEIRAL', value: '1795' },
  { label: '1797 - CORBELIA', value: '1797' },
  { label: '1801 - SAO PELEGRINO', value: '1801' },
  { label: '1802 - RETA DA PENHA', value: '1802' },
  { label: '1803 - SHOPPING IGUATEMI', value: '1803' },
  { label: '1804 - CEASA-CONTAGEM', value: '1804' },
  { label: '1806 - MOZARLANDIA', value: '1806' },
  { label: '1807 - SANTA HELENA', value: '1807' },
  { label: '1808 - 1808', value: '1808' },
  { label: '1812 - TRIANON', value: '1812' },
  { label: '1814 - SHOPPING TACARUNA', value: '1814' },
  { label: '1815 - SANTA CRUZ', value: '1815' },
  { label: '1817 - CAMPO BELO-SP', value: '1817' },
  { label: '1819 - ITAIM PAULISTA', value: '1819' },
  { label: '1820 - PIRAPORINHA', value: '1820' },
  { label: '1821 - ALPHAVILLE', value: '1821' },
  { label: '1823 - BELFORD ROXO', value: '1823' },
  { label: '1826 - MUDA', value: '1826' },
  { label: '1830 - SAO MATEUS', value: '1830' },
  { label: '1832 - VILA JAGUARA', value: '1832' },
  { label: '1833 - BENFICA-PE', value: '1833' },
  { label: '1834 - AVENIDA TABOAO', value: '1834' },
  { label: '1835 - CAXANGA', value: '1835' },
  { label: '1836 - EMPRESA RECIFE', value: '1836' },
  { label: '1837 - PRAZERES', value: '1837' },
  { label: '1838 - AFOGADOS', value: '1838' },
  { label: '1840 - EMPRESA INDEPENDENCI', value: '1840' },
  { label: '1841 - JARDIM AMERICA-GO', value: '1841' },
  { label: '1843 - VILA RICA', value: '1843' },
  { label: '1844 - AMOREIRAS', value: '1844' },
  { label: '1845 - PONTA NEGRA', value: '1845' },
  { label: '1849 - BARAO DE ITAPURA', value: '1849' },
  { label: '1850 - EMPRESA STO ANTONIO', value: '1850' },
  { label: '1852 - PARQUE DAS NACOES', value: '1852' },
  { label: '1855 - PRES.ANTONIO CARLOS', value: '1855' },
  { label: '1856 - CORP BANK AMAZONAS', value: '1856' },
  { label: '1862 - RIO NEGRO', value: '1862' },
  { label: '1863 - SERVIDOR CURITIBA', value: '1863' },
  { label: '1864 - ESTILO MACEIO', value: '1864' },
  { label: '1867 - AV.TEOTONIO SEGURADO', value: '1867' },
  { label: '1869 - COMENDADOR ARAUJO', value: '1869' },
  { label: '1870 - ESTILO MANAUS', value: '1870' },
  { label: '1872 - COSTA RICA', value: '1872' },
  { label: '1873 - CIDADE MORENA', value: '1873' },
  { label: '1874 - VILA GUILHERME', value: '1874' },
  { label: '1875 - ESTILO IGUATEMI', value: '1875' },
  { label: '1876 - MARECHAL DEODORO-PR', value: '1876' },
  { label: '1878 - ESTILO SAO LUIS', value: '1878' },
  { label: '1879 -  ESTILO INV. SAVASSI', value: '1879' },
  { label: '1880 - BERRINI', value: '1880' },
  { label: '1881 - ESTILO AGRO C.GRANDE', value: '1881' },
  { label: '1882 - ESTILO BELEM', value: '1882' },
  { label: '1885 - ESTILO JOAO PESSOA', value: '1885' },
  { label: '1886 - AVENIDA JK', value: '1886' },
  { label: '1887 - TAGUATINGA SUL', value: '1887' },
  { label: '1888 - UFSCAR', value: '1888' },
  { label: '1889 - RUA URUGUAI', value: '1889' },
  { label: '1890 - CATEDRAL CAMPINAS-SP', value: '1890' },
  { label: '1893 - LARGE CORPORATE 1893', value: '1893' },
  { label: '1897 - SETOR PUBLICO SP', value: '1897' },
  { label: '1898 - ESCOLA PLTA.MEDICINA', value: '1898' },
  { label: '1899 - UNIV.FEDERAL DO RS', value: '1899' },
  { label: '1902 - PACOVAL', value: '1902' },
  { label: '1911 - CORP BANK INFRA', value: '1911' },
  { label: '1912 - CORP BANK INDUSTRIAS', value: '1912' },
  { label: '1913 - CORP BANK AGRO', value: '1913' },
  { label: '1914 - CORP BANK COM E SERV', value: '1914' },
  { label: '1916 - CORP BANK RIB PRETO', value: '1916' },
  { label: '1917 - TELES PIRES', value: '1917' },
  { label: '1921 - CSA SAO PAULO III', value: '1921' },
  { label: '1964 - ESCR.EXC.BARAO CAFE', value: '1964' },
  { label: '1965 - ESTILO SALVADOR', value: '1965' },
  { label: '1967 - CID.ADM.BELO HORIZON', value: '1967' },
  { label: '1968 - CSA SAO PAULO II', value: '1968' },
  { label: '1974 - CSA BELO HORIZONTE', value: '1974' },
  { label: '1977 - AGRO SORRISO', value: '1977' },
  { label: '1996 - ESTILO SAENS PENA', value: '1996' },
  { label: '1997 - ESTILO PANTANAL', value: '1997' },
  { label: '1998 - ESTILO RONDONOPOLIS', value: '1998' },
  { label: '1999 - ESTILO VIT.CONQUISTA', value: '1999' },
  { label: '2000 - GECEX SAO PAULO II', value: '2000' },
  { label: '2003 - COROACI', value: '2003' },
  { label: '2004 - COROATA', value: '2004' },
  { label: '2005 - CORONEL BICACO', value: '2005' },
  { label: '2006 - CORONEL FREITAS', value: '2006' },
  { label: '2008 - CORONEL VIVIDA', value: '2008' },
  { label: '2009 - CORRENTINA', value: '2009' },
  { label: '2010 - CORUMBA DE GOIAS', value: '2010' },
  { label: '2011 - CORUPA', value: '2011' },
  { label: '2012 - COSMOPOLIS', value: '2012' },
  { label: '2017 - CRISTINA', value: '2017' },
  { label: '2019 - CRIXAS', value: '2019' },
  { label: '2020 - CRUZ MACHADO', value: '2020' },
  { label: '2021 - CRUZILIA', value: '2021' },
  { label: '2022 - CUNHA', value: '2022' },
  { label: '2025 - DIVINO', value: '2025' },
  { label: '2026 - DIVINOLANDIA', value: '2026' },
  { label: '2027 - DOIS IRMAOS', value: '2027' },
  { label: '2030 - DOM FELICIANO', value: '2030' },
  { label: '2031 - DOM PEDRO', value: '2031' },
  { label: '2032 - DOM SILVERIO', value: '2032' },
  { label: '2034 - DUARTINA', value: '2034' },
  { label: '2035 - PARNAMIRIM', value: '2035' },
  { label: '2037 - ELOI MENDES', value: '2037' },
  { label: '2038 - EMBU', value: '2038' },
  { label: '2041 - ENTRE RIOS', value: '2041' },
  { label: '2042 - ENTRE RIOS DE MINAS', value: '2042' },
  { label: '2043 - ERVAL SECO', value: '2043' },
  { label: '2044 - ERVALIA', value: '2044' },
  { label: '2045 - ESMERALDAS', value: '2045' },
  { label: '2046 - ESPERA FELIZ', value: '2046' },
  { label: '2047 - ESPERANCA', value: '2047' },
  { label: '2048 - ESPERANTINA', value: '2048' },
  { label: '2049 - ESTIVA', value: '2049' },
  { label: '2050 - ESTRELA D OESTE', value: '2050' },
  { label: '2051 - EXTREMA', value: '2051' },
  { label: '2055 - FARTURA', value: '2055' },
  { label: '2056 - FAXINAL', value: '2056' },
  { label: '2057 - FAZENDA NOVA', value: '2057' },
  { label: '2064 - FILADELFIA', value: '2064' },
  { label: '2065 - FIRMINOPOLIS', value: '2065' },
  { label: '2071 - JARDIM-MS', value: '2071' },
  { label: '2072 - FRANCO DA ROCHA', value: '2072' },
  { label: '2078 - GENERAL SALGADO', value: '2078' },
  { label: '2080 - GETULINA', value: '2080' },
  { label: '2086 - GRANDES RIOS', value: '2086' },
  { label: '2087 - GRANJA', value: '2087' },
  { label: '2088 - GRAO MOGOL', value: '2088' },
  { label: '2089 - GRAVATAL', value: '2089' },
  { label: '2092 - GUARA', value: '2092' },
  { label: '2093 - GUARACIABA DO NORTE', value: '2093' },
  { label: '2094 - GUARAI', value: '2094' },
  { label: '2095 - GUARAMIRIM', value: '2095' },
  { label: '2096 - GUARANESIA', value: '2096' },
  { label: '2097 - GUARANI DAS MISSOES', value: '2097' },
  { label: '2098 - GUARAREMA', value: '2098' },
  { label: '2100 - GUARATUBA', value: '2100' },
  { label: '2103 - HERVAL D OESTE', value: '2103' },
  { label: '2105 - IACU', value: '2105' },
  { label: '2106 - IAPU', value: '2106' },
  { label: '2110 - IBIPORA', value: '2110' },
  { label: '2111 - IBIRACI', value: '2111' },
  { label: '2115 - IBIRITE', value: '2115' },
  { label: '2118 - ICARA', value: '2118' },
  { label: '2119 - ICARAIMA', value: '2119' },
  { label: '2120 - IEPE', value: '2120' },
  { label: '2121 - IGACI', value: '2121' },
  { label: '2122 - IGARAPE', value: '2122' },
  { label: '2123 - IGARAPE-ACU', value: '2123' },
  { label: '2125 - VENTUROSA', value: '2125' },
  { label: '2128 - PAIAGUAS', value: '2128' },
  { label: '2131 - IMBITUVA', value: '2131' },
  { label: '2134 - INDIAPORA', value: '2134' },
  { label: '2137 - IPIRANGA-PR', value: '2137' },
  { label: '2138 - IPOJUCA', value: '2138' },
  { label: '2143 - IRINEOPOLIS', value: '2143' },
  { label: '2144 - IRITUIA', value: '2144' },
  { label: '2145 - ITABERA', value: '2145' },
  { label: '2146 - ITABERAI', value: '2146' },
  { label: '2147 - ITABIRINHA', value: '2147' },
  { label: '2148 - SHOPPING GRANDE RIO', value: '2148' },
  { label: '2149 - ITACARAMBI', value: '2149' },
  { label: '2152 - ITAGIBA', value: '2152' },
  { label: '2153 - ITAGUACU', value: '2153' },
  { label: '2154 - ITAGUARA', value: '2154' },
  { label: '2155 - ITAI', value: '2155' },
  { label: '2156 - ITAIBA', value: '2156' },
  { label: '2157 - ENTRE RIOS', value: '2157' },
  { label: '2158 - ITAJOBI', value: '2158' },
  { label: '2159 - ITAMARAJU', value: '2159' },
  { label: '2160 - ITAMARANDIBA', value: '2160' },
  { label: '2161 - ITAMBACURI', value: '2161' },
  { label: '2163 - ITAOBIM', value: '2163' },
  { label: '2164 - ITAOCARA', value: '2164' },
  { label: '2165 - ITAPACI', value: '2165' },
  { label: '2167 - ITAPECERICA', value: '2167' },
  { label: '2168 - ITAPECERICA DA SERRA', value: '2168' },
  { label: '2169 - ITAPEJARA D OESTE', value: '2169' },
  { label: '2171 - ITAPEVI', value: '2171' },
  { label: '2172 - ITAPICURU', value: '2172' },
  { label: '2173 - ALTA FLORESTA OESTE', value: '2173' },
  { label: '2174 - ITAPIRAPUA', value: '2174' },
  { label: '2175 - ITAPORA', value: '2175' },
  { label: '2176 - ITAPORANGA', value: '2176' },
  { label: '2177 - ITAPORANGA', value: '2177' },
  { label: '2180 - ITAQUAQUECETUBA', value: '2180' },
  { label: '2182 - ITARANTIM', value: '2182' },
  { label: '2184 - ALVORADA D OESTE', value: '2184' },
  { label: '2186 - ITIQUIRA', value: '2186' },
  { label: '2188 - IVINHEMA', value: '2188' },
  { label: '2189 - IVOTI', value: '2189' },
  { label: '2190 - JABOTICATUBAS', value: '2190' },
  { label: '2192 - JACINTO MACHADO', value: '2192' },
  { label: '2193 - JACUPIRANGA', value: '2193' },
  { label: '2194 - JACUTINGA-MG', value: '2194' },
  { label: '2195 - JAGUAPITA', value: '2195' },
  { label: '2196 - JAGUARARI-BA', value: '2196' },
  { label: '2197 - CEREJEIRAS', value: '2197' },
  { label: '2198 - JAGUARIAIVA', value: '2198' },
  { label: '2199 - JAGUARIBE', value: '2199' },
  { label: '2200 - JAGUARIUNA', value: '2200' },
  { label: '2201 - JAGUARUANA', value: '2201' },
  { label: '2202 - JAGUARUNA', value: '2202' },
  { label: '2204 - JANDAIA', value: '2204' },
  { label: '2205 - JANIOPOLIS', value: '2205' },
  { label: '2206 - JAPARATUBA', value: '2206' },
  { label: '2207 - JAPURA', value: '2207' },
  { label: '2208 - JARDIM-CE', value: '2208' },
  { label: '2209 - JARDIM ALEGRE', value: '2209' },
  { label: '2211 - JARDINOPOLIS', value: '2211' },
  { label: '2212 - JATAIZINHO', value: '2212' },
  { label: '2214 - JAURU', value: '2214' },
  { label: '2215 - JEQUERI', value: '2215' },
  { label: '2217 - JOAIMA', value: '2217' },
  { label: '2218 - JOANOPOLIS', value: '2218' },
  { label: '2219 - JOAO ALFREDO', value: '2219' },
  { label: '2220 - JOAO MONLEVADE', value: '2220' },
  { label: '2221 - JOAQUIM TAVORA', value: '2221' },
  { label: '2222 - JOSE DE FREITAS', value: '2222' },
  { label: '2223 - COSTA MARQUES', value: '2223' },
  { label: '2225 - JUCAS', value: '2225' },
  { label: '2226 - JUINA', value: '2226' },
  { label: '2230 - JUSCIMEIRA', value: '2230' },
  { label: '2232 - LADAINHA', value: '2232' },
  { label: '2233 - LAGAMAR', value: '2233' },
  { label: '2234 - SETOR PUBLICO RJ', value: '2234' },
  { label: '2236 - LAGOA DOURADA', value: '2236' },
  { label: '2237 - LAGOA FORMOSA', value: '2237' },
  { label: '2239 - LAGOA DO ITAENGA', value: '2239' },
  { label: '2240 - LAGOA DA PRATA', value: '2240' },
  { label: '2241 - LAGOA SANTA', value: '2241' },
  { label: '2244 - LAJEDO', value: '2244' },
  { label: '2245 - LAMBARI', value: '2245' },
  { label: '2246 - LARANJAL PAULISTA', value: '2246' },
  { label: '2247 - LAURO MULLER', value: '2247' },
  { label: '2249 - LICINIO DE ALMEIDA', value: '2249' },
  { label: '2251 - LIMA DUARTE', value: '2251' },
  { label: '2253 - LIMOEIRO DO NORTE', value: '2253' },
  { label: '2254 - LOUVEIRA', value: '2254' },
  { label: '2255 - LUIS CORREIA', value: '2255' },
  { label: '2256 - MACAIBA', value: '2256' },
  { label: '2258 - MAIRIPORA', value: '2258' },
  { label: '2259 - MAJOR ISIDORO', value: '2259' },
  { label: '2262 - MALLET', value: '2262' },
  { label: '2263 - MAMBORE', value: '2263' },
  { label: '2265 - MACHADINHO D OESTE', value: '2265' },
  { label: '2266 - MANDIRITUBA', value: '2266' },
  { label: '2267 - MANGUEIRINHA', value: '2267' },
  { label: '2269 - MANOEL RIBAS', value: '2269' },
  { label: '2270 - JATUARANA', value: '2270' },
  { label: '2271 - MARAGOGIPE', value: '2271' },
  { label: '2272 - MARAPANIM', value: '2272' },
  { label: '2273 - MARCO', value: '2273' },
  { label: '2278 - MARIALVA', value: '2278' },
  { label: '2279 - MARIANA', value: '2279' },
  { label: '2280 - MARICA', value: '2280' },
  { label: '2282 - MARMELEIRO', value: '2282' },
  { label: '2283 - MARTINHO CAMPOS', value: '2283' },
  { label: '2285 - MASSAPE', value: '2285' },
  { label: '2287 - MATELANDIA', value: '2287' },
  { label: '2288 - MATEUS LEME', value: '2288' },
  { label: '2289 - MATIPO', value: '2289' },
  { label: '2290 - PRESIDENTE DUTRA', value: '2290' },
  { label: '2292 - SAO MIGUEL GUAPORE', value: '2292' },
  { label: '2293 - MEDEIROS NETO', value: '2293' },
  { label: '2294 - MELEIRO', value: '2294' },
  { label: '2295 - MENDES', value: '2295' },
  { label: '2296 - VILA ISA', value: '2296' },
  { label: '2297 - MERCES', value: '2297' },
  { label: '2298 - MIGUEL ALVES', value: '2298' },
  { label: '2299 - MIGUEL PEREIRA', value: '2299' },
  { label: '2302 - MIRACATU', value: '2302' },
  { label: '2303 - MIRADOURO', value: '2303' },
  { label: '2306 - MIRANTE PARANAPANEMA', value: '2306' },
  { label: '2307 - XV DE NOVEMBRO-SC', value: '2307' },
  { label: '2309 - GECEX BLUMENAU', value: '2309' },
  { label: '2313 - MOJU', value: '2313' },
  { label: '2314 - ZE DOCA', value: '2314' },
  { label: '2315 - ITAIPU', value: '2315' },
  { label: '2318 - MONTE ALEGRE', value: '2318' },
  { label: '2319 - MONTE ALEGRE MINAS', value: '2319' },
  { label: '2321 - MONTE AZUL PAULISTA', value: '2321' },
  { label: '2322 - MONTE BELO', value: '2322' },
  { label: '2324 - MONTE MOR', value: '2324' },
  { label: '2326 - MORENO', value: '2326' },
  { label: '2327 - MORRETES', value: '2327' },
  { label: '2328 - MORRO AGUDO', value: '2328' },
  { label: '2330 - VILA RE', value: '2330' },
  { label: '2332 - MURICI', value: '2332' },
  { label: '2335 - NAZARE DA MATA', value: '2335' },
  { label: '2337 - NEOPOLIS', value: '2337' },
  { label: '2338 - NEPOMUCENO', value: '2338' },
  { label: '2340 - NIOAQUE', value: '2340' },
  { label: '2341 - NIQUELANDIA', value: '2341' },
  { label: '2344 - NOSSA SENHORA DORES', value: '2344' },
  { label: '2346 - NOSSA SRA.DO SOCORRO', value: '2346' },
  { label: '2347 - NOVA AURORA', value: '2347' },
  { label: '2348 - NOVA CANAA', value: '2348' },
  { label: '2349 - NOVA CANTU', value: '2349' },
  { label: '2350 - NOVA LIMA', value: '2350' },
  { label: '2352 - NOVA PALMA', value: '2352' },
  { label: '2353 - NOVA RESENDE', value: '2353' },
  { label: '2354 - NOVA SERRANA', value: '2354' },
  { label: '2356 - NOVA TRENTO', value: '2356' },
  { label: '2357 - NOVA VENEZA', value: '2357' },
  { label: '2358 - AQUIRY', value: '2358' },
  { label: '2359 - AV.BRASIL-RIO BRANCO', value: '2359' },
  { label: '2360 - NOVO CRUZEIRO', value: '2360' },
  { label: '2362 - OEIRAS', value: '2362' },
  { label: '2363 - DOM BOSCO', value: '2363' },
  { label: '2364 - OIAPOQUE', value: '2364' },
  { label: '2365 - OLINDA', value: '2365' },
  { label: '2367 - OLIVEIRA BREJINHOS', value: '2367' },
  { label: '2369 - OROBO', value: '2369' },
  { label: '2371 - OURICURI', value: '2371' },
  { label: '2372 - OURO BRANCO', value: '2372' },
  { label: '2373 - ALENCASTRO', value: '2373' },
  { label: '2374 - PACATUBA', value: '2374' },
  { label: '2375 - GRUPO HOSP.CONCEICAO', value: '2375' },
  { label: '2376 - PADRE BERNARDO', value: '2376' },
  { label: '2378 - PADRE PARAISO', value: '2378' },
  { label: '2382 - PALESTINA', value: '2382' },
  { label: '2383 - PALHOCA', value: '2383' },
  { label: '2385 - PALMEIRA D OESTE', value: '2385' },
  { label: '2387 - PANCAS', value: '2387' },
  { label: '2389 - PAPANDUVA', value: '2389' },
  { label: '2390 - PARACAMBI', value: '2390' },
  { label: '2391 - PARACURU', value: '2391' },
  { label: '2393 - PARAIBA DO SUL', value: '2393' },
  { label: '2396 - PARAISO DO NORTE', value: '2396' },
  { label: '2397 - PARAISOPOLIS', value: '2397' },
  { label: '2399 - PARAMIRIM', value: '2399' },
  { label: '2400 - CAMPOS BELOS', value: '2400' },
  { label: '2403 - PARANATINGA', value: '2403' },
  { label: '2404 - PARAOPEBA', value: '2404' },
  { label: '2405 - PARAPUA', value: '2405' },
  { label: '2406 - PARATY', value: '2406' },
  { label: '2411 - PASSA TEMPO', value: '2411' },
  { label: '2414 - CORP BANK SOROCABA', value: '2414' },
  { label: '2417 - PAULINIA', value: '2417' },
  { label: '2419 - PAULO RAMOS', value: '2419' },
  { label: '2423 - PEDRA PRETA', value: '2423' },
  { label: '2424 - PEDRALVA', value: '2424' },
  { label: '2425 - PEDRAS DE FOGO', value: '2425' },
  { label: '2426 - PEDREGULHO', value: '2426' },
  { label: '2427 - PEDREIRA', value: '2427' },
  { label: '2428 - PEDRO SEGUNDO', value: '2428' },
  { label: '2431 - PEDRO GOMES', value: '2431' },
  { label: '2433 - PERDOES', value: '2433' },
  { label: '2434 - CORP BANK FARIA LIMA', value: '2434' },
  { label: '2436 - PERUIBE', value: '2436' },
  { label: '2437 - PESQUEIRA', value: '2437' },
  { label: '2441 - PICUI', value: '2441' },
  { label: '2442 - PILAO ARCADO', value: '2442' },
  { label: '2445 - HIGIENOPOLIS', value: '2445' },
  { label: '2446 - PILAR DO SUL', value: '2446' },
  { label: '2447 - UNICAMP', value: '2447' },
  { label: '2449 - PINDARE-MIRIM', value: '2449' },
  { label: '2450 - PINHAO', value: '2450' },
  { label: '2451 - PINHEIROS', value: '2451' },
  { label: '2453 - PIRACAIA', value: '2453' },
  { label: '2454 - PIRANGA', value: '2454' },
  { label: '2455 - PIRAPOZINHO', value: '2455' },
  { label: '2456 - PINHAIS', value: '2456' },
  { label: '2457 - PIRATININGA', value: '2457' },
  { label: '2459 - PIRITIBA', value: '2459' },
  { label: '2460 - PIRPIRITUBA', value: '2460' },
  { label: '2461 - PITANGUEIRAS', value: '2461' },
  { label: '2462 - PLANALTINA', value: '2462' },
  { label: '2463 - PLANALTO-RS', value: '2463' },
  { label: '2464 - PLANALTO-BA', value: '2464' },
  { label: '2466 - POA', value: '2466' },
  { label: '2468 - POCAO DE PEDRAS', value: '2468' },
  { label: '2469 - POCINHOS', value: '2469' },
  { label: '2470 - POCO FUNDO', value: '2470' },
  { label: '2474 - POMERODE', value: '2474' },
  { label: '2475 - POMPEU', value: '2475' },
  { label: '2477 - PONTAL', value: '2477' },
  { label: '2479 - PONTE SERRADA', value: '2479' },
  { label: '2480 - PONTES E LACERDA', value: '2480' },
  { label: '2483 - PORCIUNCULA', value: '2483' },
  { label: '2484 - PORTAO', value: '2484' },
  { label: '2486 - PORTEL', value: '2486' },
  { label: '2489 - PORTO SEGURO', value: '2489' },
  { label: '2490 - PORTO UNIAO', value: '2490' },
  { label: '2491 - PORTO XAVIER', value: '2491' },
  { label: '2492 - POTE', value: '2492' },
  { label: '2494 - POTIRENDABA', value: '2494' },
  { label: '2495 - POUSO REDONDO', value: '2495' },
  { label: '2498 - PRESIDENTE BERNARDES', value: '2498' },
  { label: '2499 - PRESIDENTE DUTRA', value: '2499' },
  { label: '2500 - BRAZLANDIA', value: '2500' },
  { label: '2501 - PRESIDENTE GETULIO', value: '2501' },
  { label: '2502 - EMPRESA V.IMPERIAL', value: '2502' },
  { label: '2503 - GECEX RIBEIRAO PRETO', value: '2503' },
  { label: '2504 - PRIMEIRO DE MAIO-PR', value: '2504' },
  { label: '2505 - S.JOSE QUATRO MARCOS', value: '2505' },
  { label: '2507 - QUEDAS DO IGUACU', value: '2507' },
  { label: '2508 - QUEIMADAS-PB', value: '2508' },
  { label: '2512 - QUIXERE', value: '2512' },
  { label: '2513 - EMPRESA S.J.CAMPOS', value: '2513' },
  { label: '2514 - REALEZA', value: '2514' },
  { label: '2515 - REBOUCAS', value: '2515' },
  { label: '2517 - REDENCAO', value: '2517' },
  { label: '2519 - REGENTE FEIJO', value: '2519' },
  { label: '2522 - RESENDE COSTA', value: '2522' },
  { label: '2523 - RESERVA', value: '2523' },
  { label: '2525 - RIACHAO DO DANTAS', value: '2525' },
  { label: '2526 - RIACHAO DAS NEVES', value: '2526' },
  { label: '2529 - RIBEIRAO', value: '2529' },
  { label: '2532 - RIBEIRAO DAS NEVES', value: '2532' },
  { label: '2533 - RIBEIRO GONCALVES', value: '2533' },
  { label: '2534 - RINOPOLIS', value: '2534' },
  { label: '2536 - RIO BRANCO', value: '2536' },
  { label: '2537 - RIO BRANCO DO SUL', value: '2537' },
  { label: '2538 - RIO CASCA', value: '2538' },
  { label: '2539 - RIO CLARO', value: '2539' },
  { label: '2540 - RIO DE CONTAS', value: '2540' },
  { label: '2542 - RIO LARGO', value: '2542' },
  { label: '2543 - RIO NEGRO', value: '2543' },
  { label: '2545 - RIO DO OESTE', value: '2545' },
  { label: '2546 - RIO PIRACICABA', value: '2546' },
  { label: '2547 - RIO TINTO', value: '2547' },
  { label: '2549 - RODEIO', value: '2549' },
  { label: '2553 - RONCADOR', value: '2553' },
  { label: '2554 - ROQUE GONZALES', value: '2554' },
  { label: '2555 - ROSARIO', value: '2555' },
  { label: '2556 - SABARA', value: '2556' },
  { label: '2557 - SABINOPOLIS', value: '2557' },
  { label: '2561 - SALETE', value: '2561' },
  { label: '2565 - SALTO DO LONTRA', value: '2565' },
  { label: '2567 - SALVADOR DO SUL', value: '2567' },
  { label: '2568 - SANTA ADELIA', value: '2568' },
  { label: '2570 - SANTA BARBARA-MG', value: '2570' },
  { label: '2572 - SANTA CECILIA', value: '2572' },
  { label: '2573 - SANTA CECILIA PAVAO', value: '2573' },
  { label: '2574 - SANTA CRUZ CABRALIA', value: '2574' },
  { label: '2575 - SANTA CRUZ M.CASTELO', value: '2575' },
  { label: '2576 - SETOR PUBLICO MS', value: '2576' },
  { label: '2577 - SANTA HELENA', value: '2577' },
  { label: '2578 - SANTA ISABEL', value: '2578' },
  { label: '2579 - SANTA IZABEL OESTE', value: '2579' },
  { label: '2580 - SANTA ISABEL DO PARA', value: '2580' },
  { label: '2581 - SANTA LUZIA-MA', value: '2581' },
  { label: '2582 - SANTA LUZIA', value: '2582' },
  { label: '2583 - SANTA MARGARIDA', value: '2583' },
  { label: '2584 - STA.MARIA DE ITABIRA', value: '2584' },
  { label: '2585 - SANTA MARIA MADALENA', value: '2585' },
  { label: '2586 - SANTA MARIA DO PARA', value: '2586' },
  { label: '2588 - SANTA RITA DE CALDAS', value: '2588' },
  { label: '2589 - STA.RITA PASSA QUATR', value: '2589' },
  { label: '2591 - EMPRESA UBERLANDIA', value: '2591' },
  { label: '2592 - JUIZ DE FORA', value: '2592' },
  { label: '2593 - SANTA VITORIA', value: '2593' },
  { label: '2594 - SANTANA DO ACARAU', value: '2594' },
  { label: '2595 - SANTANA DO ARAGUAIA', value: '2595' },
  { label: '2599 - SANTANA DA VARGEM', value: '2599' },
  { label: '2600 - STO.AMARO IMPERATRIZ', value: '2600' },
  { label: '2601 - SANTO ANTONIO AMPARO', value: '2601' },
  { label: '2602 - STO.ANTONIO JACINTO', value: '2602' },
  { label: '2606 - SAO BENEDITO', value: '2606' },
  { label: '2607 - SAO BENTO', value: '2607' },
  { label: '2608 - SAO BENTO DO SAPUCAI', value: '2608' },
  { label: '2609 - CORP BANK MS', value: '2609' },
  { label: '2612 - SAO DESIDERIO', value: '2612' },
  { label: '2613 - SAO DOMINGOS-SC', value: '2613' },
  { label: '2614 - S.DOMINGOS MARANHAO', value: '2614' },
  { label: '2615 - S.DOMINGOS DO PRATA', value: '2615' },
  { label: '2617 - EMPRESA BOA VISTA', value: '2617' },
  { label: '2620 - SAO GABRIEL DO OESTE', value: '2620' },
  { label: '2621 - S.GONCALO DO ABAETE', value: '2621' },
  { label: '2622 - SAO GONCALO AMARANTE', value: '2622' },
  { label: '2623 - IGAPO', value: '2623' },
  { label: '2627 - SAO JOAO DA BARRA', value: '2627' },
  { label: '2629 - SAO JOAO BATISTA', value: '2629' },
  { label: '2631 - SAO JOAO DO IVAI', value: '2631' },
  { label: '2634 - SAO JOAO DA PONTE', value: '2634' },
  { label: '2635 - SAO JOAO DO TRIUNFO', value: '2635' },
  { label: '2636 - ESCR.EXC.CAPITAL DF', value: '2636' },
  { label: '2638 - SAO JOSE', value: '2638' },
  { label: '2642 - SAO JOSE DE MIPIBU', value: '2642' },
  { label: '2644 - SAO JOSE DE PIRANHAS', value: '2644' },
  { label: '2645 - SAO JOSE DE RIBAMAR', value: '2645' },
  { label: '2646 - SAO JOSE DA TAPERA', value: '2646' },
  { label: '2648 - SAO LUIS PARAITINGA', value: '2648' },
  { label: '2650 - SAO MARTINHO', value: '2650' },
  { label: '2651 - SAO MATEUS MARANHAO', value: '2651' },
  { label: '2652 - SAO MIGUEL ARCANJO', value: '2652' },
  { label: '2653 - SAO MIGUEL DO GUAMA', value: '2653' },
  { label: '2655 - 2655', value: '2655' },
  { label: '2656 - SAO PEDRO', value: '2656' },
  { label: '2657 - SAO PEDRO DA ALDEIA', value: '2657' },
  { label: '2658 - SAO PEDRO DO PIAUI', value: '2658' },
  { label: '2659 - LARGE CORPORATE 2659', value: '2659' },
  { label: '2660 - SAO RAIMUNDO NONATO', value: '2660' },
  { label: '2662 - SAO SEBASTIAO-AL', value: '2662' },
  { label: '2663 - BAIRRO NITEROI', value: '2663' },
  { label: '2664 - SAO SEBASTIAO GRAMA', value: '2664' },
  { label: '2665 - AVENIDA DO CAFE', value: '2665' },
  { label: '2666 - SAO TIAGO', value: '2666' },
  { label: '2670 - SAPEACU', value: '2670' },
  { label: '2672 - SAPUCAIA DO SUL', value: '2672' },
  { label: '2673 - SAQUAREMA', value: '2673' },
  { label: '2677 - SENGES', value: '2677' },
  { label: '2678 - SENTO SE', value: '2678' },
  { label: '2679 - SERAFINA CORREA', value: '2679' },
  { label: '2680 - SERRA DOURADA', value: '2680' },
  { label: '2681 - SERRA NEGRA', value: '2681' },
  { label: '2682 - GECEX CAXIAS DO SUL', value: '2682' },
  { label: '2685 - SERTAO', value: '2685' },
  { label: '2686 - SETE BARRAS', value: '2686' },
  { label: '2687 - SETE QUEDAS', value: '2687' },
  { label: '2688 - SIDEROPOLIS', value: '2688' },
  { label: '2689 - SILVA JARDIM', value: '2689' },
  { label: '2691 - SIMAO DIAS', value: '2691' },
  { label: '2692 - BENTO BRASIL', value: '2692' },
  { label: '2694 - BENJAMIN CONSTANT-RS', value: '2694' },
  { label: '2695 - SOCORRO', value: '2695' },
  { label: '2696 - SOLANEA', value: '2696' },
  { label: '2698 - TABAPUA', value: '2698' },
  { label: '2699 - TABIRA', value: '2699' },
  { label: '2700 - TABOAO DA SERRA', value: '2700' },
  { label: '2701 - TABULEIRO DO NORTE', value: '2701' },
  { label: '2702 - TACARATU', value: '2702' },
  { label: '2704 - TAGUATINGA', value: '2704' },
  { label: '2705 - TAIOBEIRAS', value: '2705' },
  { label: '2706 - TAMBAU', value: '2706' },
  { label: '2707 - ESCR.EXC.JOINVILLE', value: '2707' },
  { label: '2709 - TAPEJARA', value: '2709' },
  { label: '2710 - TAPEROA', value: '2710' },
  { label: '2711 - TAQUARANA', value: '2711' },
  { label: '2712 - TAQUARITUBA', value: '2712' },
  { label: '2713 - TARAUACA', value: '2713' },
  { label: '2714 - TAVARES', value: '2714' },
  { label: '2716 - TEIXEIRAS', value: '2716' },
  { label: '2718 - TEODORO SAMPAIO-SP', value: '2718' },
  { label: '2720 - TERRA BOA', value: '2720' },
  { label: '2721 - TERRA ROXA', value: '2721' },
  { label: '2722 - TIBAGI', value: '2722' },
  { label: '2723 - TIJUCAS', value: '2723' },
  { label: '2724 - TIJUCAS DO SUL', value: '2724' },
  { label: '2726 - TIMON', value: '2726' },
  { label: '2727 - ASA NORTE 316', value: '2727' },
  { label: '2728 - TOCANTINS', value: '2728' },
  { label: '2731 - TOUROS', value: '2731' },
  { label: '2732 - TRAIRI', value: '2732' },
  { label: '2733 - TRAMANDAI', value: '2733' },
  { label: '2736 - TREZE DE MAIO', value: '2736' },
  { label: '2737 - TRINDADE', value: '2737' },
  { label: '2738 - TRINDADE-GO', value: '2738' },
  { label: '2739 - TRIUNFO-PE', value: '2739' },
  { label: '2740 - TRIUNFO-RS', value: '2740' },
  { label: '2741 - TUCUNDUVA', value: '2741' },
  { label: '2743 - TUNTUM', value: '2743' },
  { label: '2744 - TUPARENDI', value: '2744' },
  { label: '2745 - TURMALINA', value: '2745' },
  { label: '2746 - TUTOIA', value: '2746' },
  { label: '2747 - UBAI', value: '2747' },
  { label: '2748 - UBATUBA', value: '2748' },
  { label: '2750 - UMBAUBA', value: '2750' },
  { label: '2751 - URANDI', value: '2751' },
  { label: '2752 - URANIA', value: '2752' },
  { label: '2753 - URUANA', value: '2753' },
  { label: '2754 - URUBICI', value: '2754' },
  { label: '2755 - EMPRESA LONDRINA', value: '2755' },
  { label: '2757 - SETOR PUBLICO RO', value: '2757' },
  { label: '2759 - URUPES', value: '2759' },
  { label: '2760 - UTINGA', value: '2760' },
  { label: '2761 - VALENCA DO PIAUI', value: '2761' },
  { label: '2762 - VARGEM GRANDE', value: '2762' },
  { label: '2763 - VARGEM GRANDE DO SUL', value: '2763' },
  { label: '2764 - VARZEA GRANDE', value: '2764' },
  { label: '2765 - VARZEA DA PALMA', value: '2765' },
  { label: '2766 - VARZEA PAULISTA', value: '2766' },
  { label: '2768 - VERA CRUZ', value: '2768' },
  { label: '2770 - VESPASIANO', value: '2770' },
  { label: '2771 - VIANA-MA', value: '2771' },
  { label: '2773 - VICOSA DO CEARA', value: '2773' },
  { label: '2774 - VICTOR GRAEFF', value: '2774' },
  { label: '2775 - VIDAL RAMOS', value: '2775' },
  { label: '2776 - AFUBRA', value: '2776' },
  { label: '2777 - VIRADOURO', value: '2777' },
  { label: '2780 - VIRGINOPOLIS', value: '2780' },
  { label: '2781 - TAQUARALTO', value: '2781' },
  { label: '2782 - VITORINO FREIRE', value: '2782' },
  { label: '2784 - ABOLICAO', value: '2784' },
  { label: '2786 - XINGUARA', value: '2786' },
  { label: '2787 - JOAO LISBOA', value: '2787' },
  { label: '2788 - NOVA SOURE', value: '2788' },
  { label: '2790 - MONTE AZUL', value: '2790' },
  { label: '2791 - MONTE SIAO', value: '2791' },
  { label: '2792 - FRANCISCO MORATO', value: '2792' },
  { label: '2793 - ALDEOTA', value: '2793' },
  { label: '2795 - RECREIO BANDEIRANTES', value: '2795' },
  { label: '2797 - ZONA NORTE', value: '2797' },
  { label: '2798 - BAIXA DOS SAPATEIROS', value: '2798' },
  { label: '2799 - EMPRESA BARRA AVENID', value: '2799' },
  { label: '2800 - PARQUE TOMAS EDSON', value: '2800' },
  { label: '2801 - BUTANTA', value: '2801' },
  { label: '2802 - CASA AMARELA', value: '2802' },
  { label: '2803 - ROCKEFELLER-PR', value: '2803' },
  { label: '2804 - CUPECE', value: '2804' },
  { label: '2806 - BAIRRO PETROPOLIS', value: '2806' },
  { label: '2807 - ITAIM BIBI', value: '2807' },
  { label: '2809 - AV.BRIG.LUIZ ANTONIO', value: '2809' },
  { label: '2810 - LARANJEIRAS', value: '2810' },
  { label: '2811 - CONSELHEIRO AGUIAR', value: '2811' },
  { label: '2812 - MONTESE', value: '2812' },
  { label: '2814 - PARTENON', value: '2814' },
  { label: '2815 - PIRITUBA', value: '2815' },
  { label: '2816 - PITUBA', value: '2816' },
  { label: '2817 - MOINHOS DE VENTO', value: '2817' },
  { label: '2818 - AVENIDA JOAO CESAR', value: '2818' },
  { label: '2821 - CAVALHADA', value: '2821' },
  { label: '2823 - HAUER', value: '2823' },
  { label: '2825 - AV.CORIOLANO JUCA', value: '2825' },
  { label: '2826 - SAO BERNARDO', value: '2826' },
  { label: '2827 - ASTOLFO DUTRA', value: '2827' },
  { label: '2828 - BARAUNA', value: '2828' },
  { label: '2829 - CRISTAIS', value: '2829' },
  { label: '2830 - CURACA', value: '2830' },
  { label: '2832 - IBIRAIARAS', value: '2832' },
  { label: '2833 - ILHA SOLTEIRA', value: '2833' },
  { label: '2834 - IPUMIRIM', value: '2834' },
  { label: '2835 - JACUI', value: '2835' },
  { label: '2836 - JUARA', value: '2836' },
  { label: '2838 - MAJOR VIEIRA', value: '2838' },
  { label: '2840 - NOVA BASSANO', value: '2840' },
  { label: '2841 - GECEX OPERACOES SP', value: '2841' },
  { label: '2842 - SAO PEDRO DO IVAI', value: '2842' },
  { label: '2844 - BARRAS', value: '2844' },
  { label: '2845 - BARRO', value: '2845' },
  { label: '2846 - BARROS CASSAL', value: '2846' },
  { label: '2847 - BASTOS', value: '2847' },
  { label: '2848 - BATAYPORA', value: '2848' },
  { label: '2849 - BAYEUX', value: '2849' },
  { label: '2850 - BEBERIBE', value: '2850' },
  { label: '2851 - BELA CRUZ', value: '2851' },
  { label: '2852 - BELA VISTA DE GOIAS', value: '2852' },
  { label: '2856 - BELO CAMPO', value: '2856' },
  { label: '2857 - EMPRESA GLICERIO', value: '2857' },
  { label: '2859 - CARLOS BARBOSA', value: '2859' },
  { label: '2862 - PONTAL RJ', value: '2862' },
  { label: '2863 - CONJUNTO NACIONAL', value: '2863' },
  { label: '2864 - ACESITA', value: '2864' },
  { label: '2866 - LITORAL NORTE-BA', value: '2866' },
  { label: '2867 - CACHOEIRINHA-RS', value: '2867' },
  { label: '2869 - ITOUPAVA NORTE', value: '2869' },
  { label: '2870 - EMPRESA ALECRIM', value: '2870' },
  { label: '2871 - NOSSA SRA.DE LOURDES', value: '2871' },
  { label: '2874 - POTIGUAR', value: '2874' },
  { label: '2875 - PARQUE IND.CUMBICA', value: '2875' },
  { label: '2876 - VILA GALVAO', value: '2876' },
  { label: '2877 - EMPRESA VALE DO ACO', value: '2877' },
  { label: '2878 - NORDESTAO', value: '2878' },
  { label: '2879 - DISTRITO INDUSTRIAL', value: '2879' },
  { label: '2881 - 2881', value: '2881' },
  { label: '2883 - 2883', value: '2883' },
  { label: '2884 - TRES VENDAS', value: '2884' },
  { label: '2885 - IMPERADOR', value: '2885' },
  { label: '2887 - JARDIM BOTANICO-DF', value: '2887' },
  { label: '2889 - CEASA-RECIFE', value: '2889' },
  { label: '2890 - EMPRESA AV.SAUDADE', value: '2890' },
  { label: '2891 - AV.TREZE DE MAIO', value: '2891' },
  { label: '2892 - CEILANDIA NORTE', value: '2892' },
  { label: '2893 - PRESIDENTE VARGAS', value: '2893' },
  { label: '2895 - SAMAMBAIA', value: '2895' },
  { label: '2896 - GONZAGA', value: '2896' },
  { label: '2897 - RUDGE RAMOS', value: '2897' },
  { label: '2898 - VILA GERTI', value: '2898' },
  { label: '2899 - ALCANTARA', value: '2899' },
  { label: '2901 - NUCLEO BANDEIRANTE', value: '2901' },
  { label: '2902 - GAMA LESTE', value: '2902' },
  { label: '2903 - AVENIDA IMPERADOR', value: '2903' },
  { label: '2904 - SCHARLAU', value: '2904' },
  { label: '2905 - AV.DJALMA BATISTA', value: '2905' },
  { label: '2906 - AV.OSORIO DE PAIVA', value: '2906' },
  { label: '2907 - ICARAI', value: '2907' },
  { label: '2909 - BARRASHOPPING', value: '2909' },
  { label: '2910 - VILA DA QUINTA', value: '2910' },
  { label: '2911 - CEILANDIA CENTRO', value: '2911' },
  { label: '2912 - GUARA I', value: '2912' },
  { label: '2913 - EMPRESA TAQUARAL', value: '2913' },
  { label: '2914 -  PENHA-RIO DE JANEIRO,RJ', value: '2914' },
  { label: '2916 - VIVENDAS', value: '2916' },
  { label: '2917 - AV.PONTES VIEIRA', value: '2917' },
  { label: '2918 - FLORIANO PEIXOTO', value: '2918' },
  { label: '2919 - AGUA SANTA', value: '2919' },
  { label: '2920 - AGUA VERDE', value: '2920' },
  { label: '2922 - VILA SANTA CECILIA', value: '2922' },
  { label: '2923 - ALEM PONTE', value: '2923' },
  { label: '2925 - AVENIDA JOSE BASTOS', value: '2925' },
  { label: '2926 - ALTO DA XV', value: '2926' },
  { label: '2927 - ALTO GARCAS', value: '2927' },
  { label: '2930 - ANA LUCIA', value: '2930' },
  { label: '2933 - BARAO DE MESQUITA', value: '2933' },
  { label: '2935 - ANTONIO DE BARROS', value: '2935' },
  { label: '2936 - EMPRESA GUAICURUS', value: '2936' },
  { label: '2937 - EMPRESA AV.W.SOARES', value: '2937' },
  { label: '2939 - ARAPUTANGA', value: '2939' },
  { label: '2941 - AREAL', value: '2941' },
  { label: '2942 - RUA LOBO DA COSTA', value: '2942' },
  { label: '2946 - DOCA', value: '2946' },
  { label: '2948 - AURELINO LEAL', value: '2948' },
  { label: '2949 - AUTONOMISTAS', value: '2949' },
  { label: '2950 - AV.BENTO GONCALVES', value: '2950' },
  { label: '2951 - AVENIDA BANDEIRANTES', value: '2951' },
  { label: '2952 - AV.BRASIL-CACH.SUL', value: '2952' },
  { label: '2953 - AREINHA', value: '2953' },
  { label: '2954 - RENASCENCA', value: '2954' },
  { label: '2957 - EMPRESA PIEDADE', value: '2957' },
  { label: '2958 - CORONEL MARCONDES', value: '2958' },
  { label: '2959 - AV.CORONEL ANTONINO', value: '2959' },
  { label: '2960 - BAIRRO DO CPA', value: '2960' },
  { label: '2963 - AV.GOV.JULIO CAMPOS', value: '2963' },
  { label: '2964 - CAJAZEIRAS', value: '2964' },
  { label: '2967 - EMPRESA COMERCIO', value: '2967' },
  { label: '2969 - AV.OSVALDO ARANHA', value: '2969' },
  { label: '2971 - JORGE AMADO', value: '2971' },
  { label: '2972 - PALACIO DOS LEOES', value: '2972' },
  { label: '2973 - AV.PRESIDENTE VARGAS', value: '2973' },
  { label: '2975 - AVENIDA RIO BRANCO', value: '2975' },
  { label: '2976 - EMPRESA MANOEL DIAS', value: '2976' },
  { label: '2978 - GECEX SALVADOR', value: '2978' },
  { label: '2981 - BAIRRO ANITA GARIBAL', value: '2981' },
  { label: '2985 - VILA BELMIRO', value: '2985' },
  { label: '2987 - BAIRRO OURO BRANCO', value: '2987' },
  { label: '2988 - SHOPPING GUARARAPES', value: '2988' },
  { label: '2989 - WASHINGTON LUIZ', value: '2989' },
  { label: '2990 - BAIRRO RIO BRANCO', value: '2990' },
  { label: '2991 - AV.ORLANDO DOMPIERI', value: '2991' },
  { label: '2995 - SAO MATEUS', value: '2995' },
  { label: '2996 - AVENIDA MUTINGA', value: '2996' },
  { label: '2997 - LUIS E.MAGALHAES', value: '2997' },
  { label: '3003 - IGUACU', value: '3003' },
  { label: '3004 - BAIRRO INDUSTRIAL', value: '3004' },
  { label: '3005 - BAIRRO JUNDIAI', value: '3005' },
  { label: '3007 - EMPRESA ROCKEFELLER', value: '3007' },
  { label: '3008 - CACHOEIRINHA-SP', value: '3008' },
  { label: '3010 - EMPRESA B.MESQUITA', value: '3010' },
  { label: '3011 - GUAIANASES', value: '3011' },
  { label: '3012 - BARRA DO RIO CERRO', value: '3012' },
  { label: '3013 - BARREIROS', value: '3013' },
  { label: '3014 - BARRO PRETO', value: '3014' },
  { label: '3015 - BAURU SHOPPING', value: '3015' },
  { label: '3016 - BENFICA-MG', value: '3016' },
  { label: '3017 - EMPRESA FREGUESIA', value: '3017' },
  { label: '3018 - BOA VISTA', value: '3018' },
  { label: '3019 - BOM JARDIM DE GOIAS', value: '3019' },
  { label: '3020 - BOQUEIRAO-PR', value: '3020' },
  { label: '3021 - BOQUEIRAO-SP', value: '3021' },
  { label: '3022 - BOSQUE', value: '3022' },
  { label: '3024 - NAZARE', value: '3024' },
  { label: '3025 - BROTAS', value: '3025' },
  { label: '3026 - ALFONSO BOVERO', value: '3026' },
  { label: '3027 - EMPRESA SAO MIGUEL', value: '3027' },
  { label: '3028 - PELINCA', value: '3028' },
  { label: '3029 - CACHOEIRA PAULISTA', value: '3029' },
  { label: '3030 - CAFELANDIA', value: '3030' },
  { label: '3031 - CAJOBI', value: '3031' },
  { label: '3032 - GUTIERREZ', value: '3032' },
  { label: '3034 - CAMBUI', value: '3034' },
  { label: '3035 - CAMPINAPOLIS', value: '3035' },
  { label: '3036 - CAMPO NOVO PARECIS', value: '3036' },
  { label: '3037 - CAMPO VERDE', value: '3037' },
  { label: '3038 - CAMPOS ALTOS', value: '3038' },
  { label: '3039 - PORTAL DO MORUMBI', value: '3039' },
  { label: '3041 - EMPRESA VISCONDE', value: '3041' },
  { label: '3043 - RUA TEODORO SAMPAIO', value: '3043' },
  { label: '3046 - CAPIM GROSSO', value: '3046' },
  { label: '3047 - CAPOEIRAS', value: '3047' },
  { label: '3048 - CARAMBEI', value: '3048' },
  { label: '3049 - CARAPINA', value: '3049' },
  { label: '3050 - VILA LEOPOLDINA', value: '3050' },
  { label: '3052 - VILA SABRINA', value: '3052' },
  { label: '3053 - ADRIANOPOLIS', value: '3053' },
  { label: '3057 - CAMPUS UNIVERSITARIO', value: '3057' },
  { label: '3058 - CORONEL NIEDERAUER', value: '3058' },
  { label: '3061 - PRACA ABC', value: '3061' },
  { label: '3062 - EMPRESA SAO CARLOS', value: '3062' },
  { label: '3063 - CENTRO EMPRESARIAL', value: '3063' },
  { label: '3064 - LARGE CORPORATE 3064', value: '3064' },
  { label: '3066 - CHAPADAO DO SUL', value: '3066' },
  { label: '3067 - CHARQUEADAS', value: '3067' },
  { label: '3068 - CIDADE NOVA-MG', value: '3068' },
  { label: '3069 - AV.BRASIL-FRANCA', value: '3069' },
  { label: '3070 - LARGE CORPORATE 3070', value: '3070' },
  { label: '3071 - SAO CLEMENTE', value: '3071' },
  { label: '3072 - COCAL DO SUL', value: '3072' },
  { label: '3074 - BATISTA CAMPOS', value: '3074' },
  { label: '3077 - COQUEIROS', value: '3077' },
  { label: '3078 - CORAL', value: '3078' },
  { label: '3079 - ESCR.EXC.C.OLIMPICA', value: '3079' },
  { label: '3081 - CORP BANK JUNDIAI', value: '3081' },
  { label: '3082 - EMPRESA CPO GRANDE', value: '3082' },
  { label: '3083 - MORUNGABA', value: '3083' },
  { label: '3089 - PRACA SECA', value: '3089' },
  { label: '3090 - DIAS DA CRUZ', value: '3090' },
  { label: '3091 - DIAS D AVILA', value: '3091' },
  { label: '3094 - ESTILO TIJUCA', value: '3094' },
  { label: '3096 - HADDOCK LOBO', value: '3096' },
  { label: '3097 - AVENIDA DAS AMERICAS', value: '3097' },
  { label: '3098 - DR.MAURICIO CARDOSO', value: '3098' },
  { label: '3101 - PRACA DO CARMO', value: '3101' },
  { label: '3105 - ENTRE-IJUIS', value: '3105' },
  { label: '3106 - CASTANHEIRA', value: '3106' },
  { label: '3107 - ERMELINO MATARAZZO', value: '3107' },
  { label: '3108 - ESPINHEIRO', value: '3108' },
  { label: '3110 - ESTACIO DE SA', value: '3110' },
  { label: '3111 - JARDIM GUANABARA', value: '3111' },
  { label: '3118 - FATIMA-RJ', value: '3118' },
  { label: '3121 - VILA XAVIER', value: '3121' },
  { label: '3123 - FORMOSO DO ARAGUAIA', value: '3123' },
  { label: '3124 - FRAGATA', value: '3124' },
  { label: '3125 - CORP BANK SC', value: '3125' },
  { label: '3126 - GARCIA', value: '3126' },
  { label: '3127 - EMPRESA CAMPOS', value: '3127' },
  { label: '3128 - AV.MARIA QUITERIA', value: '3128' },
  { label: '3129 - GILBERTO SALOMAO', value: '3129' },
  { label: '3130 - GLORIA', value: '3130' },
  { label: '3131 - EMPRESA SAO BERNARDO', value: '3131' },
  { label: '3132 - LARGE CORPORATE 3132', value: '3132' },
  { label: '3134 - PRACA VINTE', value: '3134' },
  { label: '3135 - SAO VITO', value: '3135' },
  { label: '3136 - AVENIDA PIRACICABA', value: '3136' },
  { label: '3137 - DELTA DO PARNAIBA', value: '3137' },
  { label: '3139 - HALFELD', value: '3139' },
  { label: '3140 - HERACLITO GRACA', value: '3140' },
  { label: '3142 - HIGIENOPOLIS', value: '3142' },
  { label: '3143 - HOLAMBRA', value: '3143' },
  { label: '3144 - IBATE', value: '3144' },
  { label: '3145 - JOSE MENINO', value: '3145' },
  { label: '3146 - EMPRESA PORTO SANTOS', value: '3146' },
  { label: '3148 - ILHOTA', value: '3148' },
  { label: '3149 - CORP BANK PIRACICABA', value: '3149' },
  { label: '3150 - 3150', value: '3150' },
  { label: '3153 - EMPRESA DOURADOS', value: '3153' },
  { label: '3154 - ITOUPAVA CENTRAL', value: '3154' },
  { label: '3155 - EMPRESA PRINCIPE', value: '3155' },
  { label: '3156 - IPUA', value: '3156' },
  { label: '3158 - SHOPPING ITAIGARA', value: '3158' },
  { label: '3159 - ITAIPAVA', value: '3159' },
  { label: '3162 - ITAMONTE', value: '3162' },
  { label: '3163 - PORTAL', value: '3163' },
  { label: '3164 - ITAPEMA MEIA PRAIA', value: '3164' },
  { label: '3165 - BAIRRO BESSA', value: '3165' },
  { label: '3166 - ITUPEVA', value: '3166' },
  { label: '3167 - JACARAIPE', value: '3167' },
  { label: '3168 - CORP BANK RS', value: '3168' },
  { label: '3172 - JARDIM SABARA', value: '3172' },
  { label: '3173 - CANASVIEIRAS', value: '3173' },
  { label: '3174 - EMPRESA NEREU RAMOS', value: '3174' },
  { label: '3175 - JARDINS-BA', value: '3175' },
  { label: '3178 - JOQUEI CLUBE', value: '3178' },
  { label: '3179 - PRACA DOS MARTIRIOS', value: '3179' },
  { label: '3180 - LARGE CORPORATE 3180', value: '3180' },
  { label: '3181 - NACOES UNIDAS', value: '3181' },
  { label: '3183 - GRUTA DE LOURDES', value: '3183' },
  { label: '3184 - JUVEVE', value: '3184' },
  { label: '3185 - LAGOA DA CONCEICAO', value: '3185' },
  { label: '3186 - PONTA VERDE', value: '3186' },
  { label: '3187 - LAGUNA CARAPA', value: '3187' },
  { label: '3188 - TEUTONIA', value: '3188' },
  { label: '3189 - LARGO DA PENHA', value: '3189' },
  { label: '3191 - 3191', value: '3191' },
  { label: '3192 - MALHADO', value: '3192' },
  { label: '3194 - JARDIM CAMBURI', value: '3194' },
  { label: '3196 - LUCAS DO RIO VERDE', value: '3196' },
  { label: '3197 - AVENIDA PEDRO PINHO', value: '3197' },
  { label: '3199 - CACHAMBI', value: '3199' },
  { label: '3201 - MAE DO RIO', value: '3201' },
  { label: '3204 - EMPRESA MANAIRA', value: '3204' },
  { label: '3205 - MANOEL HONORIO', value: '3205' },
  { label: '3206 - MARACANA', value: '3206' },
  { label: '3207 - MARATAIZES', value: '3207' },
  { label: '3208 - MARECHAL FLORIANO', value: '3208' },
  { label: '3209 - EMPRESA M.CLAROS', value: '3209' },
  { label: '3210 - MATIAS BARBOSA', value: '3210' },
  { label: '3211 - SANTA HELENA', value: '3211' },
  { label: '3212 - MATOZINHOS', value: '3212' },
  { label: '3213 - MAXI SHOPPING', value: '3213' },
  { label: '3214 - MEDICILANDIA', value: '3214' },
  { label: '3217 - MONSENHOR PAULO', value: '3217' },
  { label: '3219 - EMPRESA FREI SERAFIM', value: '3219' },
  { label: '3220 - PIO X', value: '3220' },
  { label: '3221 - CORP BANK A PAULISTA', value: '3221' },
  { label: '3222 - CORP BANK GUARULHOS', value: '3222' },
  { label: '3223 - COLOMBO-COPACABANA', value: '3223' },
  { label: '3225 - NOVA ERA', value: '3225' },
  { label: '3226 - EMPRESA GET.VARGAS', value: '3226' },
  { label: '3228 - NOVA MUTUM', value: '3228' },
  { label: '3229 - FLAMBOYANT', value: '3229' },
  { label: '3231 - NOVA PORTO VELHO', value: '3231' },
  { label: '3234 - SETOR PUBLICO PE', value: '3234' },
  { label: '3235 - EMPRESA NOVE DE JULH', value: '3235' },
  { label: '3237 - ESTILO RECIFE', value: '3237' },
  { label: '3238 - OXFORD', value: '3238' },
  { label: '3240 - CENTRO HISTORICO', value: '3240' },
  { label: '3242 - PREF.MUN.RECIFE', value: '3242' },
  { label: '3244 - PARAISO DO SUL', value: '3244' },
  { label: '3245 - PARAUAPEBAS', value: '3245' },
  { label: '3246 - PAROBE', value: '3246' },
  { label: '3248 - PARQUE SAO VICENTE', value: '3248' },
  { label: '3250 - SHOPPING RECIFE', value: '3250' },
  { label: '3252 - EMPRESA FARRAPOS', value: '3252' },
  { label: '3253 - BARAO DO RIO BRANCO', value: '3253' },
  { label: '3254 - PEIXOTO', value: '3254' },
  { label: '3255 - TRIBUNAIS', value: '3255' },
  { label: '3257 - BALNEARIO PICARRAS', value: '3257' },
  { label: '3258 - PRAIA DE BOA VIAGEM', value: '3258' },
  { label: '3259 - PINHEIRAL', value: '3259' },
  { label: '3261 - PIRANGI', value: '3261' },
  { label: '3262 - 3262', value: '3262' },
  { label: '3263 - PIRAQUARA', value: '3263' },
  { label: '3264 - SHOPPING PLANALTINA', value: '3264' },
  { label: '3266 - PLANALTO', value: '3266' },
  { label: '3267 - PLANURA', value: '3267' },
  { label: '3268 - POJUCA', value: '3268' },
  { label: '3270 - PONTE DA AMIZADE', value: '3270' },
  { label: '3272 - PORTO BELO', value: '3272' },
  { label: '3273 - CAPITAL ECOLOGICA', value: '3273' },
  { label: '3274 - PORTO TROMBETAS', value: '3274' },
  { label: '3275 - BAIRRO ALTO', value: '3275' },
  { label: '3278 - SANTA MARIA', value: '3278' },
  { label: '3280 - PRACA DE FATIMA', value: '3280' },
  { label: '3282 - SHOPPING RIO VERDE', value: '3282' },
  { label: '3283 - EMPRESA RONDONOPOLIS', value: '3283' },
  { label: '3284 - CANCAO', value: '3284' },
  { label: '3285 - PRACA RIO BRANCO', value: '3285' },
  { label: '3288 - PRACA DAS MAES', value: '3288' },
  { label: '3290 - PRIMAVERA DO LESTE', value: '3290' },
  { label: '3291 - PRIMAVERA', value: '3291' },
  { label: '3292 - SAO JOAO', value: '3292' },
  { label: '3293 - PRUDENTE DE MORAIS', value: '3293' },
  { label: '3294 - BELVEDERE', value: '3294' },
  { label: '3295 - ANCHIETA-MG', value: '3295' },
  { label: '3296 - AV.13 DE MAIO', value: '3296' },
  { label: '3297 - PADRE EUSTAQUIO', value: '3297' },
  { label: '3298 - RUBEM BRAGA', value: '3298' },
  { label: '3300 - RUA MARCILIO DIAS', value: '3300' },
  { label: '3302 - MARACANAU', value: '3302' },
  { label: '3304 - PRIMEIRO DE MAIO-SP', value: '3304' },
  { label: '3306 - CORP BANK PARANA', value: '3306' },
  { label: '3307 - CORP BANK C OESTE', value: '3307' },
  { label: '3308 - CORP BANK MG', value: '3308' },
  { label: '3309 - CORP BANK RJ', value: '3309' },
  { label: '3310 - ESPLANADA SHOPPING', value: '3310' },
  { label: '3311 - PRACA DA BIBLIA', value: '3311' },
  { label: '3312 - PRESIDENTE VARGAS', value: '3312' },
  { label: '3315 - RIO DAS OSTRAS', value: '3315' },
  { label: '3316 - RIO DOS CEDROS', value: '3316' },
  { label: '3317 - LABREA', value: '3317' },
  { label: '3318 - RIO MARIA', value: '3318' },
  { label: '3320 - CORP BANK AGUA BCA', value: '3320' },
  { label: '3322 - CORP BANK I', value: '3322' },
  { label: '3325 - GOIABEIRAS', value: '3325' },
  { label: '3327 - JUVENTUS', value: '3327' },
  { label: '3328 - VICENTE MACHADO', value: '3328' },
  { label: '3329 - RUA GOIAS', value: '3329' },
  { label: '3331 - BORBOREMA', value: '3331' },
  { label: '3332 - MANGABEIRAS-AL', value: '3332' },
  { label: '3333 - CORP BANK LESTE SP', value: '3333' },
  { label: '3335 - SALDANHA MARINHO', value: '3335' },
  { label: '3336 - CORP BANK JARDINS', value: '3336' },
  { label: '3337 - SANCLERLANDIA', value: '3337' },
  { label: '3338 - SANDRA REGINA', value: '3338' },
  { label: '3341 - SANTA CRUZ PALMEIRAS', value: '3341' },
  { label: '3342 - SANTA JULIANA', value: '3342' },
  { label: '3344 - CORP BANK CENTRO SP', value: '3344' },
  { label: '3345 - SANTA ROSA VITERBO', value: '3345' },
  { label: '3346 - SANTANA', value: '3346' },
  { label: '3347 - CORP BANK II', value: '3347' },
  { label: '3348 - CORP BANK ALPHAVILLE', value: '3348' },
  { label: '3350 - SAO BENEDITO', value: '3350' },
  { label: '3351 - SAO BENEDITO', value: '3351' },
  { label: '3354 - LARGO DO BICAO', value: '3354' },
  { label: '3357 - CORP BANK ABC SUL', value: '3357' },
  { label: '3358 - CORP BANK VL PARAIBA', value: '3358' },
  { label: '3359 - CORP BANK ABC LESTE', value: '3359' },
  { label: '3360 - CORP BANK N CAMPINAS', value: '3360' },
  { label: '3361 - SAO JOSE', value: '3361' },
  { label: '3362 - CORP BANK M CAMPINAS', value: '3362' },
  { label: '3364 - SAO ROQUE DO CANAA', value: '3364' },
  { label: '3368 - SAVASSI', value: '3368' },
  { label: '3369 - CORP BANK O PAULISTA', value: '3369' },
  { label: '3370 - CORP BANK RIB SUL', value: '3370' },
  { label: '3371 - CORP BANK RIO PRETO', value: '3371' },
  { label: '3372 - SENADOR LEMOS', value: '3372' },
  { label: '3373 - ESCR.EXC.TAGUATINGA', value: '3373' },
  { label: '3374 - SERRA DOS CARAJAS', value: '3374' },
  { label: '3375 - SERRANA', value: '3375' },
  { label: '3378 - PARQUE 10', value: '3378' },
  { label: '3380 - SUDOESTE 105', value: '3380' },
  { label: '3382 - CORP BANK DF', value: '3382' },
  { label: '3383 - EMPRESA LIMEIRA', value: '3383' },
  { label: '3384 - PAULISTA', value: '3384' },
  { label: '3385 - SHOPPING BARRA', value: '3385' },
  { label: '3388 - CORP BANK GOIAS', value: '3388' },
  { label: '3390 - SANTA FELICIDADE', value: '3390' },
  { label: '3391 - STA.TEREZINHA ITAIPU', value: '3391' },
  { label: '3392 - CORP BANK TIRADENTES', value: '3392' },
  { label: '3393 - TABULEIRO DO MARTINS', value: '3393' },
  { label: '3394 - CORP BANK VILA RICA', value: '3394' },
  { label: '3396 - TAMBAU', value: '3396' },
  { label: '3397 - TAPIRATIBA', value: '3397' },
  { label: '3398 - CORP BANK IV', value: '3398' },
  { label: '3399 - CORP BANK PARA', value: '3399' },
  { label: '3400 - LARGE CORPORATE 3400', value: '3400' },
  { label: '3402 - CORP BANK OESTE PR', value: '3402' },
  { label: '3403 - TRES CACHOEIRAS', value: '3403' },
  { label: '3404 - CORP BANK CTBA NORTE', value: '3404' },
  { label: '3405 - EMPRESA ARARAQUARA', value: '3405' },
  { label: '3406 - CORP BANK CTBA SUL', value: '3406' },
  { label: '3407 - CORP BANK NORTE PR', value: '3407' },
  { label: '3408 - UCHOA', value: '3408' },
  { label: '3409 - CORP BANK NOROESTE', value: '3409' },
  { label: '3410 - URUARA', value: '3410' },
  { label: '3411 - VALPARAISO DE GOIAS', value: '3411' },
  { label: '3412 - CORP BANK S GAUCHA', value: '3412' },
  { label: '3413 - BRASILIA SHOPPING', value: '3413' },
  { label: '3414 - CORP BANK V SINOS', value: '3414' },
  { label: '3415 - CORP BANK POA NORTE', value: '3415' },
  { label: '3416 - VICENTINOPOLIS', value: '3416' },
  { label: '3418 - CORP BANK POA SUL', value: '3418' },
  { label: '3420 - CORP BANK V ITAJAI', value: '3420' },
  { label: '3421 - VILA BRASILIA', value: '3421' },
  { label: '3422 - CORP BANK SUL SC', value: '3422' },
  { label: '3424 - ARTUR ALVIM', value: '3424' },
  { label: '3425 - CORP BANK FLORIANOP', value: '3425' },
  { label: '3426 - PARQUE DOS IPES', value: '3426' },
  { label: '3428 - CORP BANK NORTE SC', value: '3428' },
  { label: '3429 - CORP BANK BAHIA', value: '3429' },
  { label: '3430 - ESCR.EXC.APOTEOSE', value: '3430' },
  { label: '3431 - CORP BANK ES', value: '3431' },
  { label: '3433 - CORP BANK PERNAMBUCO', value: '3433' },
  { label: '3434 - CORP BANK NORDESTE', value: '3434' },
  { label: '3435 - VILA PIRES', value: '3435' },
  { label: '3437 - CORP BANK FLUMINENSE', value: '3437' },
  { label: '3441 - VISCONDE DE PIRAJA', value: '3441' },
  { label: '3442 - XEREM', value: '3442' },
  { label: '3447 - TRT-BA-SALVADOR', value: '3447' },
  { label: '3449 - VASCO DA GAMA', value: '3449' },
  { label: '3455 - CORP BANK GUANABARA', value: '3455' },
  { label: '3457 - UFBA-ONDINA', value: '3457' },
  { label: '3459 - GRACA', value: '3459' },
  { label: '3460 - IMBUI', value: '3460' },
  { label: '3463 - PORTO SECO PIRAJA', value: '3463' },
  { label: '3468 - PRAIA DE IRACEMA', value: '3468' },
  { label: '3469 - FRANCISCO SA', value: '3469' },
  { label: '3470 - S.JOSE VALE R.PRETO', value: '3470' },
  { label: '3472 - PARANGABA', value: '3472' },
  { label: '3473 - PAPICU', value: '3473' },
  { label: '3474 - SEIS BOCAS', value: '3474' },
  { label: '3475 - 3475', value: '3475' },
  { label: '3477 - 3477', value: '3477' },
  { label: '3478 - EMPRESA SUL', value: '3478' },
  { label: '3479 - COMPENSA', value: '3479' },
  { label: '3480 - JUCUTUQUARA', value: '3480' },
  { label: '3482 - AV.CASTELO BRANCO', value: '3482' },
  { label: '3483 - EMPRESA TAMANDARE', value: '3483' },
  { label: '3485 - SANTA GENOVEVA', value: '3485' },
  { label: '3486 - SETOR PEDRO LUDOVICO', value: '3486' },
  { label: '3489 - 3489', value: '3489' },
  { label: '3490 - CIDADE JARDIM', value: '3490' },
  { label: '3491 - SHOPPING DEL REY', value: '3491' },
  { label: '3493 - NOVA SUICA', value: '3493' },
  { label: '3494 - CENTRO CULTURAL', value: '3494' },
  { label: '3495 - EMPRESA CONTORNO', value: '3495' },
  { label: '3496 - JARDIM DOS ESTADOS', value: '3496' },
  { label: '3497 - JULIO DE CASTILHOS', value: '3497' },
  { label: '3499 - AV.RUBENS MENDONCA', value: '3499' },
  { label: '3500 - BARCARENA', value: '3500' },
  { label: '3501 - MANGABEIRA', value: '3501' },
  { label: '3502 - TORRE', value: '3502' },
  { label: '3503 - ABREU E LIMA', value: '3503' },
  { label: '3504 - CAMARAGIBE', value: '3504' },
  { label: '3506 - PRACA DO MARQUES', value: '3506' },
  { label: '3507 - SAO CRISTOVAO', value: '3507' },
  { label: '3508 - MIGRANTE', value: '3508' },
  { label: '3509 - AV.BANDEIRANTES', value: '3509' },
  { label: '3512 - CIDADE VERDE-PR', value: '3512' },
  { label: '3515 - EMPRESA ALDEOTA', value: '3515' },
  { label: '3517 - FREGUESIA', value: '3517' },
  { label: '3519 - EMPRESA R.PASSAGEM', value: '3519' },
  { label: '3520 - PEDRO LESSA', value: '3520' },
  { label: '3522 - MADUREIRA CENTRO', value: '3522' },
  { label: '3525 - TIROL', value: '3525' },
  { label: '3526 - ALBERTO MARANHAO', value: '3526' },
  { label: '3527 - CHACARA DAS PEDRAS', value: '3527' },
  { label: '3529 - AVENIDA JULIO', value: '3529' },
  { label: '3534 - BAIRRO BOQUEIRAO', value: '3534' },
  { label: '3535 - CENTRO INDUSTRIAL', value: '3535' },
  { label: '3537 - MENINO DEUS', value: '3537' },
  { label: '3539 - IRIRIU', value: '3539' },
  { label: '3540 - MARGEM ESQUERDA', value: '3540' },
  { label: '3542 - BAIRRO SAO CRISTOVAO', value: '3542' },
  { label: '3545 - AUGUSTO FRANCO', value: '3545' },
  { label: '3546 - FRANCISCO PORTO', value: '3546' },
  { label: '3548 - ACLIMACAO', value: '3548' },
  { label: '3550 - SETOR PUBLICO AC', value: '3550' },
  { label: '3551 - UNIMART SHOPPING', value: '3551' },
  { label: '3552 - INDEPENDENCIA', value: '3552' },
  { label: '3557 - SETOR PUBLICO AL', value: '3557' },
  { label: '3558 - CANGAIBA', value: '3558' },
  { label: '3559 - BOM RETIRO', value: '3559' },
  { label: '3561 - INTERLAGOS', value: '3561' },
  { label: '3563 - SETOR PUBLICO AM', value: '3563' },
  { label: '3565 - JANDIRA', value: '3565' },
  { label: '3567 - JABAQUARA', value: '3567' },
  { label: '3568 - VILA OLIVEIRA', value: '3568' },
  { label: '3569 - AUGUSTA', value: '3569' },
  { label: '3570 - PARQUE DA UVA', value: '3570' },
  { label: '3571 - JACANA', value: '3571' },
  { label: '3572 - SAO JUDAS', value: '3572' },
  { label: '3575 - SETOR PUBLICO AP', value: '3575' },
  { label: '3576 - RUA MARIA MARCOLINA', value: '3576' },
  { label: '3582 - SETOR PUBLICO SC', value: '3582' },
  { label: '3583 - VARGEM GDE.PAULISTA', value: '3583' },
  { label: '3584 - VILA ARENS', value: '3584' },
  { label: '3589 - EUSEBIO', value: '3589' },
  { label: '3590 - EDIFICIO SEDE BACEN', value: '3590' },
  { label: '3596 - CONGRESSO NACIONAL', value: '3596' },
  { label: '3599 - EMPRESA NORTE', value: '3599' },
  { label: '3601 - Q.G.DO EXERCITO-BSB', value: '3601' },
  { label: '3603 - UNIV.DE BRASILIA', value: '3603' },
  { label: '3606 - PRES.DA REPUBLICA', value: '3606' },
  { label: '3607 - UNIV.FEDERAL DE GO', value: '3607' },
  { label: '3608 - AVENIDA AFONSO PENA', value: '3608' },
  { label: '3609 - SAUDE-MG', value: '3609' },
  { label: '3610 - UNIV.FEDERAL DE MG', value: '3610' },
  { label: '3611 - SETOR PUBLICO SE', value: '3611' },
  { label: '3613 - CID.UNIVERSITARIA-PE', value: '3613' },
  { label: '3615 - SETOR PUBLICO TO', value: '3615' },
  { label: '3616 - FELIPE SCHMIDT', value: '3616' },
  { label: '3620 - ALVORADA DO NORTE', value: '3620' },
  { label: '3621 - STA.TEREZINHA GOIAS', value: '3621' },
  { label: '3622 - VIANOPOLIS', value: '3622' },
  { label: '3624 - LORETO', value: '3624' },
  { label: '3625 - PORTO FRANCO', value: '3625' },
  { label: '3626 - SAO RAIM.MANGABEIRAS', value: '3626' },
  { label: '3627 - TASSO FRAGOSO', value: '3627' },
  { label: '3628 - SAO JOSE RIO CLARO', value: '3628' },
  { label: '3629 - VIGIA', value: '3629' },
  { label: '3631 - ITAUEIRA', value: '3631' },
  { label: '3632 - VERA CRUZ DO OESTE', value: '3632' },
  { label: '3633 - AGROLANDIA', value: '3633' },
  { label: '3634 - ANTONIO CARLOS-SC', value: '3634' },
  { label: '3635 - ITA', value: '3635' },
  { label: '3637 - APIAI', value: '3637' },
  { label: '3640 - INDIARA', value: '3640' },
  { label: '3641 - SAO SIMAO-GO', value: '3641' },
  { label: '3642 - BURITICUPU', value: '3642' },
  { label: '3648 - NOVA SUICA', value: '3648' },
  { label: '3649 - EMPRESA COHAMA', value: '3649' },
  { label: '3650 - COHAB ANIL', value: '3650' },
  { label: '3652 - UNIV.FEDERAL DO RJ', value: '3652' },
  { label: '3653 - BENFICA-CE', value: '3653' },
  { label: '3655 - BARAO DE ARACATI', value: '3655' },
  { label: '3656 - AVENIDA T-7', value: '3656' },
  { label: '3657 - CIDADE JARDIM', value: '3657' },
  { label: '3659 - INDEPENDENCIA', value: '3659' },
  { label: '3661 - CAPAO DA CANOA', value: '3661' },
  { label: '3662 - CEASA-CARIACICA', value: '3662' },
  { label: '3663 - XAXIM-PR', value: '3663' },
  { label: '3664 - CEASA-RIO DE JANEIRO', value: '3664' },
  { label: '3665 - SETOR PUBLICO ES', value: '3665' },
  { label: '3668 - CHARQUEADA', value: '3668' },
  { label: '3670 - DOVERLANDIA', value: '3670' },
  { label: '3672 - FORQUILHINHA', value: '3672' },
  { label: '3673 - FRIFORT', value: '3673' },
  { label: '3674 - GAROPABA', value: '3674' },
  { label: '3676 - ITAGUARU', value: '3676' },
  { label: '3677 - ITALVA', value: '3677' },
  { label: '3678 - JAGUARE-ES', value: '3678' },
  { label: '3679 - GUADALUPE', value: '3679' },
  { label: '3680 - JOAO NEIVA', value: '3680' },
  { label: '3681 - JOVIANIA', value: '3681' },
  { label: '3682 - MACAUBAL', value: '3682' },
  { label: '3684 - NEROPOLIS', value: '3684' },
  { label: '3686 - PANTANO GRANDE', value: '3686' },
  { label: '3688 - PRESIDENTE KENNEDY', value: '3688' },
  { label: '3689 - PRACA CIVICA', value: '3689' },
  { label: '3690 - SANTA MARIA JETIBA', value: '3690' },
  { label: '3691 - SAO JOSE DE UBA', value: '3691' },
  { label: '3692 - SAO LUDGERO', value: '3692' },
  { label: '3694 - TROMBUDO CENTRAL', value: '3694' },
  { label: '3695 - VARGEM ALTA', value: '3695' },
  { label: '3696 - VENDA NOVA IMIGRANTE', value: '3696' },
  { label: '3697 - VISTA ALEGRE DO ALTO', value: '3697' },
  { label: '3698 - JAGUARARI-RN', value: '3698' },
  { label: '3699 - AV.DOMINGOS FERREIRA', value: '3699' },
  { label: '3700 - ARATIBA', value: '3700' },
  { label: '3701 - AUGUSTO PESTANA', value: '3701' },
  { label: '3702 - UNIV.FEDERAL DO PA', value: '3702' },
  { label: '3703 - BAIAO', value: '3703' },
  { label: '3705 - BOM JESUS TOCANTINS', value: '3705' },
  { label: '3706 - BOM PRINCIPIO', value: '3706' },
  { label: '3710 - CAMPINORTE', value: '3710' },
  { label: '3711 - CANDIDO GODOI', value: '3711' },
  { label: '3712 - CARMO', value: '3712' },
  { label: '3713 - CAVALCANTE', value: '3713' },
  { label: '3716 - CIPO', value: '3716' },
  { label: '3718 - CONDOR', value: '3718' },
  { label: '3721 - TEOTONIO VILELA', value: '3721' },
  { label: '3723 - DOURADINA', value: '3723' },
  { label: '3724 - FONTOURA XAVIER', value: '3724' },
  { label: '3726 - FORTALEZA DOS VALOS', value: '3726' },
  { label: '3728 - HIDROLANDIA', value: '3728' },
  { label: '3729 - IBATIBA', value: '3729' },
  { label: '3730 - IBIACA', value: '3730' },
  { label: '3732 - INDEPENDENCIA', value: '3732' },
  { label: '3733 - INDIANOPOLIS', value: '3733' },
  { label: '3735 - IPORA DO OESTE', value: '3735' },
  { label: '3739 - JURUTI', value: '3739' },
  { label: '3743 - MAURILANDIA', value: '3743' },
  { label: '3744 - MISSAL', value: '3744' },
  { label: '3749 - PALMITINHO', value: '3749' },
  { label: '3751 - PEJUCARA', value: '3751' },
  { label: '3754 - POSTO DA MATA', value: '3754' },
  { label: '3762 - SALTO DO JACUI', value: '3762' },
  { label: '3765 - SAO VICENTE DO SUL', value: '3765' },
  { label: '3767 - SERTANEJA', value: '3767' },
  { label: '3770 - VILA VALERIO', value: '3770' },
  { label: '3773 - XAMBIOA', value: '3773' },
  { label: '3774 - RIO DO CAMPO', value: '3774' },
  { label: '3775 - MONTIVIDIU', value: '3775' },
  { label: '3776 - CHAPADAO DO CEU', value: '3776' },
  { label: '3777 - AV.CAP.MOR.GOUVEIA', value: '3777' },
  { label: '3782 - PANORAMA', value: '3782' },
  { label: '3783 - SAO JOAO DA BALIZA', value: '3783' },
  { label: '3784 - TUPASSI', value: '3784' },
  { label: '3786 - JURANDA', value: '3786' },
  { label: '3788 - MOREIRA CESAR', value: '3788' },
  { label: '3789 - BOA ESPERANCA', value: '3789' },
  { label: '3790 - BAIRRO PRAIA CANTO', value: '3790' },
  { label: '3791 - SETOR PUBLICO PI', value: '3791' },
  { label: '3792 - PINHEIRINHO', value: '3792' },
  { label: '3793 - SETOR PUBLICO PR', value: '3793' },
  { label: '3795 - SETOR PUBLICO RN', value: '3795' },
  { label: '3796 - AVENIDA CALAMA', value: '3796' },
  { label: '3797 - SETOR PUBLICO RR', value: '3797' },
  { label: '3798 - SETOR PUBLICO RS', value: '3798' },
  { label: '3801 - TANGUA', value: '3801' },
  { label: '3805 - BOM JESUS DA PENHA', value: '3805' },
  { label: '3808 - PIRACEMA', value: '3808' },
  { label: '3809 - MORADA NOVA DE MINAS', value: '3809' },
  { label: '3813 - SAO GERALDO ARAGUAIA', value: '3813' },
  { label: '3814 - ALAGOA NOVA', value: '3814' },
  { label: '3821 - AUREA', value: '3821' },
  { label: '3827 - SENADOR FIRMINO', value: '3827' },
  { label: '3829 - ARAUJOS', value: '3829' },
  { label: '3832 - SETOR PUBLICO BA', value: '3832' },
  { label: '3834 - SETOR PUBLICO MT', value: '3834' },
  { label: '3835 - RIO DO ANTONIO', value: '3835' },
  { label: '3836 - MANGARATIBA', value: '3836' },
  { label: '3837 - CONDE', value: '3837' },
  { label: '3838 - ACAJUTIBA', value: '3838' },
  { label: '3839 - ARRAIAL DO CABO', value: '3839' },
  { label: '3842 - LAPAO', value: '3842' },
  { label: '3844 - CONCEICAO DE MACABU', value: '3844' },
  { label: '3845 - QUISSAMA', value: '3845' },
  { label: '3846 - SETOR PUBLICO MA', value: '3846' },
  { label: '3848 - QUATRO BARRAS', value: '3848' },
  { label: '3849 - PARQUE DA FONTE', value: '3849' },
  { label: '3850 - MATINHOS', value: '3850' },
  { label: '3851 - BURITIZAL', value: '3851' },
  { label: '3852 - CORP BANK MARILIA', value: '3852' },
  { label: '3853 - CAMARA CASCUDO', value: '3853' },
  { label: '3854 - SUMIDOURO', value: '3854' },
  { label: '3856 - PRINCESA DO SUL', value: '3856' },
  { label: '3857 - GOITACAZES', value: '3857' },
  { label: '3859 - ESTILO J.KUBITSCHEK', value: '3859' },
  { label: '3860 - EMPRESA BELEM', value: '3860' },
  { label: '3861 - MADRE DE DEUS', value: '3861' },
  { label: '3862 - INACIOLANDIA', value: '3862' },
  { label: '3863 - TERRA NOVA DO NORTE', value: '3863' },
  { label: '3866 - IGARA', value: '3866' },
  { label: '3876 - BAIRRO SAO JOAO', value: '3876' },
  { label: '3878 - S.FRANC.ITABAPOANA', value: '3878' },
  { label: '3879 - ICAPUI', value: '3879' },
  { label: '3881 - ITAREMA', value: '3881' },
  { label: '3883 - 3883', value: '3883' },
  { label: '3884 - NOVA ABRANTES', value: '3884' },
  { label: '3886 - SHOPPING BOULEVARD', value: '3886' },
  { label: '3887 - CONJUNTO CEARA', value: '3887' },
  { label: '3888 - VILA NOVA', value: '3888' },
  { label: '3890 - CARAPEBUS', value: '3890' },
  { label: '3891 - COM.LEVY GASPARIAN', value: '3891' },
  { label: '3893 - BATALHA', value: '3893' },
  { label: '3895 - AVENIDA BANDEIRANTES', value: '3895' },
  { label: '3899 - NOVO PROGRESSO', value: '3899' },
  { label: '3915 - ITARUMA', value: '3915' },
  { label: '3916 - MATRINCHA', value: '3916' },
  { label: '3918 - LAGOA GRANDE', value: '3918' },
  { label: '3919 - FORQUILHA', value: '3919' },
  { label: '3921 - VERA CRUZ', value: '3921' },
  { label: '3928 - ANAURILANDIA', value: '3928' },
  { label: '3929 - BANDEIRANTES', value: '3929' },
  { label: '3931 - MATUPA', value: '3931' },
  { label: '3933 - ITAQUIRAI', value: '3933' },
  { label: '3937 - SONORA', value: '3937' },
  { label: '3940 - CRISTO REI', value: '3940' },
  { label: '3941 - POUSO NOVO', value: '3941' },
  { label: '3942 - QUERENCIA', value: '3942' },
  { label: '3943 - STO.ANTONIO LEVERGER', value: '3943' },
  { label: '3945 - BRASNORTE', value: '3945' },
  { label: '3946 - MACUCO', value: '3946' },
  { label: '3947 - QUATRO PONTES', value: '3947' },
  { label: '3950 - NOVA ALVORADA DO SUL', value: '3950' },
  { label: '3951 - SALINOPOLIS', value: '3951' },
  { label: '3952 - EPITACIOLANDIA', value: '3952' },
  { label: '3962 - BOSQUE DOS PIONEIROS', value: '3962' },
  { label: '3964 - RIQUEZA', value: '3964' },
  { label: '3970 - BERTIOGA', value: '3970' },
  { label: '3973 - ANANAS', value: '3973' },
  { label: '3975 - AUGUSTINOPOLIS', value: '3975' },
  { label: '3980 - SILVANOPOLIS', value: '3980' },
  { label: '3983 - LAGOA DA CONFUSAO', value: '3983' },
  { label: '3984 - PEROLA-SP', value: '3984' },
  { label: '3985 - AMAPA', value: '3985' },
  { label: '3986 - IPUIUNA', value: '3986' },
  { label: '3989 - CONFRESA', value: '3989' },
  { label: '3990 - PORTO GRANDE', value: '3990' },
  { label: '3992 - VILA VALQUEIRE', value: '3992' },
  { label: '3993 - MUCAJAI', value: '3993' },
  { label: '3994 - RORAINOPOLIS', value: '3994' },
  { label: '3996 - ESTRELA VELHA', value: '3996' },
  { label: '3997 - ALTO PARAISO', value: '3997' },
  { label: '4000 - MINISTRO ANDREAZZA', value: '4000' },
  { label: '4001 - MIRANTE DA SERRA', value: '4001' },
  { label: '4002 - MONTE NEGRO', value: '4002' },
  { label: '4003 - NOVA BRASIL.D OESTE', value: '4003' },
  { label: '4004 - NOVA MAMORE', value: '4004' },
  { label: '4007 - URUPA', value: '4007' },
  { label: '4009 - TAPURAH', value: '4009' },
  { label: '4015 - CASTELO BRANCO', value: '4015' },
  { label: '4018 - JARDIM URANO', value: '4018' },
  { label: '4020 - MANAIRA SHOPPING', value: '4020' },
  { label: '4021 - MARAGOGI', value: '4021' },
  { label: '4022 - COIMBRA', value: '4022' },
  { label: '4023 - PLACIDO DE CASTRO', value: '4023' },
  { label: '4026 - SENADOR GUIOMARD', value: '4026' },
  { label: '4027 - IGUARACU', value: '4027' },
  { label: '4028 - MOGIANA', value: '4028' },
  { label: '4029 - ENTRE RIOS DO OESTE', value: '4029' },
  { label: '4033 - ARCEBURGO', value: '4033' },
  { label: '4034 - RIO PRETO', value: '4034' },
  { label: '4035 - PRAIA DA COSTA', value: '4035' },
  { label: '4038 - PROENCA', value: '4038' },
  { label: '4043 - CARMINDO DE CAMPOS', value: '4043' },
  { label: '4044 - CORP BANK SANTA CRUZ', value: '4044' },
  { label: '4046 - MORTUGABA', value: '4046' },
  { label: '4053 - ESTILO CAMPINAS', value: '4053' },
  { label: '4057 - REPUBLICA DO LIBANO', value: '4057' },
  { label: '4059 - PETROBRAS', value: '4059' },
  { label: '4060 - BERILO', value: '4060' },
  { label: '4063 - HELIODORA', value: '4063' },
  { label: '4065 - AV.MARECHAL TITO', value: '4065' },
  { label: '4067 - LIBERDADE', value: '4067' },
  { label: '4068 - MOEDA', value: '4068' },
  { label: '4070 - RIACHINHO', value: '4070' },
  { label: '4072 - CORP BANK OESTE SC', value: '4072' },
  { label: '4073 - PEDRA DE ITAUNA', value: '4073' },
  { label: '4075 - BAIRRO SAO CRISTOVAO', value: '4075' },
  { label: '4076 - SAO CAITANO', value: '4076' },
  { label: '4081 - ALTO DO IPIRANGA', value: '4081' },
  { label: '4083 - DOIS LAJEADOS', value: '4083' },
  { label: '4090 - CORP BANK BENTO GONC', value: '4090' },
  { label: '4092 - IARAS', value: '4092' },
  { label: '4093 - SAUDE-SP', value: '4093' },
  { label: '4095 - CANDOI', value: '4095' },
  { label: '4099 - NOVA MONTE VERDE', value: '4099' },
  { label: '4102 - TABAPORA', value: '4102' },
  { label: '4105 - ITACARE', value: '4105' },
  { label: '4109 - LARANJAL DO JARI', value: '4109' },
  { label: '4112 - NOVA UBIRATA', value: '4112' },
  { label: '4114 - CAPIVARI DO SUL', value: '4114' },
  { label: '4116 - S.DOMINGOS ARAGUAIA', value: '4116' },
  { label: '4118 - CAVALEIRO', value: '4118' },
  { label: '4119 - BUIQUE', value: '4119' },
  { label: '4121 - CORP BANK III', value: '4121' },
  { label: '4125 - S.FRANCISCO GUAPORE', value: '4125' },
  { label: '4132 - MARITUBA', value: '4132' },
  { label: '4134 - PONTAL DO PARANA', value: '4134' },
  { label: '4137 - ITAUBA', value: '4137' },
  { label: '4139 - BRASIL NOVO', value: '4139' },
  { label: '4144 - BANABUIU', value: '4144' },
  { label: '4148 - EMPRESA BUENO', value: '4148' },
  { label: '4153 - CANAA DOS CARAJAS', value: '4153' },
  { label: '4158 - ACRELANDIA', value: '4158' },
  { label: '4159 - AMONTADA', value: '4159' },
  { label: '4163 - PORTO DE MOZ', value: '4163' },
  { label: '4164 - GOIANESIA DO PARA', value: '4164' },
  { label: '4165 - AVENIDA JOAO NAVES', value: '4165' },
  { label: '4200 - SETOR PUBLICO DF', value: '4200' },
  { label: '4202 - CORP BANK TRIANGULO', value: '4202' },
  { label: '4203 - S.PUBLICO SP NOROEST', value: '4203' },
  { label: '4205 - CORP BANK MT', value: '4205' },
  { label: '4207 - PRIVATE SAO PAULO', value: '4207' },
  { label: '4208 - BAIRRO LAGOA', value: '4208' },
  { label: '4209 - EMPRESA MOEMA', value: '4209' },
  { label: '4210 - LARANJEIRAS', value: '4210' },
  { label: '4211 - EMPRESA CAMPO GRANDE', value: '4211' },
  { label: '4215 - M BOI MIRIM', value: '4215' },
  { label: '4217 - JAIBA', value: '4217' },
  { label: '4218 - CIDADE NOVA-AM', value: '4218' },
  { label: '4219 - STUDIO 5', value: '4219' },
  { label: '4222 - PIONEIRA', value: '4222' },
  { label: '4225 - CHESF', value: '4225' },
  { label: '4226 - GOMES CARDIM', value: '4226' },
  { label: '4229 - NAVEGANTES', value: '4229' },
  { label: '4231 - BARREIRINHAS', value: '4231' },
  { label: '4232 - ITAPARICA', value: '4232' },
  { label: '4233 - CIDADE NOVA-PA', value: '4233' },
  { label: '4234 - PRACA MANOEL ANDRE', value: '4234' },
  { label: '4238 - PALACIO DAS ARTES', value: '4238' },
  { label: '4240 - ESTILO COPACABANA', value: '4240' },
  { label: '4241 - ESCR.EXC.MARACANA', value: '4241' },
  { label: '4247 - TAPAJOS', value: '4247' },
  { label: '4248 - CORP BANK ALTO OESTE', value: '4248' },
  { label: '4249 - EMPRESA PRACA LICEU', value: '4249' },
  { label: '4250 - GUILHERME FERREIRA', value: '4250' },
  { label: '4251 - AVENIDA SETE', value: '4251' },
  { label: '4252 - PIRACICAMIRIM', value: '4252' },
  { label: '4255 - ALVINOPOLIS-SP', value: '4255' },
  { label: '4258 - CAJAMAR', value: '4258' },
  { label: '4260 - JARDIM LONDRES', value: '4260' },
  { label: '4263 - ASA BRANCA', value: '4263' },
  { label: '4267 - ESTILO SBS', value: '4267' },
  { label: '4268 - AV.BRASIL-JI-PARANA', value: '4268' },
  { label: '4269 - PIABETA', value: '4269' },
  { label: '4270 - EMPRESA SINOP', value: '4270' },
  { label: '4271 - PRACA PEDRO SANCHES', value: '4271' },
  { label: '4272 - DOM JOSE', value: '4272' },
  { label: '4275 - EMPRESA BANDEIRANTE', value: '4275' },
  { label: '4276 - IBITURUNA', value: '4276' },
  { label: '4277 - SIMOES FILHO', value: '4277' },
  { label: '4279 - RIO VERMELHO', value: '4279' },
  { label: '4282 - BAIRRO BETANIA', value: '4282' },
  { label: '4283 - BAIRRO ITAPOA', value: '4283' },
  { label: '4284 - SAO SILVESTRE', value: '4284' },
  { label: '4286 - BURITIS', value: '4286' },
  { label: '4287 - SERRARIA', value: '4287' },
  { label: '4291 - JARDIM AMERICA-ES', value: '4291' },
  { label: '4292 - EMPRESA PORTO', value: '4292' },
  { label: '4293 - EMPRESA MONTESE', value: '4293' },
  { label: '4294 - ESTILO BARRA TIJUCA', value: '4294' },
  { label: '4295 - SAO JOAO', value: '4295' },
  { label: '4297 - ALTO MARACANA', value: '4297' },
  { label: '4299 - AV.RAGUEB CHOHFI', value: '4299' },
  { label: '4302 - CAMPO LIMPO', value: '4302' },
  { label: '4303 - CABREUVA', value: '4303' },
  { label: '4304 - D AVO SAO MIGUEL', value: '4304' },
  { label: '4305 - PRACA DO PATRIARCA', value: '4305' },
  { label: '4306 - AV.PEDROSO DE MORAIS', value: '4306' },
  { label: '4307 - EMPRESA CENTRO', value: '4307' },
  { label: '4309 - BELMIRA MARIN', value: '4309' },
  { label: '4310 - PEDRINHAS PAULISTA', value: '4310' },
  { label: '4311 - AVENIDA CAMPANELLA', value: '4311' },
  { label: '4312 - SIQUEIRA CAMPOS', value: '4312' },
  { label: '4314 - FAZENDA RIO GRANDE', value: '4314' },
  { label: '4319 - NEGREIROS', value: '4319' },
  { label: '4322 - NOVA IMPERATRIZ', value: '4322' },
  { label: '4323 - CALHAU', value: '4323' },
  { label: '4326 - ESCR.EXC.JUIZ FORA', value: '4326' },
  { label: '4328 - EMPRESA PERDIZES', value: '4328' },
  { label: '4332 - ESTILO CATETE', value: '4332' },
  { label: '4333 - PRIVATE RIO JANEIRO', value: '4333' },
  { label: '4336 - AV.WEIMAR TORRES', value: '4336' },
  { label: '4337 - VILA BRANCA', value: '4337' },
  { label: '4340 - LAURO DE FREITAS', value: '4340' },
  { label: '4344 - ESTILO LEBLON', value: '4344' },
  { label: '4346 - RIACHO FUNDO', value: '4346' },
  { label: '4347 - ESCR.EXC.RIB.PRETO', value: '4347' },
  { label: '4348 - LAGO AZUL', value: '4348' },
  { label: '4349 -  ESTILO INV. CARIOCA', value: '4349' },
  { label: '4351 - JARDIM ALVORADA', value: '4351' },
  { label: '4355 - VALENTIM GENTIL', value: '4355' },
  { label: '4361 - CORP BANK RN', value: '4361' },
  { label: '4362 - CORP BANK PARAIBA', value: '4362' },
  { label: '4371 - CAMPO ALEGRE GOIAS', value: '4371' },
  { label: '4383 - GAMELEIRA', value: '4383' },
  { label: '4385 - ESTILO VILA MARIANA', value: '4385' },
  { label: '4386 - CAMPO LIMPO PAULISTA', value: '4386' },
  { label: '4390 - DAVID CANABARRO', value: '4390' },
  { label: '4392 - ESTILO RIB.PRETO', value: '4392' },
  { label: '4397 - SUL DA ILHA', value: '4397' },
  { label: '4398 - AV.FELICIANO SODRE', value: '4398' },
  { label: '4400 - ESTILO FARIA LIMA', value: '4400' },
  { label: '4402 - ELDORADO DO SUL', value: '4402' },
  { label: '4403 - AV.SILVIANO BRANDAO', value: '4403' },
  { label: '4404 - CEASA-TERESINA', value: '4404' },
  { label: '4406 - CORUMBAIBA', value: '4406' },
  { label: '4408 - RIACHAO', value: '4408' },
  { label: '4409 - DOM ELISEU', value: '4409' },
  { label: '4410 - JACUNDA', value: '4410' },
  { label: '4411 - SAO FELIX DO XINGU', value: '4411' },
  { label: '4414 - IGARAPE-MIRI', value: '4414' },
  { label: '4416 - ESTILO RIO CENTRO', value: '4416' },
  { label: '4418 - SAO SEBASTIAO-DF', value: '4418' },
  { label: '4419 - SERRA DO SALITRE', value: '4419' },
  { label: '4424 - BARROSO', value: '4424' },
  { label: '4425 - BRASILANDIA DE MINAS', value: '4425' },
  { label: '4426 - SAO JOSE AUSENTES', value: '4426' },
  { label: '4427 - EMPRESA V. REDONDA', value: '4427' },
  { label: '4428 - OFFICE PARK', value: '4428' },
  { label: '4431 - SAO JOSE DA BARRA', value: '4431' },
  { label: '4435 - JARDIM FELICIDADE', value: '4435' },
  { label: '4437 - EMPRESA ITAQUERA', value: '4437' },
  { label: '4439 - CAMPUS DO PICI', value: '4439' },
  { label: '4440 - 4440', value: '4440' },
  { label: '4444 - ESTILO CURITIBA', value: '4444' },
  { label: '4445 - UFMA', value: '4445' },
  { label: '4448 - ESCR.EXC.CUIABA', value: '4448' },
  { label: '4450 - PRACA SAO FRANCISCO', value: '4450' },
  { label: '4451 - ALMIRANTE BARROSO', value: '4451' },
  { label: '4453 - ESCR.EXC.J.PESSOA', value: '4453' },
  { label: '4464 - TUPY', value: '4464' },
  { label: '4468 - CAPAO DO LEAO', value: '4468' },
  { label: '4476 - ESTILO IPANEMA', value: '4476' },
  { label: '4477 - JARDIM OCEANICO', value: '4477' },
  { label: '4478 - CORP BANK JUIZ FORA', value: '4478' },
  { label: '4482 - BAIRRO ELDORADO', value: '4482' },
  { label: '4484 - AGUAS DE SAO PEDRO', value: '4484' },
  { label: '4485 - S.PAULO DAS MISSOES', value: '4485' },
  { label: '4486 - SAO GONCALO AMARANTE', value: '4486' },
  { label: '4488 - BARAO DE COCAIS', value: '4488' },
  { label: '4493 - ITABELA', value: '4493' },
  { label: '4494 - CONCEICAO DO JACUIPE', value: '4494' },
  { label: '4495 - TUCANO', value: '4495' },
  { label: '4498 - MONTE SANTO', value: '4498' },
  { label: '4499 - PRIVATE B.HORIZONTE', value: '4499' },
  { label: '4500 - EMPRESA PORTAO', value: '4500' },
  { label: '4501 - SOORETAMA', value: '4501' },
  { label: '4502 - ITARANA', value: '4502' },
  { label: '4506 - NOVA SANTA ROSA', value: '4506' },
  { label: '4509 - FORMOSA DO OESTE', value: '4509' },
  { label: '4510 - NOVA HARTZ', value: '4510' },
  { label: '4513 - CARMOPOLIS', value: '4513' },
  { label: '4515 - ALTO TAQUARI', value: '4515' },
  { label: '4521 - BARRINHA', value: '4521' },
  { label: '4524 - GUAPIACU', value: '4524' },
  { label: '4527 - SANTO ANTONIO POSSE', value: '4527' },
  { label: '4530 - RIO DAS FLORES', value: '4530' },
  { label: '4533 - ITUPIRANGA', value: '4533' },
  { label: '4536 - 4536', value: '4536' },
  { label: '4538 - IPUPIARA', value: '4538' },
  { label: '4541 - ESCR.EXC.DF', value: '4541' },
  { label: '4544 - RUA SAO JOSE', value: '4544' },
  { label: '4546 - 4546', value: '4546' },
  { label: '4547 - NOVO REPARTIMENTO', value: '4547' },
  { label: '4548 - AV.2 DE FEVEREIRO', value: '4548' },
  { label: '4549 - TUCUMA', value: '4549' },
  { label: '4554 - HORIZONTE', value: '4554' },
  { label: '4556 - ICONHA', value: '4556' },
  { label: '4559 - COBILANDIA', value: '4559' },
  { label: '4560 - MIRANORTE', value: '4560' },
  { label: '4562 - AMERICO BRASILIENSE', value: '4562' },
  { label: '4564 - PINHALZINHO', value: '4564' },
  { label: '4565 - IRACEMAPOLIS', value: '4565' },
  { label: '4566 - SANTA GERTRUDES', value: '4566' },
  { label: '4567 - IPERO', value: '4567' },
  { label: '4572 - SAUDE-BA', value: '4572' },
  { label: '4574 - NOVA CRIXAS', value: '4574' },
  { label: '4575 - JK', value: '4575' },
  { label: '4576 - PRES.FIGUEIREDO', value: '4576' },
  { label: '4578 - SANTANA', value: '4578' },
  { label: '4580 - SERRANOPOLIS', value: '4580' },
  { label: '4581 - BONFIM', value: '4581' },
  { label: '4582 - GUARANI', value: '4582' },
  { label: '4583 - JUATUBA', value: '4583' },
  { label: '4584 - EMBU-GUACU', value: '4584' },
  { label: '4585 - GUARIBA', value: '4585' },
  { label: '4586 - IACANGA', value: '4586' },
  { label: '4587 - IPEUNA', value: '4587' },
  { label: '4588 - JARINU', value: '4588' },
  { label: '4589 - NUPORANGA', value: '4589' },
  { label: '4590 - AGUAS LINDAS GOIAS', value: '4590' },
  { label: '4594 - ASA SUL 516', value: '4594' },
  { label: '4595 - 4595', value: '4595' },
  { label: '4601 - XAVANTINA', value: '4601' },
  { label: '4602 - FAXINAL DOS GUEDES', value: '4602' },
  { label: '4603 - ESCR.EXC.VITORIA', value: '4603' },
  { label: '4604 - PRIVATE PORTO ALEGRE', value: '4604' },
  { label: '4605 - JIJOCA JERICOACOARA', value: '4605' },
  { label: '4607 - ESCR.EXC.SALVADOR', value: '4607' },
  { label: '4608 - PALMEIROPOLIS', value: '4608' },
  { label: '4609 - OUROESTE', value: '4609' },
  { label: '4610 - MACATUBA', value: '4610' },
  { label: '4611 - INGLESES', value: '4611' },
  { label: '4613 - HOSPITAL DE CLINICAS', value: '4613' },
  { label: '4620 - GECEX RECIFE', value: '4620' },
  { label: '4622 - CIDADE NOVA-BA', value: '4622' },
  { label: '4625 - BELO ORIENTE', value: '4625' },
  { label: '4626 - CONCEICAO DA BARRA', value: '4626' },
  { label: '4627 - ESCR.EXC.FORTALEZA', value: '4627' },
  { label: '4628 - VIANA', value: '4628' },
  { label: '4629 - MUQUICABA', value: '4629' },
  { label: '4631 - PRAIA GRANDE', value: '4631' },
  { label: '4632 - TREZE TILIAS', value: '4632' },
  { label: '4634 - BRODOWSKI', value: '4634' },
  { label: '4635 - BERNARDINO DE CAMPOS', value: '4635' },
  { label: '4636 - ESCR.EXC.JAMPA', value: '4636' },
  { label: '4637 - TORITAMA', value: '4637' },
  { label: '4639 - MARIPA', value: '4639' },
  { label: '4644 - SANTO INACIO', value: '4644' },
  { label: '4645 - CHERVESON', value: '4645' },
  { label: '4646 - VARRE-SAI', value: '4646' },
  { label: '4647 - ENG.PAULO DE FRONTIN', value: '4647' },
  { label: '4648 - GARUVA', value: '4648' },
  { label: '4650 - LUIS ANTONIO', value: '4650' },
  { label: '4651 - ESCR.EXC.SJR.PRETO', value: '4651' },
  { label: '4654 - SAO MIGUEL MISSOES', value: '4654' },
  { label: '4655 - MONGAGUA', value: '4655' },
  { label: '4656 - IGUAPE', value: '4656' },
  { label: '4665 - QUATIS', value: '4665' },
  { label: '4667 - DUAS BARRAS', value: '4667' },
  { label: '4669 - MAJOR GOTE', value: '4669' },
  { label: '4670 - ARRAIAL D AJUDA', value: '4670' },
  { label: '4671 - CAJATI', value: '4671' },
  { label: '4674 - MARILANDIA', value: '4674' },
  { label: '4679 - SENADOR CANEDO', value: '4679' },
  { label: '4683 - PATY DO ALFERES', value: '4683' },
  { label: '4684 - ESTILO BOTAFOGO', value: '4684' },
  { label: '4686 - UNIV.FED.RURAL DO RJ', value: '4686' },
  { label: '4687 - EMPRESA MOSSORO', value: '4687' },
  { label: '4689 - MESQUITA-RJ', value: '4689' },
  { label: '4690 - ESTILO NITEROI', value: '4690' },
  { label: '4691 - CAVALEIROS', value: '4691' },
  { label: '4693 - EMPRESA CASCAVEL', value: '4693' },
  { label: '4694 - ILHABELA', value: '4694' },
  { label: '4695 - RIO GRANDE DA SERRA', value: '4695' },
  { label: '4696 - ESTILO CUIABA', value: '4696' },
  { label: '4700 - GERENCIAL CARTOES', value: '4700' },
  { label: '4702 - ESCR.EXC.SJ.CAMPOS', value: '4702' },
  { label: '4704 - BAIRRO SERRARIA', value: '4704' },
  { label: '4705 - BAIRRO DOS PIMENTAS', value: '4705' },
  { label: '4706 - AVENIDA PRES.MEDICI', value: '4706' },
  { label: '4710 - TERESINA SHOPPING', value: '4710' },
  { label: '4718 - BORBA', value: '4718' },
  { label: '4719 - ANTONINA', value: '4719' },
  { label: '4725 - ESTILO SAO JOAO', value: '4725' },
  { label: '4726 - ESTILO VITORIA', value: '4726' },
  { label: '4727 - CAP.LEONIDAS MARQUES', value: '4727' },
  { label: '4728 - ESTILO AV.PAULISTA', value: '4728' },
  { label: '4732 - ESTILO FORTALEZA', value: '4732' },
  { label: '4733 - AGUAS CLARAS', value: '4733' },
  { label: '4735 - ESTILO B.HORIZONTE', value: '4735' },
  { label: '4736 - ESTILO PORTO ALEGRE', value: '4736' },
  { label: '4737 - CARLOPOLIS', value: '4737' },
  { label: '4740 - CERRO AZUL', value: '4740' },
  { label: '4744 - IRETAMA', value: '4744' },
  { label: '4745 - IVAI', value: '4745' },
  { label: '4748 - CSA SAO PAULO I', value: '4748' },
  { label: '4749 - NOVA LARANJEIRAS', value: '4749' },
  { label: '4752 - SHOPPING CAMPO LIMPO', value: '4752' },
  { label: '4758 - GECEX MANAUS', value: '4758' },
  { label: '4759 - GECEX BELEM', value: '4759' },
  { label: '4760 - GECEX FORTALEZA', value: '4760' },
  { label: '4761 - GECEX VITORIA', value: '4761' },
  { label: '4765 - ESTILO FEIRA SANTANA', value: '4765' },
  { label: '4766 - ESTILO JUIZ DE FORA', value: '4766' },
  { label: '4767 - EMPRESA NITEROI', value: '4767' },
  { label: '4768 - ESTILO MARINGA', value: '4768' },
  { label: '4770 - EMPRESA GUARULHOS', value: '4770' },
  { label: '4771 - ESTILO BLUMENAU', value: '4771' },
  { label: '4772 - ESTILO P.XV NOVEMBRO', value: '4772' },
  { label: '4773 - ESTILO JOINVILLE', value: '4773' },
  { label: '4775 - ESTILO ARACAJU', value: '4775' },
  { label: '4776 - ESTILO BAURU', value: '4776' },
  { label: '4777 - NAO CORRENTISTAS', value: '4777' },
  { label: '4778 - ESTILO JUNDIAI', value: '4778' },
  { label: '4779 - ESTILO PIRACICABA', value: '4779' },
  { label: '4780 - ESTILO SAO CARLOS', value: '4780' },
  { label: '4781 - CSA CURITIBA', value: '4781' },
  { label: '4783 - ESTILO FLORIANOPOLIS', value: '4783' },
  { label: '4786 - TOMAZINA', value: '4786' },
  { label: '4787 - RIO AZUL', value: '4787' },
  { label: '4789 - VERE', value: '4789' },
  { label: '4794 - GECEX BELO HORIZONTE', value: '4794' },
  { label: '4795 - GECEX CURITIBA', value: '4795' },
  { label: '4796 - GECEX SAO PAULO I', value: '4796' },
  { label: '4813 - ESTREITO', value: '4813' },
  { label: '4814 - VERA', value: '4814' },
  { label: '4816 - RIBAS DO RIO PARDO', value: '4816' },
  { label: '4818 - ESTILO TIRADENTES', value: '4818' },
  { label: '4819 - ESTILO RIO ANTIGO', value: '4819' },
  { label: '4847 - ESTILO NATAL', value: '4847' },
  { label: '4848 - ESTILO MOINHOS VENTO', value: '4848' },
  { label: '4849 - ESTILO ALTO PINHEIRO', value: '4849' },
  { label: '4850 - ESTILO CID SAO PAULO', value: '4850' },
  { label: '4851 - ESTILO SAO PAULO', value: '4851' },
  { label: '4852 - ESTILO PERDIZES', value: '4852' },
  { label: '4853 - ESTILO PACAEMBU', value: '4853' },
  { label: '4854 - ESTILO MOEMA', value: '4854' },
  { label: '4855 - ESTILO SANTANA', value: '4855' },
  { label: '4856 - ESTILO ALTO B VISTA', value: '4856' },
  { label: '4857 - ESTILO SANTOS', value: '4857' },
  { label: '4858 - ESTILO S.JOSE CAMPOS', value: '4858' },
  { label: '4859 - ESTILO ANALIA FRANCO', value: '4859' },
  { label: '4861 - VIA SHOPPING', value: '4861' },
  { label: '4862 - NOVO GAMA', value: '4862' },
  { label: '4863 - MAIOBAO', value: '4863' },
  { label: '4869 - ESTILO S.BERN.CAMPO', value: '4869' },
  { label: '4870 - ESTILO BAIRRO GRACA', value: '4870' },
  { label: '4871 - AV.PRESIDENTE WILSON', value: '4871' },
  { label: '4875 - PEDRA BRANCA AMAPARI', value: '4875' },
  { label: '4881 - ESTILO COMERCIO', value: '4881' },
  { label: '4882 - ESTILO LAGO SUL', value: '4882' },
  { label: '4883 - ESTILO P.REPUBLICA', value: '4883' },
  { label: '4884 - 4884', value: '4884' },
  { label: '4885 - ESTILO MONUMENTAL', value: '4885' },
  { label: '4886 - ESTILO ALVORADA', value: '4886' },
  { label: '4887 - ESTILO B.DE LOURDES', value: '4887' },
  { label: '4888 - ESTILO MINASCENTRO', value: '4888' },
  { label: '4889 - ESTILO UBERLANDIA', value: '4889' },
  { label: '4890 - ESTILO MARCO ZERO', value: '4890' },
  { label: '4891 - ESTILO LONDRINA', value: '4891' },
  { label: '4892 - ESTILO PETROBRAS', value: '4892' },
  { label: '4893 - ESTILO CAMBUI', value: '4893' },
  { label: '4894 - ESTILO GUARULHOS', value: '4894' },
  { label: '4895 - ESTILO SANTO ANDRE', value: '4895' },
  { label: '4896 - ESTILO S.J.RIO PRETO', value: '4896' },
  { label: '4897 - ESTILO SOROCABA', value: '4897' },
  { label: '4899 - ESTILO CARLOS GOMES', value: '4899' },
  { label: '4925 - ESCR.INTEGRACAO VAR', value: '4925' },
  { label: '4982 - ESTILO GUANABARA', value: '4982' },
  { label: '4986 - BREJETUBA', value: '4986' },
  { label: '4990 - MEDINA', value: '4990' },
  { label: '4991 - SIMONESIA', value: '4991' },
  { label: '4993 - NOVA CANAA DO NORTE', value: '4993' },
  { label: '4995 - ESCR.EXC.MARAJOARA', value: '4995' },
  { label: '5014 - ESTILO RIO BRANCO', value: '5014' },
  { label: '5016 - ESTILO IMPERATRIZ', value: '5016' },
  { label: '5018 - ESTILO MONTES CLAROS', value: '5018' },
  { label: '5026 - ESTILO C.GRANDE', value: '5026' },
  { label: '5027 - ESTILO TERESINA', value: '5027' },
  { label: '5028 - ESTILO CASCAVEL', value: '5028' },
  { label: '5029 - ESTILO PONTA GROSSA', value: '5029' },
  { label: '5031 - ESTILO C.GOYTACAZES', value: '5031' },
  { label: '5041 - ESTILO PORTO VELHO', value: '5041' },
  { label: '5042 - ESTILO BOA VISTA', value: '5042' },
  { label: '5050 - ESTILO PELOTAS', value: '5050' },
  { label: '5051 - ESTILO SANTA MARIA', value: '5051' },
  { label: '5052 - ESTILO BALN.CAMBORIU', value: '5052' },
  { label: '5054 - ESTILO AMERICANA', value: '5054' },
  { label: '5065 - ESTILO INDAIATUBA', value: '5065' },
  { label: '5067 - ESTILO PALMAS', value: '5067' },
  { label: '5081 - ESTILO VILA VELHA', value: '5081' },
  { label: '5083 - EMPRESA PORTO VELHO', value: '5083' },
  { label: '5084 - ESTILO UBERABA', value: '5084' },
  { label: '5086 - ESTILO PETROPOLIS', value: '5086' },
  { label: '5087 - ESTILO CANOAS', value: '5087' },
  { label: '5096 - ESTILO VIEIRA ALVES', value: '5096' },
  { label: '5097 - ESTILO PITUBA', value: '5097' },
  { label: '5101 - ESTILO MEIRELES', value: '5101' },
  { label: '5102 - CORP BANK SERV FINAN', value: '5102' },
  { label: '5110 - ESTILO ALDEOTA', value: '5110' },
  { label: '5111 - CORP BANK FOZ SF', value: '5111' },
  { label: '5113 - CORP BANK RIB NORTE', value: '5113' },
  { label: '5114 - ESTILO ASA NORTE 316', value: '5114' },
  { label: '5115 - CORP BANK CAMPINAS', value: '5115' },
  { label: '5116 - CORP BANK GOIANIA', value: '5116' },
  { label: '5117 - CORP BANK CO MG', value: '5117' },
  { label: '5121 - CORP BANK D PARNAIBA', value: '5121' },
  { label: '5122 - CORP BANK PASSO FDO', value: '5122' },
  { label: '5123 - ESTILO SUDOESTE', value: '5123' },
  { label: '5190 - ESTILO PARQUE CIDADE', value: '5190' },
  { label: '5191 - ESTILO ASA SUL 504', value: '5191' },
  { label: '5197 - ESTILO BACEN DF', value: '5197' },
  { label: '5201 - CENTRAL-SC', value: '5201' },
  { label: '5209 - CENTENARIO', value: '5209' },
  { label: '5211 - IMARUI', value: '5211' },
  { label: '5215 - CALCADAO LAGES', value: '5215' },
  { label: '5233 - BAIRRO SANTA RITA', value: '5233' },
  { label: '5248 - 5248', value: '5248' },
  { label: '5255 - PRACA XV DE NOVEMBRO', value: '5255' },
  { label: '5257 - BOM JARDIM DA SERRA', value: '5257' },
  { label: '5271 - ATLANTICO SUL', value: '5271' },
  { label: '5279 - SAUDADES', value: '5279' },
  { label: '5284 - SAO JOSE DO CERRITO', value: '5284' },
  { label: '5286 - JABORA', value: '5286' },
  { label: '5297 - ANGELINA', value: '5297' },
  { label: '5302 - CAXAMBU DO SUL', value: '5302' },
  { label: '5304 - IMBUIA', value: '5304' },
  { label: '5305 - PETROLANDIA', value: '5305' },
  { label: '5310 - ATALANTA', value: '5310' },
  { label: '5314 - PAULO LOPES', value: '5314' },
  { label: '5317 - 5317', value: '5317' },
  { label: '5322 - ARROIO TRINTA', value: '5322' },
  { label: '5347 - LEOBERTO LEAL', value: '5347' },
  { label: '5355 - PERITIBA', value: '5355' },
  { label: '5357 - 5357', value: '5357' },
  { label: '5359 - RANCHO QUEIMADO', value: '5359' },
  { label: '5362 - PALHOCA CENTRO', value: '5362' },
  { label: '5369 - SAO JOAO DO SUL', value: '5369' },
  { label: '5384 - MODELO', value: '5384' },
  { label: '5391 - LUIZ ALVES', value: '5391' },
  { label: '5395 - NOVA ERECHIM', value: '5395' },
  { label: '5398 - 5398', value: '5398' },
  { label: '5406 - LONTRAS', value: '5406' },
  { label: '5407 - LAURENTINO', value: '5407' },
  { label: '5413 - GALVAO', value: '5413' },
  { label: '5416 - AURORA', value: '5416' },
  { label: '5422 - EMPRESA SAO JOSE', value: '5422' },
  { label: '5435 - TUNAPOLIS', value: '5435' },
  { label: '5436 - 5436', value: '5436' },
  { label: '5437 - 5437', value: '5437' },
  { label: '5439 - ITAPOA', value: '5439' },
  { label: '5443 - VILA NOVA', value: '5443' },
  { label: '5455 - BELA VISTA', value: '5455' },
  { label: '5456 - CAPIVARI DE BAIXO', value: '5456' },
  { label: '5556 - UNESP BOTUCATU', value: '5556' },
  { label: '5560 - ESTILO ASA SUL 514', value: '5560' },
  { label: '5568 - AVENIDA VP 8', value: '5568' },
  { label: '5602 - DIRCEU ARCOVERDE', value: '5602' },
  { label: '5605 - 13 DE MAIO', value: '5605' },
  { label: '5610 - ESTILO PRAIA CAMBURI', value: '5610' },
  { label: '5654 - ESMERALDA', value: '5654' },
  { label: '5657 - CAMPUS UNIVERSITARIO', value: '5657' },
  { label: '5658 - VILA DIRCE', value: '5658' },
  { label: '5662 - SAO JOAO EVANGELISTA', value: '5662' },
  { label: '5671 - ESTILO CAXIAS DO SUL', value: '5671' },
  { label: '5675 - CIDADE OPERARIA', value: '5675' },
  { label: '5677 - VITORIA DO MEARIM', value: '5677' },
  { label: '5679 - PRACA TIRADENTES-MG', value: '5679' },
  { label: '5680 - BAIRRO OURO PRETO', value: '5680' },
  { label: '5688 - RUA GAL.GLICERIO', value: '5688' },
  { label: '5692 - MATATU-BROTAS', value: '5692' },
  { label: '5701 - ESTILO GOIAS', value: '5701' },
  { label: '5705 - VILA MIRIM', value: '5705' },
  { label: '5710 - ESCR.EXC.P.MARAVILHA', value: '5710' },
  { label: '5721 - AV.BRIG.LIMA E SILVA', value: '5721' },
  { label: '5722 - AV.PRESIDENTE VARGAS', value: '5722' },
  { label: '5724 - ESCR.EXC.ARCOS LAPA', value: '5724' },
  { label: '5729 - AMARANTE DO MARANHAO', value: '5729' },
  { label: '5730 - GOV.NUNES FREIRE', value: '5730' },
  { label: '5734 - FORTALEZA NOGUEIRAS', value: '5734' },
  { label: '5737 - SALVADOR SHOPPING', value: '5737' },
  { label: '5742 - SHOPPING DIFUSORA', value: '5742' },
  { label: '5745 - EMPRESA ASSIS BRASIL', value: '5745' },
  { label: '5747 - GUARAJUBA', value: '5747' },
  { label: '5749 - RIO SAO FRANCISCO', value: '5749' },
  { label: '5750 - EMPRESA SAO LUIS MA', value: '5750' },
  { label: '5751 - ESTILO SAO MATEUS', value: '5751' },
  { label: '5752 - ESTILO NAZARE', value: '5752' },
  { label: '5755 - ESTILO ILHA DO LEITE', value: '5755' },
  { label: '5756 - ESTILO MADRE LEONIA', value: '5756' },
  { label: '5757 - ESTILO AVENIDA CHILE', value: '5757' },
  { label: '5761 - ESTILO AV.RIO BRANCO', value: '5761' },
  { label: '5763 - ESTILO MARIZ BARROS', value: '5763' },
  { label: '5764 - ESTILO PALAC.FAZENDA', value: '5764' },
  { label: '5766 -  ESTILO INV. RJ', value: '5766' },
  { label: '5768 - ESTILO ZONA SUL', value: '5768' },
  { label: '5769 - ESTILO POTIGUAR', value: '5769' },
  { label: '5770 - ESTILO C.HISTORICO', value: '5770' },
  { label: '5771 - ESTILO GARCIA', value: '5771' },
  { label: '5772 - ESTILO NORTE SUL', value: '5772' },
  { label: '5773 - ESTILO PORTO SANTOS', value: '5773' },
  { label: '5778 - AV.OLIVIA FLORES', value: '5778' },
  { label: '5779 - AVENIDA CHICO MENDES', value: '5779' },
  { label: '5780 - MECEJANA', value: '5780' },
  { label: '5782 - ALVORADA-MT', value: '5782' },
  { label: '5784 - ANIL', value: '5784' },
  { label: '5785 - JAPIIM', value: '5785' },
  { label: '5789 - AV.DANIEL LA TOUCHE', value: '5789' },
  { label: '5791 - LUIZOTE DE FREITAS', value: '5791' },
  { label: '5793 - ESCR.EXC.CPO.GRANDE', value: '5793' },
  { label: '5794 - CARUTAPERA', value: '5794' },
  { label: '5798 - EMPRESA NOVA IGUACU', value: '5798' },
  { label: '5799 - MORENINHAS', value: '5799' },
  { label: '5801 - ESTILO AV.A.HADDAD', value: '5801' },
  { label: '5802 - ESTILO VALE PARAIBA', value: '5802' },
  { label: '5803 - ESTILO E.P.MEDICINA', value: '5803' },
  { label: '5804 - ESTILO AV.BRASIL-SP', value: '5804' },
  { label: '5806 - ESTILO BOM RETIRO', value: '5806' },
  { label: '5807 - EMPRESA PANTANAL', value: '5807' },
  { label: '5808 - ESCR.EXC.BELEM', value: '5808' },
  { label: '5809 - ESTILO NACOES UNIDAS', value: '5809' },
  { label: '5811 - ESTILO SANTO AMARO', value: '5811' },
  { label: '5813 - ESTILO VILA CARRAO', value: '5813' },
  { label: '5814 - ESTILO REBOUCAS-SP', value: '5814' },
  { label: '5818 - ESTILO P.MORAIS', value: '5818' },
  { label: '5820 - ESTILO CENTRO CIVICO', value: '5820' },
  { label: '5821 - ESTILO OLHO D AGUA', value: '5821' },
  { label: '5826 - RUA DO FICO', value: '5826' },
  { label: '5840 - VOTUPORANGA NORTE', value: '5840' },
  { label: '5846 - ESCR.EXC.RECIFE', value: '5846' },
  { label: '5853 - EMPRESA VERGUEIRO', value: '5853' },
  { label: '5870 - RUA MARIZ E BARROS', value: '5870' },
  { label: '5874 - EMPRESA TRIANGULO', value: '5874' },
  { label: '5875 - BAIRRO INDUSTRIAL', value: '5875' },
  { label: '5878 - 5878', value: '5878' },
  { label: '5885 - AVENIDA AMAZONAS', value: '5885' },
  { label: '5886 - EMPRESA ANAPOLIS', value: '5886' },
  { label: '5888 - RUA SAMPAIO', value: '5888' },
  { label: '5889 - AV.BRASILIA-ST.LUZIA', value: '5889' },
  { label: '5895 - TURU', value: '5895' },
  { label: '5902 - SUDOESTE', value: '5902' },
  { label: '5905 - S.PUBLICO SP SUDESTE', value: '5905' },
  { label: '5907 - NOVA BALSAS', value: '5907' },
  { label: '5910 - RUA SENA MADUREIRA', value: '5910' },
  { label: '5911 - CLAUDIA', value: '5911' },
  { label: '5916 - PEIXOTO DE AZEVEDO', value: '5916' },
  { label: '5921 - CAPIM DOURADO', value: '5921' },
  { label: '5926 - B.JORGE TEIXEIRA', value: '5926' },
  { label: '5927 - EMPRESA AMAZONAS', value: '5927' },
  { label: '5929 - ESTILO MACAPA', value: '5929' },
  { label: '5932 - ESCR.EXC.SAO LUIS', value: '5932' },
  { label: '5934 - HOSP.SERV.ESTAD.SP', value: '5934' },
  { label: '5942 - PALACIO DA JUSTICA', value: '5942' },
  { label: '5958 - ESCR.EXC.LUZ SP', value: '5958' },
  { label: '5972 - TRT-RS', value: '5972' },
  { label: '5973 - ESTILO PQ.DAS ROSAS', value: '5973' },
  { label: '5974 - ESTILO R.ASSEMBLEIA', value: '5974' },
  { label: '5976 - ESCR.EXC.ARPOADOR', value: '5976' },
  { label: '5977 - ESTILO SEN.FEDERAL', value: '5977' },
  { label: '5980 - IPIRANGA DO NORTE', value: '5980' },
  { label: '5981 - NOVO SAO JOAQUIM', value: '5981' },
  { label: '5982 - GAUCHA DO NORTE', value: '5982' },
  { label: '5985 - COROA DO MEIO', value: '5985' },
  { label: '5995 - ESCR.EXC.CAXIAS', value: '5995' },
  { label: '5996 - MALACACHETA', value: '5996' },
  { label: '6501 - MATRIZ-SAO PAULO', value: '6501' },
  { label: '6503 - RUA DOUTOR QUIRINO', value: '6503' },
  { label: '6504 - EMPRESA RIB.PRETO', value: '6504' },
  { label: '6505 - CIDADE TERNURA-TATUI', value: '6505' },
  { label: '6507 - EMPRESA RIO CLARO', value: '6507' },
  { label: '6508 - PCA.BARAO DE ARARAS', value: '6508' },
  { label: '6509 - ALEXANDRINA-S.CARLOS', value: '6509' },
  { label: '6511 - CATEDRAL-SOROCABA', value: '6511' },
  { label: '6513 - CATEDRAL-GUARA', value: '6513' },
  { label: '6516 - EMPRESA PIRACICABA', value: '6516' },
  { label: '6518 - RUA BISPO RODOVALHO', value: '6518' },
  { label: '6520 - EMPRESA FRANCA', value: '6520' },
  { label: '6522 - ATENAS-ITAPETININGA', value: '6522' },
  { label: '6523 - CONVENCAO-ITU', value: '6523' },
  { label: '6528 - PRACA RAUL LEME', value: '6528' },
  { label: '6533 - PC.RUI BARBOSA-BAURU', value: '6533' },
  { label: '6535 - EDIFICIO ATRIUM-MOGI', value: '6535' },
  { label: '6536 - RUA ANDRADAS-PINDA', value: '6536' },
  { label: '6541 - PCA.ROSARIO-JACAREI', value: '6541' },
  { label: '6542 - PC.S.JOSE-MOGI-MIRIM', value: '6542' },
  { label: '6545 - RUA AGUIAR-ITATIBA', value: '6545' },
  { label: '6549 - ESCR.EXC.STO.ANDRE', value: '6549' },
  { label: '6550 - RUA MAL.DEODORO-SBC', value: '6550' },
  { label: '6551 - PIRACEMA', value: '6551' },
  { label: '6554 - ESTANCIA ATIBAIA', value: '6554' },
  { label: '6558 - CANAVIAIS', value: '6558' },
  { label: '6565 - VALE DO PARAIBA', value: '6565' },
  { label: '6570 - CATEDRAL-ASSIS', value: '6570' },
  { label: '6571 - NOVA BEBEDOURO', value: '6571' },
  { label: '6575 - CATEDRAL-S.J.R.PRETO', value: '6575' },
  { label: '6576 - MINEIROS DO TIETE', value: '6576' },
  { label: '6581 - ITATINGA', value: '6581' },
  { label: '6589 - ALTO DA BOA VISTA-SP', value: '6589' },
  { label: '6594 - PCA.DR.GAMA-BIRIGUI', value: '6594' },
  { label: '6598 - R.MARANHAO-CATANDUVA', value: '6598' },
  { label: '6600 - LINENSE', value: '6600' },
  { label: '6605 - AV.SAMPAIO VIDAL', value: '6605' },
  { label: '6607 - SERRA AZUL', value: '6607' },
  { label: '6609 - PRACA NOVE DE JULHO', value: '6609' },
  { label: '6610 - TORRINHA', value: '6610' },
  { label: '6614 - REGINOPOLIS', value: '6614' },
  { label: '6619 - QUATA', value: '6619' },
  { label: '6621 - RUA VINTE E SEIS', value: '6621' },
  { label: '6624 - EMPRESA AMERICANA', value: '6624' },
  { label: '6635 - IPAUSSU', value: '6635' },
  { label: '6640 - PARAIBUNA', value: '6640' },
  { label: '6641 - SALTO GRANDE', value: '6641' },
  { label: '6652 - RUA QUINZE-MOGI', value: '6652' },
  { label: '6655 - TABATINGA', value: '6655' },
  { label: '6658 - CONVIVIO DOM PEDRO', value: '6658' },
  { label: '6659 - ARIRANHA', value: '6659' },
  { label: '6663 - CIDADE DOS INDAIAS', value: '6663' },
  { label: '6672 - AVANHANDAVA', value: '6672' },
  { label: '6673 - VERA CRUZ', value: '6673' },
  { label: '6674 - ITIRAPINA', value: '6674' },
  { label: '6679 - FERNANDO PRESTES', value: '6679' },
  { label: '6682 - PIQUETE', value: '6682' },
  { label: '6683 - RINCAO', value: '6683' },
  { label: '6685 - IRAPUA', value: '6685' },
  { label: '6687 - PITANGUEIRAS-GUARUJA', value: '6687' },
  { label: '6689 - ECHAPORA', value: '6689' },
  { label: '6690 - REDENCAO DA SERRA', value: '6690' },
  { label: '6698 - RUA FREI GASPAR', value: '6698' },
  { label: '6702 - NEVES PAULISTA', value: '6702' },
  { label: '6707 - NOVA ALIANCA', value: '6707' },
  { label: '6710 - CIDADE DAS FLORES-SP', value: '6710' },
  { label: '6714 - ALVARES FLORENCE', value: '6714' },
  { label: '6716 - SAO JOSE BELA VISTA', value: '6716' },
  { label: '6721 - AV.9 ABRIL-CUBATAO', value: '6721' },
  { label: '6723 - CABRALIA PAULISTA', value: '6723' },
  { label: '6724 - CORUMBATAI', value: '6724' },
  { label: '6727 - ESTACAO FRANCO ROCHA', value: '6727' },
  { label: '6738 - PONGAI', value: '6738' },
  { label: '6739 - MONTEIRO LOBATO', value: '6739' },
  { label: '6748 - HERCULANDIA', value: '6748' },
  { label: '6752 - AGUAS DE STA.BARBARA', value: '6752' },
  { label: '6760 - CEDRAL', value: '6760' },
  { label: '6761 - GUARUCENTRO', value: '6761' },
  { label: '6773 - TREMEMBE', value: '6773' },
  { label: '6774 - PRAIA DE CARAGUA', value: '6774' },
  { label: '6776 - ARACOIABA DA SERRA', value: '6776' },
  { label: '6787 - IBIRAREMA', value: '6787' },
  { label: '6788 - MANDURI', value: '6788' },
  { label: '6790 - BILAC', value: '6790' },
  { label: '6795 - GUARACAI', value: '6795' },
  { label: '6796 - PARANAPANEMA', value: '6796' },
  { label: '6798 - AREALVA', value: '6798' },
  { label: '6800 - UBIRAJARA', value: '6800' },
  { label: '6803 - BRESSER-SAO PAULO', value: '6803' },
  { label: '6804 - R.VOL.PATRIA-S.PAULO', value: '6804' },
  { label: '6805 - RUA JOAQUIM TAVORA', value: '6805' },
  { label: '6806 - PINHEIROS TEODORO', value: '6806' },
  { label: '6807 - RUA AFONSO SARDINHA', value: '6807' },
  { label: '6813 - ESTILO JOAO MENDES', value: '6813' },
  { label: '6814 - PRACA ALEIXO MAFRA', value: '6814' },
  { label: '6815 - CLOVIS BEVILACQUA', value: '6815' },
  { label: '6819 - TIRADENTES-SAO PAULO', value: '6819' },
  { label: '6823 - REZENDE-PIRACICABA', value: '6823' },
  { label: '6831 - R.11 JUNHO-LIMEIRA', value: '6831' },
  { label: '6832 - CONSELHEIRO CARRAO', value: '6832' },
  { label: '6834 - JARDIM FRANCA-SP', value: '6834' },
  { label: '6835 - PENHA-SAO PAULO', value: '6835' },
  { label: '6836 - EMBARE-SANTOS', value: '6836' },
  { label: '6838 - REP.DO LIBANO-OSASCO', value: '6838' },
  { label: '6839 - ESTACAO ADONIRAN', value: '6839' },
  { label: '6841 - VILA FALCAO-BAURU', value: '6841' },
  { label: '6842 - CPOS.ELISEOS-RIB.PTO', value: '6842' },
  { label: '6843 - DISTRITO ESTACAO', value: '6843' },
  { label: '6844 - FREGUESIA SAO PAULO', value: '6844' },
  { label: '6845 - VILA PRADO-S.CARLOS', value: '6845' },
  { label: '6846 - AV.PAULA FERREIRA', value: '6846' },
  { label: '6848 - PARADA INGLESA', value: '6848' },
  { label: '6851 - DISTRITO DE SOUSAS', value: '6851' },
  { label: '6852 - RUA SALES OLIVEIRA', value: '6852' },
  { label: '6853 - VL.BELA VISTA-BAURU', value: '6853' },
  { label: '6854 - RUA MAJOR MATHEUS', value: '6854' },
  { label: '6858 - VILA GERMAINE', value: '6858' },
  { label: '6861 - BALSAMO', value: '6861' },
  { label: '6862 - CIDADE AZUL-R.CLARO', value: '6862' },
  { label: '6863 - PRACA DA BIBLIA', value: '6863' },
  { label: '6866 - SALTO DE PIRAPORA', value: '6866' },
  { label: '6867 - IGARACU DO TIETE', value: '6867' },
  { label: '6869 - SANTANA DO PARAIBA', value: '6869' },
  { label: '6871 - PARQUE ANHANGUERA', value: '6871' },
  { label: '6872 - PCA.DR.SAMPAIO VIDAL', value: '6872' },
  { label: '6873 - ICEM', value: '6873' },
  { label: '6874 - STA.CRUZ CONCEICAO', value: '6874' },
  { label: '6876 - CESARIO LANGE', value: '6876' },
  { label: '6882 - OITO DE SETEMBRO', value: '6882' },
  { label: '6884 - R.MANOEL NOBREGA', value: '6884' },
  { label: '6885 - SABINO', value: '6885' },
  { label: '6890 - CASTILHO', value: '6890' },
  { label: '6892 - AREIOPOLIS', value: '6892' },
  { label: '6899 - VILA SAO MIGUEL', value: '6899' },
  { label: '6902 - POLONI', value: '6902' },
  { label: '6905 - OCAUCU', value: '6905' },
  { label: '6909 - PRADOPOLIS', value: '6909' },
  { label: '6910 - PARAISO', value: '6910' },
  { label: '6911 - SEVERINIA', value: '6911' },
  { label: '6915 - SANTO ANTONIO PINHAL', value: '6915' },
  { label: '6918 - VILA HARMONIA', value: '6918' },
  { label: '6919 - AV.DUQUE DE CAXIAS', value: '6919' },
  { label: '6920 - AV.N.S.PAZ-RIO PRETO', value: '6920' },
  { label: '6921 - SUD MENNUCCI', value: '6921' },
  { label: '6925 - ESCR.EXC.TAUBATE', value: '6925' },
  { label: '6926 - VILA N.S.GRACAS', value: '6926' },
  { label: '6930 - RUA AMAZONAS GUARUJA', value: '6930' },
  { label: '6931 - VOTORANTINENSE', value: '6931' },
  { label: '6932 - VILA SAMPAIO-JAU', value: '6932' },
  { label: '6933 - CARMO-ARARAQUARA', value: '6933' },
  { label: '6935 - ROSEIRA', value: '6935' },
  { label: '6937 - RUA PAULA BUENO', value: '6937' },
  { label: '6938 - PARQUE BOTURUSSU', value: '6938' },
  { label: '6939 - VILA CARMOSINA', value: '6939' },
  { label: '6947 - RIO PIRACICABA', value: '6947' },
  { label: '6952 - PIACATU', value: '6952' },
  { label: '6953 - JARDIM JABOTICABEIRA', value: '6953' },
  { label: '6954 - DUQUE-RIBEIRAO PRETO', value: '6954' },
  { label: '6959 - R.FCO.AFONSO-MOGI', value: '6959' },
  { label: '6961 - AV.BRASIL-P.GRANDE', value: '6961' },
  { label: '6962 - AV.GENERAL CARNEIRO', value: '6962' },
  { label: '6966 - CIDADE ADEMAR', value: '6966' },
  { label: '6968 - RUA SENADOR FLAQUER', value: '6968' },
  { label: '6969 - VILA SONIA-SAO PAULO', value: '6969' },
  { label: '6972 - ROD.REGIS-TABOAO', value: '6972' },
  { label: '6973 - BAIRRO STA.TEREZINHA', value: '6973' },
  { label: '6974 - VILA BARCELONA', value: '6974' },
  { label: '6977 - 26 DE JULHO-SUMARE', value: '6977' },
  { label: '6978 - EMPRESA LGO.SOCORRO', value: '6978' },
  { label: '6980 - S.LOURENCO DA SERRA', value: '6980' },
  { label: '6983 - REMANSO-HORTOLANDIA', value: '6983' },
  { label: '6988 - EMPRESA VILA MARIA', value: '6988' },
  { label: '6989 - ESCR.EXC.UBERLANDIA', value: '6989' },
  { label: '6993 - JARDIM TIJUCA-MS', value: '6993' },
  { label: '6996 - LARGO DO SOCORRO', value: '6996' },
  { label: '6997 - JARDIM CAMPO GRANDE', value: '6997' },
  { label: '6998 - EMPRESA PAULISTA', value: '6998' },
  { label: '7007 - RUA INDEPENDENCIA', value: '7007' },
  { label: '7009 - USP CAMPUS SAO PAULO', value: '7009' },
  { label: '7010 - PARQUE BAHIA-COTIA', value: '7010' },
  { label: '7013 - BADY BASSITT', value: '7013' },
  { label: '7021 - ESTACAO DA UVA', value: '7021' },
  { label: '7027 - VILA TATETUBA', value: '7027' },
  { label: '7036 - CIDADE DUTRA-S.PAULO', value: '7036' },
  { label: '7042 - EMPRESA LAPA', value: '7042' },
  { label: '7046 - AV.CAETANO BARRELLA', value: '7046' },
  { label: '7047 - ESCR.EXC.GUARULHOS', value: '7047' },
  { label: '7049 - PARIQUERA-ACU', value: '7049' },
  { label: '7052 - BOSQUE MAIA', value: '7052' },
  { label: '7057 - ESC.MPE CAMPINAS', value: '7057' },
  { label: '7061 - ESCR.EXC.MOGI SP', value: '7061' },
  { label: '7067 - VILA DAS MERCES', value: '7067' },
  { label: '7068 - ESTILO USP', value: '7068' },
  { label: '7069 - ESTILO MOOCA', value: '7069' },
  { label: '7070 - ESTILO PAULISTANA', value: '7070' },
  { label: '7071 - ESTILO N.CANTAREIRA', value: '7071' },
  { label: '7072 - ESTILO CONSOLACAO', value: '7072' },
  { label: '7073 - ESTILO SAUDE', value: '7073' },
  { label: '7074 - ESTILO LAPA', value: '7074' },
  { label: '7075 - ESTILO IPIRANGA', value: '7075' },
  { label: '7076 - ESTILO BOULEVARD', value: '7076' },
  { label: '7077 - ESTILO EMBARE', value: '7077' },
  { label: '7078 - ESTILO UNICAMP', value: '7078' },
  { label: '7079 - ESTILO S.CAETANO SUL', value: '7079' },
  { label: '7080 - ESTILO OSASCO', value: '7080' },
  { label: '7081 - ESTILO ALPHAVILLE', value: '7081' },
  { label: '7082 - ESTILO ARARAQUARA', value: '7082' },
  { label: '7083 - ESTILO TAUBATE', value: '7083' },
  { label: '7084 - ESTILO ARACATUBA', value: '7084' },
  { label: '7085 - ESTILO PRES.PRUDENTE', value: '7085' },
  { label: '7086 - ESTILO MARILIA', value: '7086' },
  { label: '7087 - ESTILO RIO CLARO', value: '7087' },
  { label: '7088 - ESTILO FRANCA', value: '7088' },
  { label: '7089 - ESTILO MOGI CRUZES', value: '7089' },
  { label: '7090 - ESTILO LIMEIRA', value: '7090' },
  { label: '7114 - AV.MASCARENHAS MORAE', value: '7114' },
  { label: '7124 - EMPRESA V. CONQUISTA', value: '7124' },
  { label: '7125 - GURUPA', value: '7125' },
  { label: '7130 - AUTAZES', value: '7130' },
  { label: '7132 - BARCELOS', value: '7132' },
  { label: '7133 - CANDEIAS DO JAMARI', value: '7133' },
  { label: '7135 - SARZEDO', value: '7135' },
  { label: '7137 - AGUA BOA', value: '7137' },
  { label: '7138 - ALTOS DA SERRA', value: '7138' },
  { label: '7139 - EMPRESA VARZEA GRAND', value: '7139' },
  { label: '7141 - RECANTO DAS EMAS', value: '7141' },
  { label: '7142 - SANTA MARIA-DF', value: '7142' },
  { label: '7144 - ESTILO OSMAR CUNHA', value: '7144' },
  { label: '7145 - ESTILO AV.GOV.RONDON', value: '7145' },
  { label: '7147 - ESTILO PC TIRADENTES', value: '7147' },
  { label: '7150 - ESTILO MINAS GERAIS', value: '7150' },
  { label: '7151 - ESTILO AV.C.COLOMBO', value: '7151' },
  { label: '7154 - EMPRESA SERTAOZINHO', value: '7154' },
  { label: '7155 - ESTILO DIAMOND', value: '7155' },
  { label: '7156 - ESTILO NILO PECANHA', value: '7156' },
  { label: '7160 - ESTILO HIGIENOPOLIS', value: '7160' },
  { label: '7163 - ESTILO PRAIA BELAS', value: '7163' },
  { label: '7164 - ESTILO VISC.URUGUAI', value: '7164' },
  { label: '7404 - ESTILO CANDELARIA', value: '7404' },
  { label: '7405 - ESTILO JACAREPAGUA', value: '7405' },
  { label: '7406 - ESTILO DIAS FERREIRA', value: '7406' },
  { label: '7408 - ESTILO MEIER', value: '7408' },
  { label: '7409 - ESTILO I.GOVERNADOR', value: '7409' },
  { label: '7411 - ESTILO PENHA', value: '7411' },
  { label: '7413 - ESTILO FLAMENGO', value: '7413' },
  { label: '7416 - ESTILO CHAMPAGNAT', value: '7416' },
  { label: '7611 - EMPRESA MANAUS', value: '7611' },
  { label: '7612 - EMPRESA F.DE SANTANA', value: '7612' },
  { label: '7613 - ESCR.EXC.M.DO CRISTO', value: '7613' },
  { label: '7615 - EMPRESA CEILANDIA', value: '7615' },
  { label: '7616 - EMPRESA BARREIRAS', value: '7616' },
  { label: '7618 - EMPRESA CASTANHAL', value: '7618' },
  { label: '7621 - AGRO DOURADOS', value: '7621' },
  { label: '7625 - EMPRESA TERESINA', value: '7625' },
  { label: '7628 - AGRO MARINGA', value: '7628' },
  { label: '7629 - EMPRESA IGAPO', value: '7629' },
  { label: '7630 - AGRO LONDRINA', value: '7630' },
  { label: '7631 - EMPRESA CID.CANCAO', value: '7631' },
  { label: '7632 -  EMPRESA CAMPOS GERAIS', value: '7632' },
  { label: '7634 - EMPRESA DUQUE CAXIAS', value: '7634' },
  { label: '7640 - AGRO SANTA MARIA', value: '7640' },
  { label: '7641 - EMPRESA SANTA MARIA', value: '7641' },
  { label: '7643 - EMPRESA CHAPECO', value: '7643' },
  { label: '7644 - EMPRESA PINHAIS', value: '7644' },
  { label: '7646 - EMPRESA ARACATUBA', value: '7646' },
  { label: '7647 - AGRO FRANCA', value: '7647' },
  { label: '7649 - AGRO ARACATUBA', value: '7649' },
  { label: '7650 - AGRO PRES.PRUDENTE', value: '7650' },
  { label: '7651 - AGRO RIBEIRAO PRETO', value: '7651' },
  { label: '7652 - EMPRESA MARILIA', value: '7652' },
  { label: '7655 - EMPRESA P.PRUDENTE', value: '7655' },
  { label: '7702 - ESCR.EST.FAROL BARRA', value: '7702' },
  { label: '7703 - ESCR.EST.IRACEMA', value: '7703' },
  { label: '7706 - ESCR.ESTILO GOIANIA', value: '7706' },
  { label: '7707 - ESCR.ESTILO SAO LUIS', value: '7707' },
  { label: '7708 - ESCR.EST.LIBERDADE', value: '7708' },
  { label: '7709 - ESCR.EST.ALTEROSA', value: '7709' },
  { label: '7710 - ESCR.ESTILO BELEM', value: '7710' },
  { label: '7711 - ESCR.EST.J.PESSOA 1', value: '7711' },
  { label: '7712 - ESCR.EST.CAPIBARIBE', value: '7712' },
  { label: '7713 - ESCR.ESTILO TERESINA', value: '7713' },
  { label: '7715 - ESCR.EST.R.JANEIRO', value: '7715' },
  { label: '7717 - ESCR.ESTILO NATAL', value: '7717' },
  { label: '7718 - ESCR.ESTILO P.ALEGRE', value: '7718' },
  { label: '7719 - ESCR.ESTILO S.JOSE', value: '7719' },
  { label: '8002 - ESTILO JUVEVE', value: '8002' },
  { label: '8003 - AGRO CASCAVEL', value: '8003' },
  { label: '8004 - ESTILO MERCES', value: '8004' },
  { label: '8005 - ESTILO PORTAO', value: '8005' },
  { label: '8006 - EMPRESA SOBRAL', value: '8006' },
  { label: '8009 - EMPRESA LAGES', value: '8009' },
  { label: '8013 - EMPRESA ALTO URUGUAI', value: '8013' },
  { label: '8016 - SANTA CRUZ DA SERRA', value: '8016' },
  { label: '8027 - LOTE XV', value: '8027' },
  { label: '8030 - ESCR.EXC.CARIOCA', value: '8030' },
  { label: '8051 - AV.UIRAPURU', value: '8051' },
  { label: '8053 - MARINGA VELHO-PR', value: '8053' },
  { label: '8054 - EMPRESA VOTUPORANGA', value: '8054' },
  { label: '8057 - EMPRESA CATANDUVA', value: '8057' },
  { label: '8058 - EMPRESA BOTUCATU', value: '8058' },
  { label: '8061 - EMPRESA IJUI', value: '8061' },
  { label: '8062 - AV.DONATO QUINTINO', value: '8062' },
  { label: '8064 - EMPRESA CABO FRIO', value: '8064' },
  { label: '8074 - AV.DA INTEGRACAO', value: '8074' },
  { label: '8075 - EMPRESA CARUARU', value: '8075' },
  { label: '8083 - EMPRESA AV.PAULISTA', value: '8083' },
  { label: '8084 - EMPRESA INDAIATUBA', value: '8084' },
  { label: '8086 - EXCR.EXC.GOIANIA', value: '8086' },
  { label: '8087 - EMPRESA ARAGUAIA', value: '8087' },
  { label: '8088 - ESTILO BUENO', value: '8088' },
  { label: '8089 - AGRO RIO VERDE', value: '8089' },
  { label: '8090 - MORADA DO SOL', value: '8090' },
  { label: '8101 - SAO JOSE-PB', value: '8101' },
  { label: '8106 - EMPRESA SINIMBU', value: '8106' },
  { label: '8109 - ESCR.EXC.P.ALEGRE', value: '8109' },
  { label: '8113 - AGRO PASSO FUNDO', value: '8113' },
  { label: '8117 - RUA LUIS VIANA', value: '8117' },
  { label: '8118 - PRESIDENTE VARGAS-BA', value: '8118' },
  { label: '8122 - EMPRESA MACAPA', value: '8122' },
  { label: '8123 - JARDIM MARCO ZERO', value: '8123' },
  { label: '8125 - AV.RIO DE JANEIRO', value: '8125' },
  { label: '8126 - EMPRESA ALTO VALE', value: '8126' },
  { label: '8163 - EMPRESA LIT.NORTE', value: '8163' },
  { label: '8179 - EMPRESA FOZ IGUACU', value: '8179' },
  { label: '8193 - EMPRESA SUMARE', value: '8193' },
  { label: '8224 - EMPRESA S.CAET. SUL', value: '8224' },
  { label: '8240 - EMPRESA ZONA NORTE', value: '8240' },
  { label: '8241 - ESCR.EXC.ALECRIM', value: '8241' },
  { label: '8245 - ESCR.EXC.FLORIPA', value: '8245' },
  { label: '8246 - EMPRESA FLORIPA', value: '8246' },
  { label: '8247 - ESCR.EXC.VILA RICA', value: '8247' },
  { label: '8248 - ESCR.EXC.MINEIRAO', value: '8248' },
  { label: '8249 - ESCR.EXC.SOROCABA', value: '8249' },
  { label: '8251 - EMPRESA SOROCABANA', value: '8251' },
  { label: '8256 - ESCR.EXC.STO AMARO', value: '8256' },
  { label: '8258 - EMPRESA ITAIM BIBI', value: '8258' },
  { label: '8260 - ESCR.EXC.PENHA', value: '8260' },
  { label: '8262 - ESCR.EXC.VILA MARIA', value: '8262' },
  { label: '8263 - ESCR.EXC.SAO PAULO', value: '8263' },
  { label: '8279 - EMPRESA TUBARAO', value: '8279' },
  { label: '8282 - EMPRESA MEIO OESTE', value: '8282' },
  { label: '8300 - EMPRESA JARAGUA SUL', value: '8300' },
  { label: '8311 - EMPRESA ITAJAI', value: '8311' },
  { label: '8315 - EMPRESA BRUSQUE', value: '8315' },
  { label: '8317 - EMPRESA B.CAMBORIU', value: '8317' },
  { label: '8319 - EMPRESA S.LEOPOLDO', value: '8319' },
  { label: '8325 - EMPRESA STA CRUZ SUL', value: '8325' },
  { label: '8326 - EMPRESA LAJEADO', value: '8326' },
  { label: '8328 - ESTILO BR.ITAPURA', value: '8328' },
  { label: '8329 - ESTILO AV.PORTUGAL', value: '8329' },
  { label: '8412 - ESTILO CENTRO', value: '8412' },
  { label: '8413 - ESTILO ACLIMACAO', value: '8413' },
  { label: '8428 - ESTILO OLHOS DAGUA', value: '8428' },
  { label: '8435 - ESTILO TAG.SHOPPING', value: '8435' },
  { label: '8441 - ESTILO AV.ANGELICA', value: '8441' },
  { label: '8450 - AVENIDA INGLATERRA', value: '8450' },
  { label: '8455 - EMPRESA CANOAS', value: '8455' },
  { label: '8458 - ESTILO CAMP.ELISEOS', value: '8458' },
  { label: '8459 - EMPRESA B.GONCALVES', value: '8459' },
  { label: '8460 - ESTILO BERRINI', value: '8460' },
  { label: '8469 - ESTILO BUTANTA', value: '8469' },
  { label: '8480 - ESTILO PINHEIROS', value: '8480' },
  { label: '8492 - ESTILO ITAIM BIBI', value: '8492' },
  { label: '8505 - EMPRESA MACAE', value: '8505' },
  { label: '8507 - ESTILO JD PAULISTANO', value: '8507' },
  { label: '8525 - ESTILO MIN.FAZENDA', value: '8525' },
  { label: '8526 - ESTILO INV. PAULISTA', value: '8526' },
  { label: '8527 - ESTILO RUA E.UNIDOS', value: '8527' },
  { label: '8528 - ESTILO FREGUESIA', value: '8528' },
  { label: '8529 - ESTILO PCA.S.ROMERO', value: '8529' },
  { label: '8530 - ESTILO PENHA FRANCA', value: '8530' },
  { label: '8533 - ESTILO CAPITAL', value: '8533' },
  { label: '8534 - ESTILO ITAQUERA', value: '8534' },
  { label: '8536 - ESTILO RUA J.TAVORA', value: '8536' },
  { label: '8547 - ESTILO INV.RIB.PRETO', value: '8547' },
  { label: '8548 - AGRO PONTA GROSSA', value: '8548' },
  { label: '8549 - RUA JOSE CLETO', value: '8549' },
  { label: '8551 - EMPRESA TOLEDO', value: '8551' },
  { label: '8561 - EMPRESA PARANAENSE', value: '8561' },
  { label: '8563 - EMPRESA PATO BRANCO', value: '8563' },
  { label: '8569 - ESCR.EXC.CURITIBA', value: '8569' },
  { label: '8570 - EMPRESA CAMPO MOURAO', value: '8570' },
  { label: '8571 - EMPRESA APUCARANA', value: '8571' },
  { label: '8573 - EMPRESA VS FRANCISCO', value: '8573' },
  { label: '8574 - ESCR.EXC.CAMPINAS', value: '8574' },
  { label: '8575 - EMPRESA J.GUARARAPES', value: '8575' },
  { label: '8602 - ESTILO PONTA VERDE', value: '8602' },
  { label: '8603 - ESTILO UFBA', value: '8603' },
  { label: '8604 - ESTILO BARRA', value: '8604' },
  { label: '8605 - ESTILO SANTOS DUMONT', value: '8605' },
  { label: '8606 - EMPRESA METROPOLE', value: '8606' },
  { label: '8608 - ESTILO TCU DF', value: '8608' },
  { label: '8610 - ESCR.EXC.ESTACAO', value: '8610' },
  { label: '8611 - ESTILO TR.SUPERIORES', value: '8611' },
  { label: '8612 - ESTILO PCA.TRIBUNAIS', value: '8612' },
  { label: '8615 - ESTILO MIN.ECONOMIA', value: '8615' },
  { label: '8617 - ESTILO AGRO GOIANIA', value: '8617' },
  { label: '8618 - ESTILO RENASCENCA', value: '8618' },
  { label: '8619 - ESTILO PAMPULHA', value: '8619' },
  { label: '8620 - ESTILO CONTAGEM', value: '8620' },
  { label: '8623 - EMPRESA MARABA', value: '8623' },
  { label: '8626 - ESTILO VALE DO ACO', value: '8626' },
  { label: '8628 - ESTILO E.DA CUNHA', value: '8628' },
  { label: '8629 - ESTILO MATO GROSSO', value: '8629' },
  { label: '8631 - ESTILO AV.E.PESSOA', value: '8631' },
  { label: '8632 - ESTILO BESSA', value: '8632' },
  { label: '8633 - ESTILO PARNAMIRIM', value: '8633' },
  { label: '8634 - ESTILO RECIFE ANTIGO', value: '8634' },
  { label: '8636 - ESTILO MOSSORO', value: '8636' },
  { label: '8637 - ESTILO PONTA NEGRA', value: '8637' },
  { label: '8638 - ESTILO VALE SINOS', value: '8638' },
  { label: '8639 - ESTILO PASSO FUNDO', value: '8639' },
  { label: '8641 - ESTILO SANTA MONICA', value: '8641' },
  { label: '8642 - ESTILO CASTEJON', value: '8642' },
  { label: '8644 - ESTILO SOROCABANA', value: '8644' },
  { label: '8670 - EMPRESA UBERABA', value: '8670' },
  { label: '8672 - EMPRESA POUSO ALEGRE', value: '8672' },
  { label: '8675 - EMPRESA POCOS CALDAS', value: '8675' },
  { label: '8681 - EMPRESA PATOS MINAS', value: '8681' },
  { label: '8684 - EMPRESA G.VALADARES', value: '8684' },
  { label: '8685 - EMPRESA RIO VERDE', value: '8685' },
  { label: '8687 - EMPRESA PTE.DE FERRO', value: '8687' },
  { label: '8689 - LUVERDENSE', value: '8689' },
  { label: '8695 - EMPRESA ITUMBIARA', value: '8695' },
  { label: '8697 - ROD.AUG.MONTENEGRO', value: '8697' },
  { label: '8702 - EMPRESA SERRA', value: '8702' },
  { label: '8706 - PRIVATE NORDESTE', value: '8706' },
  { label: '8707 - PRIVATE CAMPINAS', value: '8707' },
  { label: '8708 - PRIVATE BRASILIA', value: '8708' },
  { label: '8728 - ESCR.ESTILO PARANA', value: '8728' },
  { label: '8755 - EMPRESA C.ITAPEMIRIM', value: '8755' },
  { label: '8756 - EMPRESA J. DO NORTE', value: '8756' },
  { label: '8971 - PRIVATE RIB.PRETO', value: '8971' },
  { label: '8972 - PRIVATE CURITIBA', value: '8972' },
  { label: '8973 - PRIVATE RECIFE', value: '8973' },
  { label: '8974 - PRIVATE GOIANIA', value: '8974' },
  { label: '9075 - AGRO CAMPO MOURAO', value: '9075' },
  { label: '9076 - AGRO UBERLANDIA', value: '9076' },
  { label: '9102 - ESCR.EXC.RIO BRANCO', value: '9102' },
  { label: '9103 - ESCR.EXC.MACEIO', value: '9103' },
  { label: '9104 - ESCR.EXC.MANAUS', value: '9104' },
  { label: '9105 - ESCR.EXC.MACAPA', value: '9105' },
  { label: '9106 - ESCR.EXC.F.SANTANA', value: '9106' },
  { label: '9107 - ESCR.EXC.E.LACERDA', value: '9107' },
  { label: '9108 - ESCR.EXC.F.DE ITAPUA', value: '9108' },
  { label: '9109 - ESCR.EXC.M.MODELO', value: '9109' },
  { label: '9110 - ESCR.EXC.TERRA LUZ', value: '9110' },
  { label: '9111 - ESCR.EXC.DRAGAO MAR', value: '9111' },
  { label: '9112 - ESCR.EXC.ESPLANADA', value: '9112' },
  { label: '9113 - ESCR.EXC.MONUMENTAL', value: '9113' },
  { label: '9115 - ESCR.EXC.ANAPOLIS', value: '9115' },
  { label: '9116 - ESCR.EXC.GOIAS', value: '9116' },
  { label: '9117 - ESCR.EXC.SAO LUIS 2', value: '9117' },
  { label: '9119 - ESCR.EXC.JK', value: '9119' },
  { label: '9120 - ESCR.EXC.SAVASSI', value: '9120' },
  { label: '9121 - ESCR.EXC.S.DUMONT MG', value: '9121' },
  { label: '9122 - EMPRESA ITU', value: '9122' },
  { label: '9123 - ESCR.EXC.DIVINOPOLIS', value: '9123' },
  { label: '9125 - ESCR.EXC.IPATINGA', value: '9125' },
  { label: '9126 - ESCR.EXC.M.CLAROS', value: '9126' },
  { label: '9127 - ESCR.EXC.PANTANAL', value: '9127' },
  { label: '9128 - ESCR.EXC.DOURADOS', value: '9128' },
  { label: '9129 - ESCR.EXC.CID.VERDE', value: '9129' },
  { label: '9131 - ESCR.EXC.C.GRANDE-PB', value: '9131' },
  { label: '9133 - EMPRESA UBA', value: '9133' },
  { label: '9134 - ESCR.EXC.AV.R.BRANCO', value: '9134' },
  { label: '9135 - ESCR.EXC.CAIS APOLO', value: '9135' },
  { label: '9136 - ESCR.EXC.TERESINA', value: '9136' },
  { label: '9137 - ESCR.EXC.CAJUINA', value: '9137' },
  { label: '9138 - ESCR.EXC.PARANA', value: '9138' },
  { label: '9139 - ESCR.EXC.LONDRINA', value: '9139' },
  { label: '9140 - ESCR.EXC.MARINGA', value: '9140' },
  { label: '9141 - ESCR.EXC.PTA.GROSSA', value: '9141' },
  { label: '9142 - ESCR.EX.N.FLUMINENSE', value: '9142' },
  { label: '9143 - EXCLUSIVO D CAXIAS', value: '9143' },
  { label: '9144 - EXCLUSIVO NITEROI 2', value: '9144' },
  { label: '9151 - ESCR.EXC.V.REDONDA', value: '9151' },
  { label: '9152 - ESCR.EXC.MOSSORO', value: '9152' },
  { label: '9153 - ESCR.EXC.RIBEIRA', value: '9153' },
  { label: '9155 - ESCR.EXC.PORTO VELHO', value: '9155' },
  { label: '9156 - ESCR.EXC.BOA VISTA', value: '9156' },
  { label: '9157 - ESCR.EXC.N.HAMBURGO', value: '9157' },
  { label: '9158 - ESCR.EXC.PAMPA SUL', value: '9158' },
  { label: '9159 - ESCR.EXC.P.ALEGRE 2', value: '9159' },
  { label: '9160 - ESCR.EXC.P.ALEGRE 3', value: '9160' },
  { label: '9161 - AGRO IJUI', value: '9161' },
  { label: '9162 - ESCR.EXC.SANTA MARIA', value: '9162' },
  { label: '9164 - ESCR.EXC.BLUMENAU', value: '9164' },
  { label: '9165 - ESCR.EXC.CHAPECO', value: '9165' },
  { label: '9166 - ESCR.EXC.CRICIUMA', value: '9166' },
  { label: '9167 - ESCR.EXC.SAO JOSE', value: '9167' },
  { label: '9169 - ESCR.EXC.ARACAJU', value: '9169' },
  { label: '9170 - ESCR.EXC.AMERICANA', value: '9170' },
  { label: '9171 - ESCR.EXC.ARACATUBA', value: '9171' },
  { label: '9172 - ESCR.EXC.ARARAQUARA', value: '9172' },
  { label: '9174 - ESCR.EXC.BAURU', value: '9174' },
  { label: '9176 - ESCR.EXC.DR.QUIRINO', value: '9176' },
  { label: '9177 - ESCR.EXC.FRANCA', value: '9177' },
  { label: '9180 - ESCR.EXC.JUNDIAI', value: '9180' },
  { label: '9181 - ESCR.EXC.LIMEIRA', value: '9181' },
  { label: '9182 - ESCR.EXC.MARILIA', value: '9182' },
  { label: '9183 - ESCR.EXC.ALTO TIETE', value: '9183' },
  { label: '9184 - ESCR.EXC.OSASCO', value: '9184' },
  { label: '9185 - ESCR.EXC.BARUERI', value: '9185' },
  { label: '9186 - ESCR.EXC.PIRACICABA', value: '9186' },
  { label: '9187 - ESCR.EXC.P.PRUDENTE', value: '9187' },
  { label: '9189 - ESCR.EXC.S.B.CAMPO', value: '9189' },
  { label: '9190 - ESCR.EXC.RUDGE RAMOS', value: '9190' },
  { label: '9191 - ESCR.EXC.BAIXADA', value: '9191' },
  { label: '9192 - ESCR.EXC.SANTOS', value: '9192' },
  { label: '9193 - ESCR.EXC.SAO CARLOS', value: '9193' },
  { label: '9194 - ESCR.EXC.VALE', value: '9194' },
  { label: '9197 - ESCR.EXC.GOVERNO SP1', value: '9197' },
  { label: '9198 - ESCR.EXC.GOVERNO SP2', value: '9198' },
  { label: '9199 - ESCR.EXC.PAULISTA', value: '9199' },
  { label: '9201 - ESCR.EXC.CAPITAL', value: '9201' },
  { label: '9202 - ESCR.EXC.CTO EMPRES', value: '9202' },
  { label: '9203 - ESCR.EXC.PAULISTANO', value: '9203' },
  { label: '9204 - ESCR.EXC.PREF.SP1', value: '9204' },
  { label: '9205 - ESCR.EXC.PREF.SP2', value: '9205' },
  { label: '9206 - ESCR.EXC.PALMAS', value: '9206' },
  { label: '9301 - PRIVATE SP PAULISTA', value: '9301' },
  { label: '9302 - PRIVATE SP CAPITAL', value: '9302' },
  { label: '9303 - PRIVATE SP OESTE', value: '9303' },
  { label: '9304 - PRIVATE RJ CAPITAL', value: '9304' },
  { label: '9305 - PRIVATE ESPÍRITO SANTO', value: '9305' },
  { label: '9306 - PRIVATE MINAS GERAIS', value: '9306' },
  { label: '9307 - PRIVATE SORRISO', value: '9307' },
  { label: '9308 - PRIVATE RONDONOPOLIS', value: '9308' },
  { label: '9309 - PRIVATE MATO GROSSO DO SUL', value: '9309' },
  { label: '9310 - PRIVATE NORTE', value: '9310' },
  { label: '9311 - ESCRITÓRIO PRIVATE NORTE NORDESTE', value: '9311' },
  { label: '9312 - PRIVATE SANTA CATARINA', value: '9312' },
  { label: '9313 - PRIVATE PARANÁ', value: '9313' },
  { label: '9314 - PRIVATE RIO GRANDE DO SUL', value: '9314' },
  { label: '9315 - ESCRITÓRIO WEALTH MANAGEMENT', value: '9315' },
  { label: '9792 - EMPRESA VILA VELHA', value: '9792' },
  { label: '9794 - EMPRESA TAUBATE', value: '9794' },
  { label: '9796 - EMPRESA OSASCO', value: '9796' },
  { label: '9894 - EMPRESA BARUERI', value: '9894' },
  { label: '9895 - EMPRESA JUNDIAI', value: '9895' },
  { label: '9925 - ESCR.EXC.VILA GALVAO', value: '9925' },
  { label: '9934 - EMPRESA MOGI CRUZES', value: '9934' },
  { label: '9945 - EMPRESA PETROPOLIS', value: '9945' },
  { label: '9964 - EMPRESA DIVINOPOLIS', value: '9964' },
  { label: '9965 - ESCR.EXC.BONFIM', value: '9965' },
  { label: '9966 - ESCR.EXC.PAO ACUCAR', value: '9966' },
  { label: '9970 - ESCR.EXC.PRACA XV', value: '9970' },
  { label: '9975 - ESCR.EXC.S.PAULO 21', value: '9975' },
  { label: '9976 - ESCR.EXC.CENTRO', value: '9976' },
  { label: '9986 - ESCR.EST.INVESTIDOR', value: '9986' },
]
